<template>
  <div>
    <div id="tabMembers">
      <div class="mx-28 my-32">
        <div>
          <div
            v-if="
              Object.keys(this.checked).filter((k) => this.checked[k] === true)
                .length == 0
            "
            class="flex-row-center height-bind"
          >
            <div class="flex-center fs-24 fc-000000">
              <span class="fw-900">
                {{
                  results.length > 0
                    ? $utils("addCommasInNumber", results.length)
                    : 0
                }}
              </span>
              <span class="fw-700">&nbsp;{{ $t("members.Members") }}</span>
              <span
                v-if="
                  incomplete.length > 1 ||
                  (incomplete.length == 1 &&
                    incomplete[0].user_type !== 'superleader' &&
                    incomplete[0].user_type !== 'superadmin' &&
                    incomplete[0].user_type !== 'leadership' &&
                    (incomplete[0].boss == '' || incomplete[0].team == ''))
                "
                class="fs-14 fw-400 fc-F44336 ml-12"
              >
                <span class="fs-14 fw-400 fc-F44336 ml-12"
                  >⚠️
                  {{
                    Object.keys(incomplete).filter(
                      (k) =>
                        incomplete[k].boss === "" &&
                        (incomplete[k].user_type === "superleader" ||
                          incomplete[k].user_type === "superadmin" ||
                          incomplete[k].user_type === "leadership")
                    ).length == 1
                      ? incomplete.length - 1
                      : incomplete.length
                  }}
                  {{ $t("members.incomplete_profiles") }}</span
                >
              </span>
            </div>

            <div
              style="
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: flex-end;
              "
            >
              <span class="text-archived">
                <span
                  @click="archivedModalClick"
                >
                  {{ $t("members.Archived") }}
                  <span v-if="archivedSchedule > 0">
                    {{ `(${archivedSchedule} Scheduled)` }}
                  </span>
                </span>
              </span>
              <div style="margin-right: 12px">
                <el-button
                  class="btnAddMember"
                  size="small"
                  icon="el-icon-plus"
                  @click="addMember"
                  >{{ $t("members.ADD_MEMBER") }}</el-button
                >
              </div>
              <div style="margin-right: 12px">
                <el-button
                  class="btnExportAll"
                  size="small"
                  icon="el-icon-upload2"
                  @click="importMembers"
                >
                  IMPORT MEMBERS
                </el-button>
              </div>


              <!-- TODO: mouseenter, mouseleve -->
              <!-- <div class="dropdown-container" style="margin-right: 12px">
                <el-button
                  class="btnAddMember"
                  size="small"
                  @click="showMenu = !showMenu"
                >
                  {{ $t("members.ADD_MEMBER") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-menu
                  v-show="showMenu"
                  default-active="1"
                  class="dropdown-menu el-menu--popup"
                  mode="horizontal"
                  @select="handleSelect"
                  @mouseenter="showMenu = true"
                  @mouseleave="handleMouseLeave"
                >
                  <el-menu-item index="import_members">Import Members</el-menu-item>
                  <el-menu-item index="add_member">Add a Single Member</el-menu-item>
                </el-menu>
              </div> -->


              <el-badge
                v-if="reviewUpdatesTotal"
                :value="reviewUpdatesTotal" :max="99" class="happily-primary el-badge-unread">
                <el-button
                    class="btnExportAll"
                    size="small"
                    @click="clickReviewUpdates"
                    >{{ $t("members.REVIEW_UPDATES") }}</el-button
                  >
              </el-badge>
              <el-button v-else
                    class="btnExportAll"
                    size="small"
                    >{{ $t("members.REVIEW_UPDATES") }}</el-button
                  >
              <el-dropdown @command="handleExportCommand" style="margin-left: 12px">
                <el-button size="small" class="btnExportAll">
                  EXPORT <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="member-data">
                    <i class="el-icon-download"></i> Member Data (CSV)
                  </el-dropdown-item>
                  <el-dropdown-item command="context-data">
                    <i class="el-icon-data-analysis"></i> Personal Context (AI)
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- Hidden download-csv component for Excel export -->
              <download-csv 
                ref="csvExport" 
                :data="dataexport" 
                :name="exportFileName"
                style="display: none;">
                <el-button ref="hiddenCsvButton" style="display: none;"></el-button>
              </download-csv>
              <download-progress :active="showSnackbar"></download-progress>
            </div>
          </div>

          <div
            v-else
            class="flex-row-center height-bind selectionmenu"
            style="background-color: #6c30cc; margin: -10px -40px 0"
          >
            <span class="fs-18 fc-FFFFFF fw-700 ml-40"
              >{{
                $utils(
                  "addCommasInNumber",
                  Object.keys(this.checked).filter(
                    (k) => this.checked[k] === true
                  ).length
                )
              }}
              {{ $t("members.members_selected") }}</span
            >
            <div style="margin-left: 24px; display: flex">
              <div v-for="(item, index) in this.checkedData" :key="index">
                <div v-if="index < 3" style="height: 32px">
                  <img
                    v-if="item.pic"
                    :src="item.pic"
                    class="viewMember image-skeleton image-profile-30"
                    :class="[ blurMode ?  'blurelement': '' ]"
                    v-bind:style="renderSelectedPic(index)"
                  />
                  <div
                    v-else
                    class="viewMember image image-profile-30"
                    :class="[ blurMode ?  'blurelement': '' ]"
                    v-bind:style="renderSelectedPic(index)"
                  >
                    <div class="text-in-image text-in-image-32 flex-mid">
                      {{
                        $utils("acronymName", {
                          firstName: item.firstname,
                          lastName: item.lastname,
                        })
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <span
              v-if="this.checkedData.length > 3"
              class="fs-14 fc-FFFFFF"
              style="margin-left: -10px"
              >+{{
                this.checkedData && this.checkedData.length > 3
                  ? this.checkedData.length - 3
                  : ""
              }}</span
            >

            <div class="divActionHeader">
              <div
                @click.prevent="
                  assignManagerModalStatus = !assignManagerModalStatus
                "
                @click="assignManagerModalClick"
                class="btn btn-navbar bg-hover-barken-54279B"
              >
                {{ $t("members.RE_ASSIGN_MANAGER") }}
              </div>
              <div
                @click.prevent="assignTeamModalStatus = !assignTeamModalStatus"
                @click="assignTeamModalClick"
                class="btn btn-navbar bg-hover-barken-54279B"
              >
                {{ $t("members.EDIT_TEAM") }}
              </div>
              <div
                @click="archiveArrMemberClick"
                class="btn btn-navbar bg-hover-barken-54279B"
              >
                {{ $t("members.ARCHIVE") }}
              </div>
              <div
                @click="inviteArrMember"
                class="btn btn-navbar bg-hover-barken-54279B"
              >
                {{ $t("members.SEND_INVITE") }}
              </div>
            </div>
          </div>

          <div class="flex-row-between mt-14">
            <el-input
              class="input-style"
              style="height: 40px"
              autosize
              :placeholder="$t('members.Search')"
              v-model="inputSearch"
              clearable
            ></el-input>

            <div style="width: 220px">
              <el-menu class="input-select" mode="horizontal">
                <el-submenu index="0" style="width: 220px">
                  <template slot="title">
                    <span class="text-dropdown" id="userStatus"
                      >{{ $t("members.All") }}
                      {{
                        datamembers["membersall"]
                          ? "(" + datamembers["membersall"].length + ")"
                          : ""
                      }}</span
                    >
                  </template>
                  <!--<el-menu-item index="1" style="font-size: 14px;width: 220px;">&nbsp;All (162)</el-menu-item> -->
                  <el-menu-item
                    @click="statusClick('new')"
                    index="1"
                    style="font-size: 14px; width: 220px"
                    >{{ $t("members.New") }}
                    {{
                      this.datamembers["membersnew"]
                        ? "(" + this.datamembers["membersnew"].length + ")"
                        : ""
                    }}</el-menu-item
                  >
                  <el-menu-item
                    @click="statusClick('invited')"
                    index="2"
                    style="font-size: 14px; width: 220px"
                    >{{ $t("members.Invited") }}
                    {{
                      this.datamembers["membersinvited"]
                        ? "(" + this.datamembers["membersinvited"].length + ")"
                        : ""
                    }}</el-menu-item
                  >
                  <el-menu-item
                    @click="statusClick('active')"
                    index="3"
                    style="font-size: 14px; width: 220px"
                    >{{ $t("members.Active") }}
                    {{
                      this.datamembers["membersact"]
                        ? "(" + this.datamembers["membersact"].length + ")"
                        : ""
                    }}</el-menu-item
                  >
                  <el-menu-item
                    @click="statusClick('inactive')"
                    index="4"
                    style="font-size: 14px; width: 220px"
                    >Inactive
                    {{
                      this.datamembers["membersinact"]
                        ? "(" + this.datamembers["membersinact"].length + ")"
                        : ""
                    }}</el-menu-item
                  >
                  <el-menu-item
                    @click="statusClick('all')"
                    index="5"
                    style="font-size: 14px; width: 220px"
                    >{{ $t("members.All") }}
                    {{
                      datamembers["membersall"]
                        ? "(" + datamembers["membersall"].length + ")"
                        : ""
                    }}</el-menu-item
                  >
                </el-submenu>
              </el-menu>
            </div>
          </div>
          <div class="mt-20" style="position: relative">
            <el-table
              ref="multipleTable"
              :data="members"
              style="width: 100%"
              @sort-change="sort"
              @row-click="rowClickEdit"
              :row-style="tableRowStyle"
              :empty-text="
                loadingMemberTable
                  ? ' '
                  : !loadingMemberTable && inputSearch === ''
                  ? 'No members'
                  : 'No results found...'
              "
            >
              <el-table-column
                :render-header="renderOptionSelect"
                column-key="memberCheckbox"
                width="51"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    style="
                      display: inline-block;
                      float: right;
                      margin-right: 6px;
                    "
                    v-model="checked['key_' + scope.row.key]"
                    :key="scope.row.key"
                    @change="membersChecked(scope.row.key)"
                  />
                </template>
              </el-table-column>

              <el-table-column width="42">
                <template slot-scope="scope">
                  <div class="absolute-mid">
                    <img
                      v-if="scope.row.pic"
                      v-lazy="scope.row.pic"
                      :key="scope.row.pic"
                      class="image-skeleton image-profile-42 flex-mid mx-10"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <div v-else class="image image-profile-42 flex-mid"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <div class="text-in-image text-in-image-42 flex-mid">
                        {{
                          $utils("acronymName", {
                            firstName: scope.row.firstname,
                            lastName: scope.row.lastname,
                          })
                        }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                prop="name"
                sortable="custom"
                :label="$t('members.Member')"
                width="175"
              >
                <template slot-scope="scope">
                  <div class="flex-column">
                    <span 
                    :class="[ blurMode ?  'blurelement': '', 'text-name' ]"

                      >{{ scope.row.firstname }} {{ scope.row.lastname }}</span
                    >
                    <span
                    :class="[ blurMode ?  'blurelement': '', 'text-email' ]"
                    >{{ scope.row.email }}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                prop="team_name"
                sortable="custom"
                property="team"
                :label="$t('members.Team')"
                width="170"
              >
                <template slot-scope="scope">
                  <!-- Inline Edit Popover -->
                  <el-popover
                    :ref="'teamPopover_' + scope.row.key"
                    placement="bottom-start"
                    width="320"
                    trigger="manual"
                    :value="editingTeamMemberKey === scope.row.key"
                    popper-class="inline-team-popover"
                    @show="onTeamPopoverShow"
                  >
                    <div class="inline-team-popover-content" @click.stop>
                      <div class="inline-team-popover-header">
                        <span class="inline-team-popover-title">{{ $t('members.Edit_Team') }}</span>
                        <div class="inline-team-popover-actions">
                          <button 
                            class="inline-team-action-btn inline-team-confirm-btn"
                            @click.stop="confirmInlineTeamEdit(scope.row)"
                            :disabled="!inlineTeamValue || !!inlineTeamValidationMsg"
                            :title="$t('global.Confirm')"
                          >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M13.5 4.5L6.5 11.5L3 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </button>
                          <button 
                            class="inline-team-action-btn inline-team-cancel-btn"
                            @click.stop="cancelInlineTeamEdit"
                            :title="$t('global.Cancel')"
                          >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                      <el-autocomplete
                        ref="inlineTeamAutocomplete"
                        class="inline-team-autocomplete-popover"
                        v-model="inlineTeamValue"
                        :fetch-suggestions="querySearchTeam"
                        :placeholder="$t('members.Select_a_Team')"
                        @select="handleInlineTeamSelect($event, scope.row)"
                        @input="handleInlineTeamInput"
                        @keyup.escape.native="cancelInlineTeamEdit"
                        @keyup.enter.native="confirmInlineTeamEdit(scope.row)"
                        :class="[ blurMode ? 'blurelement': '' ]"
                      >
                        <template slot-scope="{ item }">
                          <div class="inline-team-suggestion-item" :class="[ blurMode ? 'blurelement': '' ]">
                            <span 
                              class="inline-team-color-dot" 
                              :style="{ backgroundColor: item.color || '#9E9E9E' }"
                            ></span>
                            {{ item.name }}
                          </div>
                        </template>
                      </el-autocomplete>
                      <div v-if="inlineTeamValue && isNewTeam(inlineTeamValue)" class="inline-team-new-hint">
                        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 4px; vertical-align: middle;">
                          <path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                        "{{ inlineTeamValue }}" {{ $t("members.will_be_created_as_a") }}
                      </div>
                      <div v-if="inlineTeamValidationMsg" class="inline-team-validation">
                        {{ inlineTeamValidationMsg }}
                      </div>
                    </div>
                    <!-- Trigger Element -->
                    <span 
                      slot="reference"
                      v-if="scope.row.team_name"
                      class="inline-team-clickable"
                      :class="[ blurMode ? 'blurelement': '' ]"
                      @click.stop="startInlineTeamEdit(scope.row)"
                    >{{ scope.row.team_name }}</span>
                    <span 
                      slot="reference"
                      v-else 
                      class="fc-32C2D5 fs-14 inline-team-clickable"
                      @click.stop="startInlineTeamEdit(scope.row)"
                    >{{ $t("members.Assign_Team") }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="boss_name"
                sortable="custom"
                property="manager"
                :label="$t('members.Manager')"
                width="130"
              >
                <template slot-scope="scope">
                  <!-- Top Most Manager (no editing needed) -->
                  <span
                    v-if="
                      Object.keys(incomplete).filter(
                        (k) =>
                          incomplete[k].boss === '' &&
                          (incomplete[k].user_type === 'superleader' ||
                            incomplete[k].user_type === 'superadmin' ||
                            incomplete[k].user_type === 'leadership')
                      ).length == 1 &&
                      !scope.row.boss &&
                      (scope.row.user_type == 'superleader' ||
                        scope.row.user_type == 'superadmin' ||
                        scope.row.user_type == 'leadership')
                    "
                    class="fc-9D9D9D"
                    >*{{ $t("members.Top_Most") }}</span
                  >
                  <!-- Inline Edit Popover for Manager -->
                  <el-popover
                    v-else
                    :ref="'managerPopover_' + scope.row.key"
                    placement="bottom-start"
                    width="320"
                    trigger="manual"
                    :value="editingManagerMemberKey === scope.row.key"
                    popper-class="inline-team-popover"
                    @show="onManagerPopoverShow"
                  >
                    <div class="inline-team-popover-content" @click.stop>
                      <div class="inline-team-popover-header">
                        <span class="inline-team-popover-title">{{ $t('members.Edit_Manager') }}</span>
                        <div class="inline-team-popover-actions">
                          <button 
                            class="inline-team-action-btn inline-team-confirm-btn"
                            @click.stop="confirmInlineManagerEdit(scope.row)"
                            :disabled="!inlineManagerData.email || !!inlineManagerValidationMsg"
                            :title="$t('global.Confirm')"
                          >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M13.5 4.5L6.5 11.5L3 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </button>
                          <button 
                            class="inline-team-action-btn inline-team-cancel-btn"
                            @click.stop="cancelInlineManagerEdit"
                            :title="$t('global.Cancel')"
                          >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                      <el-autocomplete
                        ref="inlineManagerAutocomplete"
                        class="inline-team-autocomplete-popover"
                        v-model="inlineManagerValue"
                        :fetch-suggestions="querySearchInlineManager"
                        :placeholder="$t('members.Search_manager_name')"
                        @select="handleInlineManagerSelect($event, scope.row)"
                        @input="handleInlineManagerInput"
                        @keyup.escape.native="cancelInlineManagerEdit"
                        @keyup.enter.native="confirmInlineManagerEdit(scope.row)"
                        :class="[ blurMode ? 'blurelement': '' ]"
                      >
                        <template slot-scope="{ item }">
                          <div class="inline-manager-suggestion-item" :class="[ blurMode ? 'blurelement': '' ]">
                            <img
                              v-if="item.pic"
                              :src="item.pic"
                              class="inline-manager-avatar"
                            />
                            <div v-else class="inline-manager-avatar-placeholder">
                              {{ $utils("acronymName", { firstName: item.firstname, lastName: item.lastname }) }}
                            </div>
                            <div class="inline-manager-info">
                              <div class="inline-manager-name">{{ item.firstname }} {{ item.lastname }}</div>
                              <div class="inline-manager-team">{{ item.team_name }}</div>
                            </div>
                          </div>
                        </template>
                      </el-autocomplete>
                      <div v-if="inlineManagerValidationMsg" class="inline-team-validation">
                        {{ inlineManagerValidationMsg }}
                      </div>
                    </div>
                    <!-- Trigger Element -->
                    <span 
                      slot="reference"
                      v-if="scope.row.boss_shortname"
                      class="inline-team-clickable"
                      :class="[ blurMode ? 'blurelement': '' ]"
                      @click.stop="startInlineManagerEdit(scope.row)"
                    >{{ scope.row.boss_shortname }}</span>
                    <span 
                      slot="reference"
                      v-else 
                      class="fc-32C2D5 fs-14 inline-team-clickable"
                      @click.stop="startInlineManagerEdit(scope.row)"
                    >{{ $t("members.Assign_Manager") }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="coin"
                sortable="custom"
                property="coins"
                :label="$t('members.Coins')"
                width="80"
              >
                <template slot-scope="scope">
                  <div class="center mr-8">
                    {{ $utils("addCommasInNumber", scope.row.coin) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="gem"
                sortable="custom"
                property="gems"
                :label="$t('members.Gems')"
                width="80"
              >
                <template slot-scope="scope">
                  <div class="center mr-8">
                    {{ $utils("addCommasInNumber", scope.row.gem) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="user_type"
                sortable="custom"
                property="permission"
                :label="$t('members.Permission')"
                width="115"
              >
                <template slot-scope="scope">
                  <div>{{ OptuserType[scope.row.user_type] }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="most_recent_activity"
                sortable="custom"
                property="most_recent_activity"
                :label="$t('members.Status')"
                align="right"
                width="90"
              >
                <template slot-scope="scope">
                  <div class="div-active">
                    <div
                      class="btn-status"
                      :class="[`status-${scope.row.status}`]"
                    >
                      {{ scope.row.status }}
                    </div>
                    <div class="active">{{ scope.row.to_now }}</div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div
              v-if="loadingMemberTable"
              class="center"
              style="position: absolute; top: 0; left: 0; right: 0; z-index: 99; padding-top: 60px"
            >
              <div
                v-for="value in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                :key="'mock_data_on_loading_' + value"
                class="flex-center loading-member-table opa-06"
                :style="`height: 64px; animation-duration: ${value * 1.5 + 1}s`"
              >
                <div class="flex-mid opa-04" style="width: 51px">
                  <el-checkbox
                    style="
                      display: inline-block;
                      float: right;
                      margin-right: 6px;
                    "
                  />
                </div>
                <div class="flex-mid">
                  <div class="image-skeleton image-profile-42 opa-06"></div>
                </div>
                <div class="pl-10" style="width: 174px">
                  <div class="text-skeleton fs-14" style="width: 130px">
                    &nbsp;
                  </div>
                  <div
                    class="text-skeleton fs-14 opa-06 mt-6"
                    style="width: 120px"
                  >
                    &nbsp;
                  </div>
                </div>
                <div class="flex-center" style="width: 160px">
                  <div class="text-skeleton fs-14 ml-10" style="width: 100px">
                    &nbsp;
                  </div>
                </div>
                <div class="flex-center" style="width: 120px">
                  <div class="text-skeleton fs-14 ml-10" style="width: 100px">
                    &nbsp;
                  </div>
                </div>
                <div class="flex-mid" style="width: 80px">
                  <div class="text-skeleton fs-14 mr-14" style="width: 20px">
                    &nbsp;
                  </div>
                </div>
                <div class="flex-mid" style="width: 80px">
                  <div class="text-skeleton fs-14 mr-14" style="width: 20px">
                    &nbsp;
                  </div>
                </div>
                <div class="flex-mid" style="width: 125px">
                  <div class="text-skeleton fs-14" style="width: 60px">
                    &nbsp;
                  </div>
                </div>
                <div class="flex-mid" style="width: 90px">
                  <div class="div-active">
                    <div class="btn-status opa-06" style="padding-top: 0">
                      &nbsp;
                    </div>
                    <div
                      class="text-skeleton fs-8 mt-3 mx-auto"
                      style="width: 50px"
                    >
                      &nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-center pagination mt-10">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="10"
            :pager-count="5"
            layout="prev, pager, next"
            :total="results.length"
          ></el-pagination>
          <span class="results-status">
            {{ members.length > 10 ? 10 : members.length }}
            {{ $t("members.results_from") }}
            {{ $utils("addCommasInNumber", results.length) }}
            {{ $t("members.results") }}
          </span>
        </div>
      </div>
      <el-dialog
        :visible.sync="dialogFormVisible"
        top="8vh"
        @close="cancelDialog"
      >
        <el-form :model="validateForm" ref="validateForm">
          <el-col
            :span="13"
            class="thin-scrollbar"
            style="height: 84vh; min-height: 847px; max-height: 1200px"
            v-if="dialogFormVisible"
          >
            <member
              :userDetail="validateForm"
              :orgChartData="modalMemberData['org']"
              :powerData="powerData"
              :modalMemberData="modalMemberData"
            ></member>
          </el-col>
          <el-col :span="11" class="second-column profileform thin-scrollbar">
            <div
              id="modal_profile"
              class="px-40 pb-40"
              style="padding-top: 60px"
            >
              <div
                v-if="
                  directReportsData.total == 0 ||
                  directReportsData.total == undefined
                "
              >
                <div v-if="switchToArchive" class="mt-24 word-break">
                  <div>
                    <span class="fw-700 fs-19 fc-2D2E36">{{
                      $t("members.Are_you_sure_would")
                    }}</span>
                  </div>
                  <div class="pt-20">
                    <span class="fs-16 fc-2D2E36">{{
                      $t("members.Once_archived_the_member")
                    }}</span>
                  </div>
                  <div class="pt-20">
                    <span class="fs-16 fc-2D2E36">{{
                      $t("members.Archived_members_can_be")
                    }}</span>
                  </div>
                  <div class="fs-16 fw-600 mt-24">Archive Schedule</div>
                  <div class="relative mt-8">
                    <el-date-picker
                      v-model="dateAcchivePicker"
                      value-format="yyyy-MM-dd HH:mm"
                      type="datetime"
                      :picker-options="pickerOptions"
                      @change="checkNowPicker"
                      placeholder=""
                      style="width: 100%"
                      :format="`MMMM d hh:mm A`"
                      default-time="23:59:00"
                      :editable="false"
                      popper-class="hide-btn-picker-time"
                    >
                    </el-date-picker>
                    <div
                      v-if="!dateAcchivePicker"
                      class="absolute-mid fs-18 events-none"
                      style="left: 54px"
                    >
                      Now
                    </div>
                  </div>
                  <el-col :span="24" class="flex-center mt-40">
                    <el-button
                      class="btnCancelArchiveModal btn-gray"
                      type="primary"
                      @click="switchToArchive = !switchToArchive"
                      >{{ $t("members.CANCEL") }}</el-button
                    >
                    <el-dropdown @command="archiveMemberType" class="ml-18">
                      <div @click="handleArchiveButtonClick" class="btn btn-archive">
                        ARCHIVE
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="Resigned">Resigned</el-dropdown-item>
                        <el-dropdown-item command="Terminated"
                          >Terminated</el-dropdown-item
                        >
                        <el-dropdown-item command="Other">Other</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </el-col>
                </div>
                <div v-else class="mt-24">
                  <el-col :span="11">
                    <p class="txtHeaderStyle">{{ $t("members.First_Name") }}</p>
                    <el-input
                      v-model="validateForm.firstname"
                      auto-complete="off"
                      :placeholder="$t('members.First_Name')"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    ></el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="12">
                    <p class="txtHeaderStyle">{{ $t("members.Last_Name") }}</p>
                    <el-input
                      v-model="validateForm.lastname"
                      auto-complete="off"
                      :placeholder="$t('members.Last_Name')"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    ></el-input>
                  </el-col>
                  <el-col :span="24" style="padding-top: 12px">
                    <p class="txtHeaderStyle">Nickname</p>
                    <el-input
                      v-model="validateForm.nickname"
                      auto-complete="off"
                      placeholder="Nickname (optional)"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    ></el-input>
                  </el-col>
                  <el-col :span="24" style="padding-top: 12px">
                    <p class="txtHeaderStyle">{{ $t("members.Email") }}</p>
                    <el-input
                      :disabled="this.mode ? true : false"
                      v-model="validateForm.email"
                      auto-complete="off"
                      placeholder="name@company.com"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    ></el-input>
                  </el-col>
                  <el-col :span="24" style="padding-top: 32px">
                    <p class="txtHeaderStyle">{{ $t("members.Manager") }}</p>
                    <el-autocomplete
                      class="inline-input managerfield"
                      v-model="validateForm.dispboss"
                      :fetch-suggestions="querySearchManager"
                      :placeholder="$t('members.Select_a_Manager')"
                      @select="handleSelectManager"
                      @input="handleInputManager"
                      :trigger-on-focus="false"
                      style="width: 100%"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    >
                      <template slot-scope="{ item }">
                        <div class="flex-center my-7">
                          <div v-if="item.pic">
                            <img
                              v-lazy="item.pic"
                              :key="item.pic"
                              class="image-skeleton image-profile-32 flex-mid mr-12"
                            />
                          </div>
                          <div
                            v-else
                            class="image image-profile-32 flex-mid mr-12"
                          >
                            <div
                              class="text-in-image text-in-image-32 flex-mid"
                            >
                              {{
                                $utils("acronymName", {
                                  firstName: item.firstname,
                                  lastName: item.lastname,
                                })
                              }}
                            </div>
                          </div>
                          <div style="width: 200px; line-height: 16px">
                            <div class="ellipsis">
                              {{ item.firstname + " " + item.lastname }}
                            </div>
                            <div class="ellipsis fs-13 opa-06">
                              {{ item.team_name }}
                            </div>
                          </div>
                          <div
                            style="
                              display: flex;
                              flex: 1;
                              justify-content: flex-end;
                            "
                          >
                            <div class="div-active">
                              <div
                                class="btn-status"
                                :class="[`status-${item.status}`]"
                              >
                                {{ item.status }}
                              </div>
                              <div class="active">{{ item.to_now }}</div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template slot="prepend">
                        <div class="autocomplete-member">
                          <img
                            v-if="validateForm.boss_pic"
                            v-lazy="validateForm.boss_pic"
                            class="image image-skeleton image-profile-52 flex-mid mr-12"
                          />
                          <div
                            v-else
                            class="image image-profile-52 flex-mid mr-12"
                          >
                            <div
                              class="text-in-image text-in-image-52 flex-mid"
                            >
                              {{
                                $utils("acronymName", {
                                  firstName: validateForm.boss_firstname,
                                  lastName: validateForm.boss_lastname,
                                })
                              }}
                            </div>
                          </div>
                          <div class="team-name">
                            {{ validateForm.boss_team_name }}
                          </div>
                        </div>
                      </template>
                    </el-autocomplete>
                    <div class="flex-right">
                      <div
                        v-if="validateForm.dispmanager"
                        style="justify-content: flex-end"
                      >
                        <p
                          class="fs-12 fc-F44336 m-0 pt-6"
                          style="word-break: normal"
                        >
                          {{ validateForm.dispmanager }}
                        </p>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="24" style="padding-top: 12px">
                    <div class="flex-center">
                      <div class="flex-center-1">
                        <p class="txtHeaderStyle">{{ $t("members.Team") }}</p>
                      </div>
                    </div>
                    <el-autocomplete
                      class="inline-input teamfield"
                      :class="
                        [validateForm.team_color
                          ? `border-left-color-${validateForm.team_color}`
                          : 'border-left-color-',
                          blurMode ? 'blurelement': ''
                      ]"
                      v-model="validateForm.dispteam"
                      :fetch-suggestions="querySearchTeam"
                      :placeholder="$t('members.Select_a_Team')"
                      @select="handleSelectTeam"
                      @input="handleInputTeam"
                      style="width: 100%"
                    >
                      <template slot-scope="{ item }">
                        <div class="item"
                        :class="[ blurMode ?  'blurelement': '' ]">{{ item.name }}</div>
                      </template>
                    </el-autocomplete>
                    <div class="flex-right">
                      <div
                        v-if="
                          validateForm.dispteam &&
                          Object.keys(teamByKey).filter(
                            (k) =>
                              teamByKey[k].name.toLowerCase() ===
                              validateForm.dispteam.toLowerCase()
                          ).length == 0
                        "
                        style="justify-content: flex-end"
                      >
                        <p
                          class="fs-12 fc-32C2D5 m-0 pt-6"
                          style="word-break: normal"
                        >
                          "{{ validateForm.dispteam }}"
                          {{ $t("members.will_be_created_as_a") }}
                        </p>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="24" style="padding-top: 32px">
                    <p class="txtHeaderStyle">{{ $t("members.User_role") }}</p>
                    <el-select
                      v-model="validateForm.user_type"
                      class="rolefield"
                      style="width: 100%"
                    >
                      <el-option label="👩🏻  Member" value="user">
                        <span
                          style="float: left; color: #2d2e36; font-size: 14px"
                          >👩🏻 Member</span
                        >
                        <span style="float: right; font-size: 11px">{{
                          $t("members.Limited_Access")
                        }}</span>
                      </el-option>
                      <el-option label="✍🏻  Admin" value="admin">
                        <span
                          style="float: left; color: #2d2e36; font-size: 14px"
                          >✍🏻 Admin</span
                        >
                        <span style="float: right; font-size: 11px">{{
                          $t("members.Manage_Account_Email_Notifications")
                        }}</span>
                      </el-option>
                      <el-option label="🛠️  Developer" value="developer">
                        <span
                          style="float: left; color: #2d2e36; font-size: 14px"
                          >🛠️ Developer</span
                        >
                        <span style="float: right; font-size: 11px">{{
                          $t("members.integrations")
                        }}</span>
                      </el-option>
                      <el-option
                        label="👩🏻‍💻  HR"
                        value="hr"
                        :disabled="
                          user.user_type == 'leadership' ||
                          user.user_type == 'admin'
                        "
                      >
                        <span
                          style="float: left; color: #2d2e36; font-size: 14px"
                          >👩🏻‍💻 HR</span
                        >
                        <span style="float: right; font-size: 11px">{{
                          $t("members.Manage_Account_Insights")
                        }}</span>
                      </el-option>
                      <el-option label="👩🏻‍💼  Leader" value="leadership">
                        <span
                          style="float: left; color: #2d2e36; font-size: 14px"
                          >👩🏻‍💼 Leader</span
                        >
                        <span style="float: right; font-size: 11px">{{
                          $t("members.Insights_Medals")
                        }}</span>
                      </el-option>
                      <el-option
                        label="🦸🏻‍♀️  Super Leader"
                        value="superleader"
                        :disabled="
                          user.user_type == 'leadership' ||
                          user.user_type == 'admin'
                        "
                      >
                        <span
                          style="float: left; color: #2d2e36; font-size: 14px"
                          >🦸🏻‍♀️ Super Leader</span
                        >
                        <span style="float: right; font-size: 11px">{{
                          $t("members.Manage_Account_Insights_Medals")
                        }}</span>
                      </el-option>
                      <el-option
                        label="🙆🏻‍♀️  Super Admin"
                        value="superadmin"
                        :disabled="
                          user.user_type == 'leadership' ||
                          user.user_type == 'admin'
                        "
                      >
                        <span
                          style="float: left; color: #2d2e36; font-size: 14px"
                          >🙆🏻‍♀️ Super Admin</span
                        >
                        <span style="float: right; font-size: 11px">{{
                          $t("members.Manage_Account_Insights_Email")
                        }}</span>
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="24" style="padding-top: 12px">
                    <p class="txtHeaderStyle">
                      {{ $t("members.Language") }}
                    </p>
                    <el-select
                      v-model="validateForm.language"
                      class="langfield"
                      style="width: 100%"
                    >
                      <el-option
                        :label="$t('members.English')"
                        value="en"
                      ></el-option>
                      <el-option
                        :label="$t('members.Thai')"
                        value="th"
                      ></el-option>
                      <el-option
                        :label="$t('members.BahasaMalay')"
                        value="ms"
                      ></el-option>
                      <el-option
                        :label="$t('members.ChineseHK')"
                        value="zh-HK"
                      ></el-option>
                      <el-option
                        :label="$t('members.BrazilianPortuguese')"
                        value="pt-br"
                      ></el-option>
                      <el-option
                        :label="$t('members.Burmese')"
                        value="my"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="24" style="padding-top: 20px">
                    <div
                      class="advanced-info-header"
                      @click="advancedInfoCollapsed = !advancedInfoCollapsed"
                    >
                      <span class="txtHeaderStyle" style="margin: 0; cursor: pointer;">Advanced Information</span>
                      <i
                        :class="advancedInfoCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
                        style="font-size: 12px; color: #909399; margin-left: 8px; cursor: pointer;"
                      ></i>
                    </div>
                    <div v-show="!advancedInfoCollapsed" style="padding-top: 12px">
                      <div>
                        <p class="txtHeaderStyle">Birthday</p>
                        <div class="grid-2-50">
                          <div class="mr-8">
                            <el-select
                              v-model="validateForm.birthday_month"
                              placeholder="Month"
                              style="width: 100%"
                              clearable
                            >
                              <el-option
                                v-for="m in monthOptions"
                                :key="m.value"
                                :label="m.label"
                                :value="m.value"
                              ></el-option>
                            </el-select>
                          </div>
                          <div class="ml-8">
                            <el-select
                              v-model="validateForm.birthday_day"
                              placeholder="Day"
                              style="width: 100%"
                              clearable
                            >
                              <el-option
                                v-for="d in dayOptions"
                                :key="d.value"
                                :label="d.label"
                                :value="d.value"
                              ></el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                      <div style="padding-top: 12px">
                        <p class="txtHeaderStyle">Join Date</p>
                        <el-date-picker
                          v-model="validateForm.workdate"
                          type="date"
                          placeholder="Select date"
                          style="width: 100%"
                          value-format="yyyy-MM-dd"
                        ></el-date-picker>
                      </div>
                      <div style="padding-top: 12px">
                        <p class="txtHeaderStyle">Happily House</p>
                        <el-select
                          v-model="validateForm.house"
                          placeholder="Quiz-based Assignment Recommended"
                          style="width: 100%"
                          clearable
                        >
                          <el-option
                            v-for="house in houseOptions"
                            :key="house.value"
                            :label="house.label"
                            :value="house.value"
                          >
                            <span class="house-option-item">
                              <img :src="getHouseImage(house.image)" class="house-option-icon" />
                              <span>{{ house.label }}</span>
                            </span>
                          </el-option>
                        </el-select>
                        <div v-if="validateForm.house !== originalHouseValue" class="house-assignment-hint">
                          <i class="el-icon-warning" style="color: #FAAD14"></i>
                          <span>Manual assignment not recommended - may affect workstyle analysis accuracy</span>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="24" style="padding-top: 12px">
                    <div class="grid-2-50">
                      <div class="mr-8">
                        <p class="txtHeaderStyle">Country</p>
                        <el-select
                          v-model="validateForm.country"
                          class="langfield"
                          style="width: 100%"
                          filterable
                        >
                          <el-option
                            v-for="item in locationOption"
                            :key="item.value"
                            :label="item.value"
                            :value="item.lable"
                          ></el-option>
                          <!-- <el-option
                            label="Thailand"
                            value="thailand"
                          ></el-option> -->
                        </el-select>
                      </div>
                      <div class="ml-8">
                        <p class="txtHeaderStyle">Time Zone</p>
                        <el-select
                          v-model="validateForm.time_zone"
                          class="langfield"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in timeZoneOption"
                            :key="item.lable"
                            :label="item.utcOffsetStr"
                            :value="item.lable"
                            style="height: auto"
                          >
                            <span style="line-height: 14px">
                              <div class="mt-8" style="max-width: 350px">
                                {{ item.utcOffsetStr }}
                              </div>
                              <el-tooltip
                                v-if="item.country.length > 46"
                                placement="top"
                              >
                                <div slot="content" style="max-width: 520px">
                                  {{ item.country }}
                                </div>
                                <div
                                  class="opa-08 fs-12 mb-8 mt-2 ellipsis"
                                  style="max-width: 350px"
                                >
                                  {{ item.country }}
                                </div>
                              </el-tooltip>
                              <div
                                v-else
                                class="opa-08 fs-12 mb-8 mt-2 ellipsis"
                                style="max-width: 350px"
                              >
                                {{ item.country }}
                              </div>
                            </span>
                          </el-option>
                          <!-- <el-option
                                label="+7:00 GMT"
                                value="480"
                              >
                                <span>+7:00 GMT</span>&nbsp;
                                <span class="opa-08 fs-12">Thailand, Indonesia, Vietnam, Laos</span>
                              </el-option>
                              <el-option
                                label="+8:00 GMT"
                                value="540"
                              >
                                <span>+8:00 GMT</span>&nbsp;
                                <span class="opa-08 fs-12">Chaina, Brounei, Hong Kong</span>
                              </el-option>
                              <el-option
                                label="+9:00 GMT"
                                value="600"
                              >
                                <span>+9:00 GMT</span>&nbsp;
                                <span class="opa-08 fs-12">Japan, South Korea, North Korea</span>
                              </el-option> -->
                        </el-select>
                      </div>
                    </div>
                  </el-col>
                  <el-col v-if="mode" :span="24" class="flex-center mt-32">
                    <el-button class="btnAddMemberModal" @click="saveMember">{{
                      $t("members.SAVE_CHANGES")
                    }}</el-button>
                    <el-button
                      :disabled="this.mode ? false : true"
                      class="btnInviteMemberModal btn-gray"
                      type="primary"
                      @click="inviteMember(validateForm.email)"
                    >
                      <div class="flex-center" style="justify-content: center">
                        <img
                          :src="getImgUrl('ic_mail-18px@2x')"
                          style="width: 18px; height: 18px"
                        />
                        <span style="padding-left: 8px">{{
                          $t("members.SEND_INVITE")
                        }}</span>
                      </div>
                    </el-button>
                  </el-col>
                  <el-col v-else :span="24" class="flex-center mt-32">
                    <div class="flex-center">
                      <el-button
                        class="btnAddMemberModal"
                        @click="saveMember"
                        >{{ $t("members.ADD_MEMBER") }}</el-button
                      >
                      <div class="send-style ml-28">
                        <el-checkbox v-model="checkedAutoSendInvit"
                          ><span></span
                        ></el-checkbox>
                      </div>
                      <div class="fs-13 fw-400 fc-2D2E36">
                        {{ $t("members.Automatically_send_an") }}
                      </div>
                    </div>
                  </el-col>
                  <el-col
                    v-if="this.mode && !scheduledArchive"
                    :span="24"
                    style="padding-top: 13px"
                  >
                    <span
                      class="txtArchivedModal"
                      @click="switchToArchive = !switchToArchive"
                      >{{ $t("members.Archive_employee") }}</span
                    >
                  </el-col>
                  <el-col
                    v-else-if="scheduledArchive"
                    :span="24"
                    style="padding-top: 24px"
                  >
                    <div class="cancel-achive-box mb-22">
                      <div>Scheduled Archive on {{ this.dateArchive }}</div>
                      <div
                        class="link mt-12 cursor-pointer"
                        @click="cancelSchedule"
                      >
                        Cancel Scheduled Archive
                      </div>
                    </div>
                  </el-col>
                </div>
              </div>
              <div v-else>
                <el-tabs v-model="activeProfileTab">
                  <el-tab-pane
                    :label="$t('members.Information')"
                    name="information"
                  >
                    <div v-if="switchToArchive" class="mt-24 word-break">
                      <div>
                        <span class="fw-700 fs-19 fc-2D2E36">{{
                          $t("members.Are_you_sure_would")
                        }}</span>
                      </div>
                      <div class="pt-20">
                        <span class="fs-16 fc-2D2E36"
                          >{{ $t("members.Once_archived_the_member") }}
                        </span>
                      </div>
                      <div class="pt-20">
                        <span class="fs-16 fc-2D2E36">{{
                          $t("members.Archived_members_can_be")
                        }}</span>
                      </div>
                      <div class="fs-16 fw-600 mt-24">Archive Schedule</div>
                      <div class="relative mt-8">
                        <el-date-picker
                          v-model="dateAcchivePicker"
                          value-format="yyyy-MM-dd HH:mm"
                          type="datetime"
                          :picker-options="pickerOptions"
                          @change="checkNowPicker"
                          placeholder=""
                          style="width: 100%"
                          :format="`MMMM d hh:mm A`"
                          default-time="23:59:00"
                          :editable="false"
                          popper-class="hide-btn-picker-time"
                        >
                        </el-date-picker>
                        <div
                          v-if="!dateAcchivePicker"
                          class="absolute-mid fs-18 events-none"
                          style="left: 54px"
                        >
                          Now
                        </div>
                      </div>
                      <el-col :span="24" class="flex-center mt-40">
                        <el-button
                          class="btnCancelArchiveModal btn-gray"
                          type="primary"
                          @click="switchToArchive = !switchToArchive"
                          >{{ $t("members.CANCEL") }}</el-button
                        >
                        <el-dropdown @command="archiveMemberType" class="ml-18">
                          <div @click="handleArchiveButtonClick" class="btn btn-archive">
                            ARCHIVE
                          </div>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="Resigned">Resigned</el-dropdown-item>
                            <el-dropdown-item command="Terminated"
                              >Terminated</el-dropdown-item
                            >
                            <el-dropdown-item command="Other">Other</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </el-col>
                    </div>
                    <div v-else class="mt-24">
                      <el-col :span="11">
                        <p class="txtHeaderStyle">
                          {{ $t("members.First_Name") }}
                        </p>
                        <el-input
                          v-model="validateForm.firstname"
                          auto-complete="off"
                          :placeholder="$t('members.First_Name')"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        ></el-input>
                      </el-col>
                      <el-col :span="1">&nbsp;</el-col>
                      <el-col :span="12">
                        <p class="txtHeaderStyle">
                          {{ $t("members.Last_Name") }}
                        </p>
                        <el-input
                          v-model="validateForm.lastname"
                          auto-complete="off"
                          :placeholder="$t('members.Last_Name')"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        ></el-input>
                      </el-col>
                      <el-col :span="24" style="padding-top: 12px">
                        <p class="txtHeaderStyle">Nickname</p>
                        <el-input
                          v-model="validateForm.nickname"
                          auto-complete="off"
                          placeholder="Nickname (optional)"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        ></el-input>
                      </el-col>

                      <el-col :span="24" style="padding-top: 12px">
                        <p class="txtHeaderStyle">{{ $t("members.Email") }}</p>
                        <el-input
                          :disabled="this.mode ? true : false"
                          v-model="validateForm.email"
                          auto-complete="off"
                          placeholder="name@company.com"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        ></el-input>
                      </el-col>

                      <el-col :span="24" style="padding-top: 32px">
                        <p class="txtHeaderStyle">
                          {{ $t("members.Manager") }}
                        </p>
                        <el-autocomplete
                          class="inline-input managerfield"
                          v-model="validateForm.dispboss"
                          :fetch-suggestions="querySearchManager"
                          :placeholder="$t('members.Select_a_Manager')"
                          @select="handleSelectManager"
                          @input="handleInputManager"
                          :trigger-on-focus="false"
                          style="width: 100%"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        >
                          <template slot-scope="{ item }">
                            <div class="flex-center my-7">
                              <div v-if="item.pic">
                                <img
                                  v-lazy="item.pic"
                                  :key="item.pic"
                                  class="image-skeleton image-profile-32 flex-mid mr-12"
                                  :class="[ blurMode ?  'blurelement': '' ]"
                                />
                              </div>
                              <div
                                v-else
                                class="image image-profile-32 flex-mid mr-12"
                                :class="[ blurMode ?  'blurelement': '' ]"
                              >
                                <div
                                  class="text-in-image text-in-image-32 flex-mid"
                                >
                                  {{
                                    $utils("acronymName", {
                                      firstName: item.firstname,
                                      lastName: item.lastname,
                                    })
                                  }}
                                </div>
                              </div>
                              <div style="width: 200px; line-height: 16px"
                              :class="[ blurMode ?  'blurelement': '' ]">
                                <div class="ellipsis">
                                  {{ item.firstname + " " + item.lastname }}
                                </div>
                                <div class="ellipsis fs-13 opa-06">
                                  {{ item.team_name }}
                                </div>
                              </div>
                              <div
                                style="
                                  display: flex;
                                  flex: 1;
                                  justify-content: flex-end;
                                "
                              >
                                <div class="div-active">
                                  <div
                                    class="btn-status"
                                    :class="[`status-${item.status}`]"
                                  >
                                    {{ item.status }}
                                  </div>
                                  <div class="active">{{ item.to_now }}</div>
                                </div>
                              </div>
                            </div>
                          </template>
                          <template slot="prepend">
                            <div class="autocomplete-member">
                              <img
                                v-if="validateForm.boss_pic"
                                v-lazy="validateForm.boss_pic"
                                class="image image-skeleton image-profile-52 flex-mid mr-12"
                                :class="[ blurMode ?  'blurelement': '' ]"
                              />
                              <div
                                v-else
                                class="image image-profile-52 flex-mid mr-12"
                                :class="[ blurMode ?  'blurelement': '' ]"
                              >
                                <div
                                  class="text-in-image text-in-image-52 flex-mid"
                                >
                                  {{
                                    $utils("acronymName", {
                                      firstName: validateForm.boss_firstname,
                                      lastName: validateForm.boss_lastname,
                                    })
                                  }}
                                </div>
                              </div>
                              <div class="team-name"
                              :class="[ blurMode ?  'blurelement': '' ]">
                                {{ validateForm.boss_team_name }}
                              </div>
                            </div>
                          </template>
                        </el-autocomplete>
                        <div class="flex-right">
                          <div
                            v-if="validateForm.dispmanager"
                            style="justify-content: flex-end"
                          >
                            <p
                              class="fs-12 fc-F44336 m-0 pt-6"
                              style="word-break: normal"
                            >
                              {{ validateForm.dispmanager }}
                            </p>
                          </div>
                        </div>
                      </el-col>

                      <el-col :span="24" style="padding-top: 12px">
                        <div class="flex-center">
                          <div class="flex-center-1">
                            <p class="txtHeaderStyle">Team</p>
                          </div>
                        </div>
                        <el-autocomplete
                          class="inline-input teamfield"
                          :class="
                          [validateForm.team_color
                          ? `border-left-color-${validateForm.team_color}`
                          : 'border-left-color-',
                          blurMode ? 'blurelement': ''
                      ]"
                          v-model="validateForm.dispteam"
                          :fetch-suggestions="querySearchTeam"
                          :placeholder="$t('members.Select_a_Team')"
                          @select="handleSelectTeam"
                          @input="handleInputTeam"
                          style="width: 100%"
                        >
                          <template slot-scope="{ item }">
                            <div class="item"
                            :class="[ blurMode ?  'blurelement': '' ]">{{ item.name }}</div>
                          </template>
                        </el-autocomplete>
                        <div class="flex-right">
                          <div
                            v-if="
                              validateForm.dispteam &&
                              Object.keys(teamByKey).filter(
                                (k) =>
                                  teamByKey[k].name.toLowerCase() ===
                                  validateForm.dispteam.toLowerCase()
                              ).length == 0
                            "
                            style="justify-content: flex-end"
                          >
                            <p
                              class="fs-12 fc-32C2D5 m-0 pt-6"
                              style="word-break: normal"
                            >
                              "{{ validateForm.dispteam }}"
                              {{ $t("members.will_be_created_as_a") }}
                            </p>
                          </div>
                        </div>
                      </el-col>

                      <el-col :span="24" style="padding-top: 32px">
                        <p class="txtHeaderStyle">
                          {{ $t("members.User_role") }}
                        </p>
                        <el-select
                          v-model="validateForm.user_type"
                          class="rolefield"
                          style="width: 100%"
                        >
                          <el-option label="👩🏻  Member" value="user">
                            <span
                              style="
                                float: left;
                                color: #2d2e36;
                                font-size: 14px;
                              "
                              >👩🏻 Member</span
                            >
                            <span style="float: right; font-size: 11px">{{
                              $t("members.Limited_Access")
                            }}</span>
                          </el-option>
                          <el-option label="✍🏻  Admin" value="admin">
                            <span
                              style="
                                float: left;
                                color: #2d2e36;
                                font-size: 14px;
                              "
                              >✍🏻 Admin</span
                            >
                            <span style="float: right; font-size: 11px">{{
                              $t("members.Manage_Account_Email_Notifications")
                            }}</span>
                          </el-option>
                          <el-option label="🛠️  Developer" value="developer">
                            <span
                              style="
                                float: left;
                                color: #2d2e36;
                                font-size: 14px;
                              "
                              >🛠️ Developer</span
                            >
                            <span style="float: right; font-size: 11px">{{
                              $t("members.integrations")
                            }}</span>
                          </el-option>
                          <el-option
                            label="👩🏻‍💻  HR"
                            value="hr"
                            :disabled="
                              user.user_type == 'leadership' ||
                              user.user_type == 'admin'
                            "
                          >
                            <span
                              style="
                                float: left;
                                color: #2d2e36;
                                font-size: 14px;
                              "
                              >👩🏻‍💻 HR</span
                            >
                            <span style="float: right; font-size: 11px">{{
                              $t("members.Manage_Account_Insights")
                            }}</span>
                          </el-option>
                          <el-option label="👩🏻‍💼  Leader" value="leadership">
                            <span
                              style="
                                float: left;
                                color: #2d2e36;
                                font-size: 14px;
                              "
                              >👩🏻‍💼 Leader</span
                            >
                            <span style="float: right; font-size: 11px">{{
                              $t("members.Insights_Medals")
                            }}</span>
                          </el-option>
                          <el-option
                            label="🦸🏻‍♀️  Super Leader"
                            value="superleader"
                            :disabled="
                              user.user_type == 'leadership' ||
                              user.user_type == 'admin'
                            "
                          >
                            <span
                              style="
                                float: left;
                                color: #2d2e36;
                                font-size: 14px;
                              "
                              >🦸🏻‍♀️ Super Leader</span
                            >
                            <span style="float: right; font-size: 11px">{{
                              $t("members.Manage_Account_Insights_Medals")
                            }}</span>
                          </el-option>
                          <el-option
                            label="🙆🏻‍♀️  Super Admin"
                            value="superadmin"
                            :disabled="
                              user.user_type == 'leadership' ||
                              user.user_type == 'admin'
                            "
                          >
                            <span
                              style="
                                float: left;
                                color: #2d2e36;
                                font-size: 14px;
                              "
                              >🙆🏻‍♀️ Super Admin</span
                            >
                            <span style="float: right; font-size: 11px">{{
                              $t("members.Manage_Account_Insights_Email")
                            }}</span>
                          </el-option>
                        </el-select>
                      </el-col>

                      <el-col :span="24" style="padding-top: 12px">
                        <p class="txtHeaderStyle">
                          {{ $t("members.Language") }}
                        </p>
                        <el-select
                          v-model="validateForm.language"
                          class="langfield"
                          style="width: 100%"
                        >
                          <el-option
                            :label="$t('members.English')"
                            value="en"
                          ></el-option>
                          <el-option
                            :label="$t('members.Thai')"
                            value="th"
                          ></el-option>
                          <el-option
                        :label="$t('members.BahasaMalay')"
                        value="ms"
                        ></el-option>
                        <el-option
                          :label="$t('members.ChineseHK')"
                          value="zh-HK"
                        ></el-option>
                        <el-option
                          :label="$t('members.BrazilianPortuguese')"
                          value="pt-br"
                        ></el-option>
                        <el-option
                          :label="$t('members.Burmese')"
                          value="my"
                        ></el-option>
                        </el-select>
                      </el-col>

                      <el-col :span="24" style="padding-top: 20px">
                        <div
                          class="advanced-info-header"
                          @click="advancedInfoCollapsed = !advancedInfoCollapsed"
                        >
                          <span class="txtHeaderStyle" style="margin: 0; cursor: pointer;">Advanced Information</span>
                          <i
                            :class="advancedInfoCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
                            style="font-size: 12px; color: #909399; margin-left: 8px; cursor: pointer;"
                          ></i>
                        </div>
                        <div v-show="!advancedInfoCollapsed" style="padding-top: 12px">
                          <div>
                            <p class="txtHeaderStyle">Birthday</p>
                            <div class="grid-2-50">
                              <div class="mr-8">
                                <el-select
                                  v-model="validateForm.birthday_month"
                                  placeholder="Month"
                                  style="width: 100%"
                                  clearable
                                >
                                  <el-option
                                    v-for="m in monthOptions"
                                    :key="m.value"
                                    :label="m.label"
                                    :value="m.value"
                                  ></el-option>
                                </el-select>
                              </div>
                              <div class="ml-8">
                                <el-select
                                  v-model="validateForm.birthday_day"
                                  placeholder="Day"
                                  style="width: 100%"
                                  clearable
                                >
                                  <el-option
                                    v-for="d in dayOptions"
                                    :key="d.value"
                                    :label="d.label"
                                    :value="d.value"
                                  ></el-option>
                                </el-select>
                              </div>
                            </div>
                          </div>
                          <div style="padding-top: 12px">
                            <p class="txtHeaderStyle">Join Date</p>
                            <el-date-picker
                              v-model="validateForm.workdate"
                              type="date"
                              placeholder="Select date"
                              style="width: 100%"
                              value-format="yyyy-MM-dd"
                            ></el-date-picker>
                          </div>
                          <div style="padding-top: 12px">
                            <p class="txtHeaderStyle">Happily House</p>
                            <el-select
                              v-model="validateForm.house"
                              placeholder="Not Assigned"
                              style="width: 100%"
                              clearable
                            >
                              <el-option
                                v-for="house in houseOptions"
                                :key="house.value"
                                :label="house.label"
                                :value="house.value"
                              >
                                <span class="house-option-item">
                                  <img :src="getHouseImage(house.image)" class="house-option-icon" />
                                  <span>{{ house.label }}</span>
                                </span>
                              </el-option>
                            </el-select>
                            <div v-if="validateForm.house !== originalHouseValue" class="house-assignment-hint">
                              <i class="el-icon-warning" style="color: #FAAD14"></i>
                              <span>Manual assignment not recommended - may affect workstyle analysis accuracy</span>
                            </div>
                          </div>
                        </div>
                      </el-col>

                      <el-col :span="24" style="padding-top: 12px">
                        <div class="grid-2-50">
                          <div class="mr-8">
                            <p class="txtHeaderStyle">Country</p>
                            <el-select
                              v-model="validateForm.country"
                              class="langfield"
                              style="width: 100%"
                              filterable
                            >
                              <el-option
                                v-for="item in locationOption"
                                :key="item.value"
                                :label="item.value"
                                :value="item.lable"
                              ></el-option>
                              <!-- <el-option
                                label="Singapore"
                                value="singapore"
                              ></el-option>
                              <el-option
                                label="Thailand"
                                value="thailand"
                              ></el-option> -->
                            </el-select>
                          </div>
                          <div class="ml-8">
                            <p class="txtHeaderStyle">Time Zone</p>
                            <el-select
                              v-model="validateForm.time_zone"
                              class="langfield"
                              style="width: 100%"
                            >
                              <el-option
                                v-for="item in timeZoneOption"
                                :key="item.lable"
                                :label="item.utcOffsetStr"
                                :value="item.lable"
                                style="height: auto"
                              >
                                <span style="line-height: 14px">
                                  <div class="mt-8" style="max-width: 350px">
                                    {{ item.utcOffsetStr }}
                                  </div>
                                  <el-tooltip
                                    v-if="item.country.length > 46"
                                    placement="top"
                                  >
                                    <div
                                      slot="content"
                                      style="max-width: 520px"
                                    >
                                      {{ item.country }}
                                    </div>
                                    <div
                                      class="opa-08 fs-12 mb-8 mt-2 ellipsis"
                                      style="max-width: 350px"
                                    >
                                      {{ item.country }}
                                    </div>
                                  </el-tooltip>
                                  <div
                                    v-else
                                    class="opa-08 fs-12 mb-8 mt-2 ellipsis"
                                    style="max-width: 350px"
                                  >
                                    {{ item.country }}
                                  </div>
                                </span>
                              </el-option>
                              <!-- <el-option label="+7:00 GMT" value="480">
                                <span>+7:00 GMT</span>&nbsp;
                                <span class="opa-08 fs-12"
                                  >Thailand, Indonesia, Vietnam, Laos</span
                                >
                              </el-option>
                              <el-option label="+8:00 GMT" value="540">
                                <span>+8:00 GMT</span>&nbsp;
                                <span class="opa-08 fs-12"
                                  >Chaina, Brounei, Hong Kong</span
                                >
                              </el-option>
                              <el-option label="+9:00 GMT" value="600">
                                <span>+9:00 GMT</span>&nbsp;
                                <span class="opa-08 fs-12"
                                  >Japan, South Korea, North Korea</span
                                >
                              </el-option> -->
                            </el-select>
                          </div>
                        </div>
                      </el-col>

                      <el-col v-if="mode" :span="24" class="flex-center mt-32">
                        <el-button
                          class="btnAddMemberModal"
                          @click="saveMember"
                          >{{ $t("members.SAVE_CHANGES") }}</el-button
                        >
                        <el-button
                          :disabled="this.mode ? false : true"
                          class="btnInviteMemberModal btn-gray"
                          type="primary"
                          @click="inviteMember(validateForm.email)"
                        >
                          <div
                            class="flex-center"
                            style="justify-content: center"
                          >
                            <img
                              :src="getImgUrl('ic_mail-18px@2x')"
                              style="width: 18px; height: 18px"
                            />
                            <span style="padding-left: 8px">{{
                              $t("members.SEND_INVITE")
                            }}</span>
                          </div>
                        </el-button>
                      </el-col>

                      <el-col v-else :span="24" class="flex-center mt-32">
                        <div class="flex-center">
                          <el-button
                            class="btnAddMemberModal"
                            @click="saveMember"
                            >{{ $t("members.ADD_MEMBER") }}</el-button
                          >
                          <div class="send-style ml-28">
                            <el-checkbox v-model="checkedAutoSendInvit"
                              ><span></span
                            ></el-checkbox>
                          </div>
                          <div class="fs-13 fw-400 fc-2D2E36">
                            {{ $t("members.Automatically_send_an") }}
                          </div>
                        </div>
                      </el-col>

                      <el-col
                        v-if="this.mode && !scheduledArchive"
                        :span="24"
                        style="padding-top: 13px"
                      >
                        <span
                          class="txtArchivedModal"
                          @click="switchToArchive = !switchToArchive"
                          >{{ $t("members.Archive_employee") }}</span
                        >
                      </el-col>
                      <el-col
                        v-else-if="scheduledArchive"
                        :span="24"
                        style="padding-top: 24px"
                      >
                        <div class="cancel-achive-box mb-22">
                          <div>
                            Scheduled Archive on
                            {{ this.dateArchive }}
                          </div>
                          <div
                            class="link mt-12 cursor-pointer"
                            @click="cancelSchedule"
                          >
                            Cancel Scheduled Archive
                          </div>
                        </div>
                      </el-col>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane
                    :label="`${$t('members.Direct_Reports')} (${
                      directReportsData.total
                    })`"
                    name="directReports"
                    :disabled="directReportsData.total == 0 ? true : false"
                  >
                    <div class="mt-24">
                      <div class="fs-20 fw-900 fc-2D2E36 mb-16">
                        {{ $t("members.Direct_Reports") }} ({{
                          directReportsData.total
                        }})
                      </div>
                      <div
                        v-for="profile in directReportsData.directReport"
                        :key="profile.id"
                        class="flex-center py-8"
                      >
                        <div class="flex-mid">
                          <img
                            v-if="profile.pic"
                            v-lazy="profile.pic"
                            :alt="profile.firstname + ' ' + profile.lastName"
                            :key="profile.pic"
                            class="image-skeleton image-profile-42 flex-mid mr-12"
                            :class="[ blurMode ?  'blurelement': '' ]"
                          />
                          <div
                            v-else
                            class="image image-profile-42 flex-mid mr-12"
                            :class="[ blurMode ?  'blurelement': '' ]"
                          >
                            <div
                              class="text-in-image text-in-image-42 flex-mid"
                            >
                              {{
                                $utils("acronymName", {
                                  firstName: profile.firstname,
                                  lastName: profile.lastname,
                                })
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="flex-column">
                          <span class="text-name"
                          :class="[ blurMode ?  'blurelement': '' ]"
                            >{{ profile.firstname }}
                            {{ profile.lastname }}</span
                          >
                          <span class="text-email"
                          :class="[ blurMode ?  'blurelement': '' ]">{{ profile.email }}</span>
                        </div>
                        <div
                          class="fs-14 fc-4A4A4A ml-16 ellipsis"
                          style="width: 114px"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        >
                          {{ profile.team_name }}
                        </div>
                        <div class="div-active" style="margin-left: auto">
                          <div
                            class="btn-status"
                            :class="[`status-${profile.status}`]"
                          >
                            {{ profile.status }}
                          </div>
                          <div class="active">{{ profile.to_now }}</div>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </el-col>
        </el-form>
      </el-dialog>
      <el-dialog
        :visible.sync="assignManagerModalStatus"
        @close="cancelAssignManagerModal"
        top="8vh"
      >
        <div class="modal-2-column modal-edit-team">
          <div class="member-selected rm-scrollbar">
            <div class="fs-20 fc-2D2E36 fw-700 mb-6">
              {{
                checkedData.length > 0
                  ? $utils("addCommasInNumber", checkedData.length)
                  : 0
              }}
              {{ $t("members.members_selected") }}
            </div>
            <div
              v-for="(user, index) in checkedData"
              :key="index + user.email"
              class="flex-center py-8"
            >
              <div class="flex-mid">
                <img
                  v-if="user.pic"
                  v-lazy="user.pic"
                  :alt="user.firstname + ' ' + user.lastname"
                  :key="user.pic"
                  class="image-skeleton image-profile-42 flex-mid mr-12"
                  :class="[ blurMode ?  'blurelement': '' ]"
                />
                <div v-else class="image image-profile-42 flex-mid mr-12"
                :class="[ blurMode ?  'blurelement': '' ]">
                  <div class="text-in-image text-in-image-42 flex-mid">
                    {{
                      $utils("acronymName", {
                        firstName: user.firstname,
                        lastName: user.lastname,
                      })
                    }}
                  </div>
                </div>
              </div>
              <div class="flex-column">
                <span class="text-name"
                :class="[ blurMode ?  'blurelement': '' ]"
                  >{{ user.firstname }} {{ user.lastname }}</span
                >
                <span class="text-email"
                :class="[ blurMode ?  'blurelement': '' ]">{{ user.email }}</span>
              </div>
            </div>
          </div>
          <div class="second-column-modal">
            <div class="fs-24 fc-2D2E36 fw-700 mb-20">
              {{ $t("members.Re_Assign_Manager") }}
            </div>
            <el-input
              class="input-style"
              v-model="manager_assign_disp"
              auto-complete="off"
              :placeholder="$t('members.Search_manager_name')"
              @input="handleInputManagerAssign"
            ></el-input>
            <div class="fs-14 fc-4A4A4A my-24">
              {{ $t("members.Suggestions_based_on_member") }}
            </div>
            <div class="grid-2">
              <div
                v-for="(item, index) in this.managerSuggest"
                :key="index"
                class="card bd-r-3 cursor-pointer"
                @click="assignManagerActiveClick(item, index)"
                :class="{ 'active-card': selectedManagerForAssign === index }"
              >
                <div class="flex-center">
                  <div class="flex-mid">
                    <img
                      v-if="item.pic"
                      v-lazy="item.pic"
                      :alt="item.firstname + item.lastname"
                      :key="item.pic"
                      class="image-skeleton image-profile-40 flex-mid mr-12"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <div v-else class="image image-profile-40 flex-mid mr-12"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <div class="text-in-image text-in-image-40 flex-mid">
                        {{
                          $utils("acronymName", {
                            firstName: item.firstname,
                            lastName: item.lastname,
                          })
                        }}
                      </div>
                    </div>
                    <div class="flex-column" style="width: 55%">
                      <span class="text-name" :class="[ blurMode ?  'blurelement': '' ]"
                        >{{ item.firstname }} {{ item.lastname }}</span
                      >
                      <span class="text-email"
                      :class="[ blurMode ?  'blurelement': '' ]">{{ item.email }}</span>
                    </div>
                    <div class="div-active" style="margin-left: auto">
                      <div
                        class="btn-status"
                        :class="[`status-${item.status}`]"
                      >
                        {{ item.status }}
                      </div>
                      <div class="active">{{ item.to_now }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-reverse mt-30">
              <el-button
                class="btn primary"
                style="margin-left: 12px"
                @click="assignManagerModalSubmit"
                >{{ $t("members.SUBMIT") }}</el-button
              >
              <el-button
                class="btn secondary"
                @click="assignManagerModalStatus = !assignManagerModalStatus"
                >{{ $t("members.CANCEL") }}</el-button
              >
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="assignTeamModalStatus"
        @close="cancelAssignTeamModal"
        top="8vh"
      >
        <div class="modal-2-column modal-edit-team">
          <div class="member-selected rm-scrollbar">
            <div class="fs-20 fc-2D2E36 fw-700 mb-6">
              {{
                checkedData.length > 0
                  ? $utils("addCommasInNumber", checkedData.length)
                  : 0
              }}
              {{ $t("members.members_selected") }}
            </div>
            <div
              v-for="(user, index) in checkedData"
              :key="index + user.email"
              class="flex-center py-8"
            >
              <div class="flex-mid">
                <img
                  v-if="user.pic"
                  v-lazy="user.pic"
                  :alt="user.firstname + user.lastname"
                  :key="user.pic"
                  class="image-skeleton image-profile-42 flex-mid mr-12"
                  :class="[ blurMode ?  'blurelement': '' ]"
                />
                <div v-else class="image image-profile-42 flex-mid mr-12"
                :class="[ blurMode ?  'blurelement': '' ]">
                  <div class="text-in-image text-in-image-42 flex-mid">
                    {{
                      $utils("acronymName", {
                        firstName: user.firstname,
                        lastName: user.lastname,
                      })
                    }}
                  </div>
                </div>
              </div>
              <div class="flex-column"
              :class="[ blurMode ?  'blurelement': '' ]">
                <span class="text-name"
                  >{{ user.firstname }} {{ user.lastname }}</span
                >
                <span class="text-email">{{ user.email }}</span>
              </div>
            </div>
          </div>
          <div class="second-column-modal">
            <div class="fs-24 fc-2D2E36 fw-700 mb-20">
              {{ $t("members.Edit_Team") }}
            </div>
            <el-input
              class="input-style"
              v-model="team_assign_disp"
              auto-complete="off"
              :placeholder="$t('members.Search_team_name')"
              @input="handleInputTeamAssign"
            ></el-input>
            <div class="fs-14 fc-4A4A4A my-24">
              {{ $t("members.Suggestions_based_on_member") }}
            </div>
            <div class="grid-2">
              <div
                v-for="(item, index) in this.teamSuggest"
                :key="index"
                class="card bd-r-3 left-bar left-bar-83 cursor-pointer"
                @click="assignTeamActiveClick(item, index)"
                :class="[
                  { 'active-card': selectedTeamForAssign === index },
                  `bg-${item.color_code}-after`,
                ]"
              >
                <div class="flex-center">
                  <div class="flex-mid">
                    <img
                      v-if="item.boss_pic"
                      v-lazy="item.boss_pic"
                      :alt="item.boss_name"
                      :key="item.boss_pic"
                      class="image-skeleton image-profile-40 flex-mid mr-12"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <div v-else class="image image-profile-40 flex-mid mr-12"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <div class="text-in-image text-in-image-40 flex-mid">
                        {{
                          $utils("acronymName", { fullName: item.boss_name })
                        }}
                      </div>
                    </div>
                    <div class="flex-column mr-12">
                      <span class="text-name ellipsis"
                      :class="[ blurMode ?  'blurelement': '' ]" style="width: 238px">{{
                        item.name
                      }}</span>
                      <span class="text-email"
                      :class="[ blurMode ?  'blurelement': '' ]"
                        >{{ item.count_member_team }}
                        {{ $t("members.members") }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-reverse mt-30">
              <el-button
                class="btn primary"
                style="margin-left: 12px"
                @click="assignTeamModalSubmit"
                >{{ $t("members.SUBMIT") }}</el-button
              >
              <el-button
                class="btn secondary"
                @click="assignTeamModalStatus = !assignTeamModalStatus"
                >{{ $t("members.CANCEL") }}</el-button
              >
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="archivedModalStatus"
        top="3vh"
        width="95%"
        id="archivedModal"
        @close="cancelAddArchive"
      >
        <div class="p-40">
          <div class="flex-center-1 fs-24 fc-000000 ml-10">
            <span class="fw-900">{{
              resultsArchive.length > 0
                ? $utils("addCommasInNumber", resultsArchive.length)
                : 0
            }}</span>
            <span class="fw-700">&nbsp;Archived Employee</span>
          </div>
          
          <!-- Attrition Chart Section -->
          <div class="attrition-chart-container mt-20" v-if="resultsArchive.length > 0">
            <div class="pl-40 pr-40 pt-20 pb-16">
              <div class="fc-000000 fs-18 fw-700">Employee Archive Trend by Month</div>
              <div style="height: 200px">
                <canvas
                  ref="attritionChart"
                  height="200px"
                  class="barchart-style"
                ></canvas>
                <div 
                  v-if="!hasValidArchiveDates" 
                  class="flex-center-1 fs-14 fc-666666"
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
                >
                  No date information available for archived employees
                </div>
              </div>
            </div>
          </div>
          
          <div
            v-if="
              Object.keys(this.checkedArchive).filter(
                (k) => this.checkedArchive[k] === true
              ).length == 0
            "
          >
            &nbsp;
          </div>
          <div
            v-else
            class="flex-row-center height-bind ml-10"
            style="background-color: #6c30cc; margin: 15px -40px 0"
          >
            <span class="fs-18 fc-FFFFFF fw-700 ml-40"
              >{{
                $utils(
                  "addCommasInNumber",
                  Object.keys(this.checkedArchive).filter(
                    (k) => this.checkedArchive[k] === true
                  ).length
                )
              }}
              {{ $t("members.members_selected") }}</span
            >
            <div style="margin-left: 24px; display: flex">
              <div
                v-for="(item, index) in this.checkedDataArchive"
                :key="index"
              >
                <div v-if="index < 3">
                  <img
                    v-if="item.pic"
                    v-lazy="item.pic"
                    :alt="item.firstname + item.lastname"
                    class="viewMember image-skeleton image-profile-30"
                    :class="[ blurMode ?  'blurelement': '' ]"
                    v-bind:style="renderSelectedPic(index)"
                  />
                  <div
                    v-else
                    class="viewMember image image-profile-30"
                    :class="[ blurMode ?  'blurelement': '' ]"
                    v-bind:style="renderSelectedPic(index)"
                  >
                    <div class="text-in-image text-in-image-30 flex-mid">
                      {{
                        $utils("acronymName", {
                          firstName: item.firstname,
                          lastName: item.lastname,
                        })
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <span
              v-if="this.checkedDataArchive.length > 3"
              class="fs-14 fc-FFFFFF"
              style="margin-left: -10px"
              >+{{
                this.checkedDataArchive && this.checkedDataArchive.length > 3
                  ? this.checkedDataArchive.length - 3
                  : ""
              }}</span
            >

            <div class="divActionHeader">
              <div
                class="btn btn-navbar bg-hover-barken-54279B opa-05"
                v-if="selcetedArchiveScheduleBoth"
              >
                {{ "CANCEL SCHEDULED ARCHIVE" }}
              </div>
              <div
                @click="unarchiveArrMemberClick"
                class="btn btn-navbar bg-hover-barken-54279B"
                v-else-if="!selcetedArchiveSchedule"
              >
                {{ "CANCEL SCHEDULED ARCHIVE" }}
              </div>

              <div
                @click="unarchiveArrMemberClick"
                class="btn btn-navbar bg-hover-barken-54279B"
                v-if="selcetedArchiveSchedule"
              >
                {{ $t("members.UNARCHIVE") }}
              </div>
              <div class="btn btn-navbar bg-hover-barken-54279B opa-05" v-else>
                {{ $t("members.UNARCHIVE") }}
              </div>
              <!-- <div
                @click="deleteArchiveArrMemberClick"
                class="btn btn-navbar bg-hover-barken-54279B"
                
              >
                {{ $t("members.DELETE") }}
              </div> -->
              <div
                v-if="selcetedArchiveSchedule"
                @click="deleteArchiveArrMemberClick"
                class="btn btn-navbar bg-hover-barken-54279B"
              >
                {{ $t("members.DELETE") }}
              </div>
              <div v-else class="btn btn-navbar bg-hover-barken-54279B opa-05">
                {{ $t("members.DELETE") }}
              </div>
            </div>
          </div>
          <div>
            <div class="flex-row-between mt-14 ml-12">
              <el-input
                class="input-style"
                style="height: 40px"
                autosize
                :placeholder="$t('members.Search')"
                v-model="inputSearchArchive"
                clearable
              ></el-input>
              <button
                @click="deleteArchiveAllClick"
                class="button btn-red cursor-pointer"
              >
                {{ $t("members.delete_all") }}
              </button>
            </div>
          </div>
          <div class="mt-10">
            <el-table
              ref="multipleTable"
              :data="membersArchive"
              style="width: 100%"
              :empty-text="
                loadingArchiveTable
                  ? ' '
                  : !membersArchive && inputSearchArchive === ''
                  ? 'No archived employees'
                  : 'No results found...'
              "
              @sort-change="sortArchive"
              @expand-change="handleArchiveExpand"
            >
              <el-table-column type="expand">
                <template slot-scope="scope">
                  <div class="archive-detail-card" v-if="!loadingArchiveDetail[scope.row.email]">
                    <!-- Left Panel: Exit Signals -->
                    <div class="archive-detail-panel">
                      <div class="panel-title">Exit Signals</div>

                      <!-- eNPS Status -->
                      <div class="detail-section">
                        <div class="detail-label">eNPS Status</div>
                        <div v-if="expandedArchiveData[scope.row.email] && expandedArchiveData[scope.row.email].enps" class="enps-badge-wrapper">
                          <span class="enps-badge" :class="'enps-' + expandedArchiveData[scope.row.email].enps.category">
                            {{ expandedArchiveData[scope.row.email].enps.label }}
                          </span>
                          <span class="enps-score">Score: {{ expandedArchiveData[scope.row.email].enps.score }}</span>
                        </div>
                        <div v-else class="detail-empty">No eNPS data</div>
                      </div>

                      <!-- Risk Flags Count -->
                      <div class="detail-section">
                        <div class="detail-label">Risk Flags (4 months)</div>
                        <div v-if="expandedArchiveData[scope.row.email] && expandedArchiveData[scope.row.email].riskFlagCount > 0">
                          <div class="risk-count-total">{{ expandedArchiveData[scope.row.email].riskFlagCount }} times flagged</div>
                          <div class="risk-count-bar">
                            <span v-if="expandedArchiveData[scope.row.email].riskBreakdown['3R']" class="risk-segment risk-high" :title="expandedArchiveData[scope.row.email].riskBreakdown['3R'] + ' high'">
                              {{ expandedArchiveData[scope.row.email].riskBreakdown['3R'] }} high
                            </span>
                            <span v-if="expandedArchiveData[scope.row.email].riskBreakdown['2R']" class="risk-segment risk-medium" :title="expandedArchiveData[scope.row.email].riskBreakdown['2R'] + ' medium'">
                              {{ expandedArchiveData[scope.row.email].riskBreakdown['2R'] }} med
                            </span>
                            <span v-if="expandedArchiveData[scope.row.email].riskBreakdown['R']" class="risk-segment risk-low" :title="expandedArchiveData[scope.row.email].riskBreakdown['R'] + ' low'">
                              {{ expandedArchiveData[scope.row.email].riskBreakdown['R'] }} low
                            </span>
                          </div>
                        </div>
                        <div v-else class="detail-empty">No risk flags</div>
                      </div>

                      <!-- Check-in Activity -->
                      <div class="detail-section">
                        <div class="detail-label">Check-in Activity (4 months)</div>
                        <div v-if="expandedArchiveData[scope.row.email] && expandedArchiveData[scope.row.email].checkinPercentage != null">
                          <div class="activity-label">{{ expandedArchiveData[scope.row.email].checkinPercentage }}% active ({{ expandedArchiveData[scope.row.email].checkinCount }} of {{ expandedArchiveData[scope.row.email].totalWorkdays }} workdays)</div>
                          <div class="activity-progress">
                            <div class="activity-bar" :style="{ width: Math.min(expandedArchiveData[scope.row.email].checkinPercentage, 100) + '%' }"></div>
                          </div>
                        </div>
                        <div v-else class="detail-empty">No check-in data</div>
                      </div>
                    </div>

                    <!-- Center Panel: Happiness Journey -->
                    <div class="archive-detail-panel archive-detail-panel-center">
                      <div class="panel-title">Happiness Journey</div>
                      <div v-if="loadingArchivedPatterns[scope.row.email]" class="happiness-loading">
                        <i class="el-icon-loading"></i> Loading happiness data...
                      </div>
                      <div v-else-if="archivedHappinessPatterns[scope.row.email] && archivedHappinessPatterns[scope.row.email].error" class="happiness-error">
                        {{ archivedHappinessPatterns[scope.row.email].error }}
                      </div>
                      <div v-else-if="archivedHappinessPatterns[scope.row.email]" class="happiness-card-content">
                        <div class="happiness-tooltip-header">
                          <div class="tooltip-subtitle">90 days before {{ archivedHappinessPatterns[scope.row.email].stats.archiveDate }}</div>
                        </div>

                        <div class="happiness-stats">
                          <div class="stat-item">
                            <span class="stat-dot green"></span>
                            <span class="stat-label">Happy:</span>
                            <span class="stat-value">{{ archivedHappinessPatterns[scope.row.email].stats.happyDays }}d ({{ archivedHappinessPatterns[scope.row.email].stats.happyPercentage }}%)</span>
                          </div>
                          <div class="stat-item">
                            <span class="stat-dot yellow"></span>
                            <span class="stat-label">Okay:</span>
                            <span class="stat-value">{{ archivedHappinessPatterns[scope.row.email].stats.okayDays }}d ({{ archivedHappinessPatterns[scope.row.email].stats.okayPercentage }}%)</span>
                          </div>
                          <div class="stat-item">
                            <span class="stat-dot red"></span>
                            <span class="stat-label">Not Great:</span>
                            <span class="stat-value">{{ archivedHappinessPatterns[scope.row.email].stats.notGreatDays }}d ({{ archivedHappinessPatterns[scope.row.email].stats.notGreatPercentage }}%)</span>
                          </div>
                        </div>

                        <div class="happiness-timeline">
                          <div class="timeline-label">Timeline (oldest → newest):</div>
                          <div class="timeline-months">
                            <div
                              v-for="(monthData, monthKey) in archivedHappinessPatterns[scope.row.email].monthlyData"
                              :key="monthKey"
                              class="timeline-month"
                            >
                              <div class="month-label">{{ monthData.monthName }}</div>
                              <div class="month-grid">
                                <div
                                  v-for="(day, dayIndex) in monthData.days"
                                  :key="dayIndex"
                                  class="timeline-day"
                                  :class="[day.response || 'no-response', { 'archive-date': day.isArchiveDate }]"
                                  :title="`${day.formattedDate} (${day.dayOfWeek}): ${day.response ? (day.response === 'green' ? 'Happy' : day.response === 'yellow' ? 'Okay' : 'Not Great') : 'No response'}${day.riskFlag && day.riskFlag.highlight ? ' | Risk: ' + day.riskFlag.highlight : ''}`"
                                >
                                  <span class="day-number">{{ day.dayOfMonth }}</span>
                                  <div v-if="day.isArchiveDate" class="archive-marker">📌</div>
                                  <div v-if="day.riskFlag && day.riskFlag.highlight && day.riskFlag.highlight.includes('R')" class="risk-flag">
                                    {{ day.riskFlag.highlight === 'R' ? '!' : day.riskFlag.highlight === '2R' ? '!!' : '!!!' }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="timeline-legend">
                            <span class="legend-item"><span class="legend-dot no-response"></span>No response</span>
                            <span class="legend-item"><span class="legend-dot green"></span>Happy</span>
                            <span class="legend-item"><span class="legend-dot yellow"></span>Okay</span>
                            <span class="legend-item"><span class="legend-dot red"></span>Not Great</span>
                            <span class="legend-item">📌 Archive date</span>
                          </div>
                        </div>
                      </div>
                      <div v-else class="detail-empty">Expand to load happiness data</div>
                    </div>

                    <!-- Right Panel: Profile at Exit -->
                    <div class="archive-detail-panel">
                      <div class="panel-title">Profile at Exit</div>

                      <!-- Coins & Gems -->
                      <div class="detail-section">
                        <div class="detail-label">Coins & Gems</div>
                        <div class="coins-gems-row">
                          <span class="coin-value"><img src="@/assets/images/ic_coin.png" alt="coin" class="coin-gem-icon" /> {{ scope.row.coin || 0 }} coins</span>
                          <span class="gem-value"><img src="@/assets/images/ic_gem.png" alt="gem" class="coin-gem-icon" /> {{ scope.row.gem || 0 }} gems</span>
                        </div>
                      </div>

                      <!-- Recovery Flags -->
                      <div class="detail-section" v-if="archivedHappinessPatterns[scope.row.email] && archivedHappinessPatterns[scope.row.email].hasRecoveryData">
                        <div class="detail-label">Recovery Flags</div>
                        <div class="flag-list">
                          <div
                            v-for="(flag, index) in archivedHappinessPatterns[scope.row.email].recoveryFlags.slice(0, 5)"
                            :key="'rec-' + index"
                            class="flag-item recovery"
                          >
                            <span class="flag-date">{{ flag.date }}</span>
                            <span class="flag-level recovery">+</span>
                            <span class="flag-content">{{ flag.content && flag.content !== 'undefined' ? flag.content : 'Recovery detected' }}</span>
                          </div>
                          <div v-if="archivedHappinessPatterns[scope.row.email].recoveryFlags.length > 5" class="more-flags">
                            ... and {{ archivedHappinessPatterns[scope.row.email].recoveryFlags.length - 5 }} more
                          </div>
                        </div>
                      </div>

                      <!-- Risk Flag Details -->
                      <div class="detail-section" v-if="archivedHappinessPatterns[scope.row.email] && archivedHappinessPatterns[scope.row.email].hasRiskData">
                        <div class="detail-label">Risk Flag Details</div>
                        <div class="flag-list">
                          <div
                            v-for="(flag, index) in archivedHappinessPatterns[scope.row.email].riskFlags.slice(0, 5)"
                            :key="'risk-' + index"
                            class="flag-item risk"
                          >
                            <span class="flag-date">{{ flag.date }}</span>
                            <span class="flag-level" :class="getRiskFlagClass(flag.highlight)">
                              {{ flag.highlight === 'R' ? '!' : flag.highlight === '2R' ? '!!' : '!!!' }}
                            </span>
                            <span class="flag-content">{{ flag.content && flag.content !== 'undefined' ? flag.content : 'Risk detected' }}</span>
                          </div>
                          <div v-if="archivedHappinessPatterns[scope.row.email].riskFlags.length > 5" class="more-flags">
                            ... and {{ archivedHappinessPatterns[scope.row.email].riskFlags.length - 5 }} more
                          </div>
                        </div>
                      </div>

                      <div v-if="!(archivedHappinessPatterns[scope.row.email] && (archivedHappinessPatterns[scope.row.email].hasRiskData || archivedHappinessPatterns[scope.row.email].hasRecoveryData))" class="detail-section">
                        <div class="detail-empty" style="margin-top: 8px;">No risk/recovery data available</div>
                      </div>
                    </div>
                  </div>
                  <!-- Loading state -->
                  <div v-else class="archive-detail-loading">
                    <i class="el-icon-loading"></i> Loading detail data...
                  </div>
                  <!-- Error state -->
                  <div v-if="expandedArchiveData[scope.row.email] && expandedArchiveData[scope.row.email].error" class="archive-detail-error">
                    {{ expandedArchiveData[scope.row.email].error }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                :render-header="renderOptionSelectArchive"
                column-key="memberCheckbox"
                width="50"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    style="
                      display: inline-block;
                      float: right;
                      margin-right: 6px;
                    "
                    v-model="checkedArchive['key_' + scope.row.key]"
                    :key="scope.row.key"
                    @change="membersCheckedArchive(scope.row.key)"
                  />
                </template>
              </el-table-column>

              <el-table-column width="55">
                <template slot-scope="scope">
                  <div class="absolute-mid">
                    <img
                      v-if="scope.row.pic"
                      v-lazy="scope.row.pic"
                      :key="scope.row.pic"
                      class="image-skeleton image-profile-42 flex-mid mx-10"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                    <div v-else class="image image-profile-42 flex-mid"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <div class="text-in-image text-in-image-42 flex-mid">
                        {{
                          $utils("acronymName", {
                            firstName: scope.row.firstname,
                            lastName: scope.row.lastname,
                          })
                        }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                prop="name"
                sortable="custom"
                :label="$t('members.Member')"
                min-width="180"
              >
                <template slot-scope="scope">
                  <div class="flex-column">
                    <span class="text-name"
                    :class="[ blurMode ?  'blurelement': '' ]"
                      >{{ scope.row.firstname }} {{ scope.row.lastname }}</span
                    >
                    <span class="text-email"
                    :class="[ blurMode ?  'blurelement': '' ]">{{ scope.row.email }}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                prop="team_name"
                sortable="custom"
                property="team"
                :label="$t('members.Team')"
                min-width="110"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.team_name"
                  :class="[ blurMode ?  'blurelement': '' ]"
                  style="color: #4a4a4a">{{
                    scope.row.team_name
                  }}</span>
                  <span v-else class="fc-32C2D5 fs-14"
                  :class="[ blurMode ?  'blurelement': '' ]"
                  style="color: #4a4a4a">{{
                    $t("members.Assign_Team")
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="impact_rating"
                sortable="custom"
                property="impact_rating"
                label="Impact"
                min-width="65"
                align="center"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.impact_rating != null" style="font-weight: 600;" :style="{ color: getImpactRatingColor(scope.row.impact_rating) }">
                    {{ Math.round(scope.row.impact_rating) }}
                  </div>
                  <div v-else style="color: #c0c4cc;">—</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="network_type"
                sortable="custom"
                property="network_type"
                label="Network"
                min-width="120"
              >
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.network_type"
                    class="archive-pill"
                    :class="getNetworkTagClass(scope.row.network_type)"
                    :title="getNetworkTooltip(scope.row.network_type)"
                  >{{ scope.row.network_type }}</span>
                  <span v-else style="color: #c0c4cc;">—</span>
                </template>
              </el-table-column>
              <el-table-column
                label="eNPS"
                min-width="85"
                align="center"
              >
                <template slot-scope="scope">
                  <span
                    v-if="expandedArchiveData[scope.row.email] && expandedArchiveData[scope.row.email].enps"
                    class="archive-pill"
                    :class="'enps-' + expandedArchiveData[scope.row.email].enps.category"
                  >{{ expandedArchiveData[scope.row.email].enps.label }}</span>
                  <span v-else style="color: #c0c4cc; font-size: 12px;">—</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="user_type"
                sortable="custom"
                property="permission"
                label="Type"
                min-width="100"
              >
                <template slot-scope="scope">
                  <div>
                    <el-dropdown @command="selectArchivedType">
                      <span class="fs-14" style="color: #4a4a4a">
                        <span
                        :class="[ blurMode ?  'blurelement': '' ]"
                        >{{ scope.row.archive_type }}</span>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          :command="{ type: 'Resigned', user: scope.row }"
                          :disabled="'Resigned' == scope.row.archive_type"
                          >Resigned</el-dropdown-item
                        >
                        <el-dropdown-item
                          :command="{ type: 'Terminated', user: scope.row }"
                          :disabled="'Terminated' == scope.row.archive_type"
                          >Terminated</el-dropdown-item
                        >
                        <el-dropdown-item
                          :command="{ type: 'Other', user: scope.row }"
                          :disabled="'Other' == scope.row.archive_type"
                          >Other</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="archiveddate"
                sortable="custom"
                property="archiveddate"
                label="Date"
                min-width="100"
              >
                <template slot-scope="scope">
                  <div style="color: #606266; font-size: 13px;">{{ scope.row.archiveddate }}</div>
                </template>
              </el-table-column>

              <el-table-column
                label
                align="center"
                width="80"
              >
                <template slot-scope="scope">
                  <div
                    @click="unarchiveMemberClick(scope.row)"
                    class="archive-action-link"
                    v-if="scope.row.archiveSchedule"
                    title="Cancel Scheduled Archive"
                  >
                    Cancel
                  </div>
                  <div
                    @click="unarchiveMemberClick(scope.row)"
                    class="archive-action-link"
                    v-else
                  >
                    Unarchive
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label
                align="center"
                width="40"
              >
                <template slot-scope="scope">
                  <div
                    @click="deleteArchiveMemberClick(scope.row.key)"
                    class="archive-delete-btn"
                    v-if="!scope.row.archiveSchedule"
                    title="Delete"
                  >
                    <i class="el-icon-delete"></i>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div
              class="center mt-10 mb-40 pt-10 pb-40"
              v-if="loadingArchiveTable"
            >
              <loading-even></loading-even>
            </div>
          </div>
          <div class="flex-center pagination mt-10">
            <el-pagination
              @current-change="handleArchiveCurrentChange"
              :current-page="pagearchive"
              :page-size="10"
              :pager-count="5"
              layout="prev, pager, next"
              :total="resultsArchive.length"
            ></el-pagination>
            <span class="results-status">
              {{ resultsArchive.length > 10 ? 10 : resultsArchive.length }}
              {{ $t("members.results_from") }}
              {{ $utils("addCommasInNumber", resultsArchive.length) }}
              {{ $t("members.results") }}
            </span>
          </div>
        </div>
      </el-dialog>

      <!-- Import Members Dialog: xxx -->
      <el-dialog
        :visible.sync="importMembersModalStatus"
        top="8vh"
        id="importMembersModal"
        @close="cancelImportMembers"
      >
        <!-- Select import type step -->
        <div class="p-40" v-if="importMembersStep == 'select'">
          <div class="flex-center-1 fs-24 fw-800 fc-000000">How would you like to add members?</div>
          <div class="fs-13 fc-000000 mt-16">Your members are the people on your teams that will receive daily questions and be able to actively participate in strengthening your culture. We'll help you import your<br /> data and set you up for success.</div>
          <div class="import-members-radio-group">
            <el-radio-group v-model="importMembersType">
              <div class="radio-item-wrapper">
                <div class="radio-item" @click="selectImportMembersType('file')" :class="[ importMembersType == 'file' ?  'active': '' ]">
                  <div>
                    <img
                      :src="$utils('icons', 'ic_xls_download@2x')"
                      width="24"
                      height="24"
                      class=""
                    />
                    <el-radio label="file" style="margin-left: auto"></el-radio>
                  </div>
                  <div>
                    <span class="fc-3B3B3B fs-13 fw-700">Upload a file</span>
                  </div>
                  <div class="description">
                    Use CSV or tab-delimited TXT files. Be sure<br /> files are formatted properly and data is<br /> clean.
                  </div>
                </div>
                <!-- <a href="javascript:void(0)">How to format your file</a> -->
              </div>
              <div class="radio-item-wrapper">
                <div class="radio-item" @click="selectImportMembersType('text')" :class="[ importMembersType == 'text' ?  'active': '' ]">
                  <div>
                    <i class="el-icon-document-copy"></i>
                    <el-radio label="text" style="margin-left: auto"></el-radio>
                  </div>
                  <div>
                    <span class="fc-3B3B3B fs-13 fw-700">Copy and paste</span>
                  </div>
                  <div class="description">
                    Directly paste in new members from a<br /> spreadsheet or similar list.
                  </div>
                </div>
                <!-- <a href="javascript:void(0)">How to copy and paste</a> -->
              </div>
            </el-radio-group>
          </div>
          <div class="mt-28">
            <el-button
              class="btn-add bigger"
              type="primary"
              @click="importMembersNextStep"
              >{{ `Continue` }}</el-button
            >
          </div>
        </div>
        <!-- Select file step -->
        <div class="p-40" v-if="importMembersStep == 'select-file'">
          <div class="flex-center-1 fs-24 fw-800 fc-000000">Upload a file</div>
          <div class="fs-13 fc-000000 mt-16">Ensuring your file is formatted correctly helps eliminate errors and makes the import process go smoother and faster.</div>
          <a href="/templates/member_import_template.csv" download class="fs-13 mt-6" style="color: #6C30CC; text-decoration: none; display: block; margin-bottom: 10px;">
            <i class="el-icon-download" style="margin-right: 5px;"></i>
            Download template file
          </a>
          <div class="mt-12 mb-16 p-16" style="background: #F8F7FC; border: 1px solid #E5E1F2; border-radius: 12px;">
            <div class="fs-14 fw-700 fc-000000">Column format guide</div>
            <div class="fs-12 mt-6" style="color: #6C30CC;">Include a header row. For birthday-only updates, you can import just <span class="fw-700">Email Address,Birthday</span>. Birthdays store month and day only.</div>
            <div class="fs-12 mt-10" style="display: grid; grid-template-columns: 160px 160px 1fr; gap: 8px 12px;">
              <div class="fw-700">Column</div>
              <div class="fw-700">Expected format</div>
              <div class="fw-700">Example</div>
              <div>First Name</div>
              <div>Free text</div>
              <div>Jane</div>
              <div>Last Name</div>
              <div>Free text</div>
              <div>Doe</div>
              <div>Email Address</div>
              <div>Work email</div>
              <div>jane@acme.com</div>
              <div>Team Name</div>
              <div>Free text</div>
              <div>People Ops</div>
              <div>Direct Manager Email</div>
              <div>Work email or blank for the one root user</div>
              <div>brittany@acme.com</div>
              <div>Language</div>
              <div>English or Thai</div>
              <div>English</div>
              <div>Country</div>
              <div>2-letter code when possible</div>
              <div>US</div>
              <div>User Type</div>
              <div>Role key</div>
              <div>user</div>
              <div>Birthday</div>
              <div>MM-DD (month/day only)</div>
              <div>04-16</div>
              <div>Join Date</div>
              <div>YYYY-MM-DD</div>
              <div>2024-01-08</div>
              <div>Timezone</div>
              <div>+/-hours or +/-HH:MM</div>
              <div>+7 or +05:30</div>
              <div>Nickname</div>
              <div>Free text</div>
              <div>JD</div>
            </div>
          </div>
          <el-upload
            ref="importMembersFileUpload"
            class="custom-upload"
            action="https://api-node.happily.ai/accounts/upload-file"
            accept=".csv, .txt, .xls, .xlsx"
            :limit=2
            :auto-upload=false
            :on-change="handleImportMembersChange"
            :before-upload="handleImportMembersBeforeUpload"
            :on-success="handleImportMembersSuccess"
            :file-list="importMembersFileList"
            drag
            >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              <strong>Drop and drop</strong><br />
              or<br />
              <em>select a file</em><br />
              <div class="el-upload__tip" slot="tip">Max file size: 200 MB (CSV, TXT), 50 MB (XLSX)</div>
            </div>
          </el-upload>
          <div class="mt-28">
            <el-button
              class="btn-cancel bigger"
              @click="importMembersStep = 'select'"
              >Back</el-button
            >
            <el-button
              class="btn-add bigger"
              type="primary"
              @click="importMembersProcess"
              >{{ `Continue` }}</el-button
            >
            
          </div>
        </div>
        <!-- Select text step -->
        <div class="p-40" v-if="importMembersStep == 'select-text'">
          <div class="flex-center-1 fs-24 fw-800 fc-000000">Copy and paste your contacts</div>
          <div class="fs-13 fc-000000 mt-16">Ensuring that the information you submit has all the necessary information makes the import process go smoother and faster.</div>
          <div class="fs-13 mt-6" style="color: #6C30CC">For full imports: First Name, Last Name, Email Address, and Team Name are required. For profile-only updates, Email Address plus the field you want to update is enough.</div>
          <div class="mt-12 mb-16 p-16" style="background: #F8F7FC; border: 1px solid #E5E1F2; border-radius: 12px;">
            <div class="fs-14 fw-700 fc-000000">Column format guide</div>
            <div class="fs-12 mt-6" style="color: #6C30CC;">Paste a header row first. For birthday-only updates, use <span class="fw-700">Email Address,Birthday</span>. Birthdays store month and day only.</div>
            <div class="fs-12 mt-10" style="display: grid; grid-template-columns: 160px 160px 1fr; gap: 8px 12px;">
              <div class="fw-700">Column</div>
              <div class="fw-700">Expected format</div>
              <div class="fw-700">Example</div>
              <div>First Name</div>
              <div>Free text</div>
              <div>Jane</div>
              <div>Last Name</div>
              <div>Free text</div>
              <div>Doe</div>
              <div>Email Address</div>
              <div>Work email</div>
              <div>jane@acme.com</div>
              <div>Team Name</div>
              <div>Free text</div>
              <div>People Ops</div>
              <div>Direct Manager Email</div>
              <div>Work email or blank for the one root user</div>
              <div>brittany@acme.com</div>
              <div>Language</div>
              <div>English or Thai</div>
              <div>English</div>
              <div>Country</div>
              <div>2-letter code when possible</div>
              <div>US</div>
              <div>User Type</div>
              <div>Role key</div>
              <div>user</div>
              <div>Birthday</div>
              <div>MM-DD (month/day only)</div>
              <div>04-16</div>
              <div>Join Date</div>
              <div>YYYY-MM-DD</div>
              <div>2024-01-08</div>
              <div>Timezone</div>
              <div>+/-hours or +/-HH:MM</div>
              <div>+7 or +05:30</div>
              <div>Nickname</div>
              <div>Free text</div>
              <div>JD</div>
            </div>
          </div>
          <el-input
            type="textarea"
            v-model="importMembersText"
            auto-complete="off"
          class="custom-textarea"
          placeholder="Example:

Email Address,Birthday
jane@acme.com,04-16"
          >
          </el-input>
          <div class="mt-28">
            <el-button
              class="btn-cancel bigger"
              @click="importMembersStep = 'select'"
              >Back</el-button
            >
            <el-button
              class="btn-add bigger"
              type="primary"
              @click="importMembersProcess"
              >{{ `Continue` }}</el-button
            >
            
          </div>
        </div>
        <!-- Review step -->
        <div class="p-40" v-if="importMembersStep == 'review'">
          <div class="flex-center-1 fs-24 fw-800 fc-000000">{{ importMembersTableDataGroupsTotal }} Updates to Review</div>
          <div class="flex-row-between mt-14">
            <el-input
              class="input-style"
              style="height: 40px"
              autosize
              :placeholder="$t('members.Search')"
              v-model="importMembersSearch"
              clearable
            ></el-input>
          </div>
          <div v-if="importMembersTableDataGroupsTotal > 0" style="overflow-y: auto; height: calc(100vh - 8vh - 50px - 230px)">
            <div v-for="(group, index) in importMembersTableDataGroups" :key="index">
              <div v-if="group.items.length" class="fs-20 mt-30 mb-16 fc-000000" style="line-height: 24px">{{ group.name }}</div>
              <el-table
                v-if="group.items.length"
                ref="importMembersTable"
                id="importMembersTable"
                :data="group.items"
                style="width: 100%"
                :empty-text="
                  'No results found...'
                "
                @sort-change="sortReviewUpdates"
              >
                <!-- Avatar -->
                <el-table-column width="42">
                  <template slot-scope="scope">
                    <div class="absolute-mid">
                      <div class="image image-profile-42 flex-mid"
                      :class="[ blurMode ?  'blurelement': '' ]">
                        <div class="text-in-image text-in-image-42 flex-mid">
                          {{
                            $utils("acronymName", {
                              firstName: scope.row.first_name,
                              lastName: scope.row.last_name,
                            })
                          }}
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <!-- Member -->
                <el-table-column
                    prop="name"
                    :label="$t('members.Member')"
                    width="170"
                  >
                    <template slot-scope="scope">
                      <div class="flex-column">
                        <span class="text-name"
                        :class="[ blurMode ?  'blurelement': '' ]"
                          >{{ scope.row.first_name }} {{ scope.row.last_name }}</span
                        >
                        <span class="text-email"
                        :class="[ blurMode ?  'blurelement': '' ]">{{ scope.row.email }}</span>
                      </div>
                    </template>
                  </el-table-column>

                  <!-- Team -->
                  <el-table-column
                    prop="team_name"
                    property="team"
                    :label="$t('members.Team')"
                    width="150"
                  >
                    <template slot-scope="scope">
                      <el-select
                        v-if="canEdit(scope.row, 'team')"
                        v-model="reviewUpdates[scope.$index].team"
                        class=""
                        style="width: 100%"
                        filterable
                        :class="[ blurMode ?  'blurelement': '' ]"
                      >
                        <el-option label="Assign Team" value=""></el-option>
                        <el-option
                            v-for="item in teamOptions"
                            :key="`team_${item.key}`"
                            :label="item.value"
                            :value="item.key"
                            :class="[ blurMode ?  'blurelement': '' ]"
                          ></el-option>
                      </el-select>
                      <div v-else
                      :class="[ blurMode ?  'blurelement': '' ]">
                        {{ scope.row.team_name }}
                      </div>
                    </template>
                  </el-table-column>

                <!-- Manager -->
                <el-table-column
                  prop="manager_name"
                  property="manager"
                  :label="$t('members.Manager')"
                  width="165"
                >
                  <template slot-scope="scope">
                    <el-select
                      v-if="canEdit(scope.row, 'manager')"
                      v-model="group.items[scope.$index].manager"
                      class="langfield"
                      style="width: 100%"
                      filterable
                      :class="[ blurMode ?  'blurelement': '' ]"
                      :ref="`managerSelects[${[reviewUpdates[scope.$index].key]}]`"
                    >
                      <el-option label="Assign Manager" value=""></el-option>
                      <el-option
                            v-for="item in managerOptions"
                            :key="`manager_${item.key}`"
                            :label="item.value"
                            :value="item.key"
                            :class="[ blurMode ?  'blurelement': '' ]"
                          ></el-option>
                    </el-select>
                    <div v-else
                    :class="[ blurMode ?  'blurelement': '' ]">
                      {{ scope.row.manager_name }}
                    </div>
                  </template>
                </el-table-column>

                <!-- Languge -->
                <el-table-column
                  prop="language"
                  property="language"
                  :label="$t('members.Language')"
                  width="120"
                >
                  <template slot-scope="scope">
                    <el-select
                      v-model="group.items[scope.$index].language"
                      class="langfield"
                      style="width: 100%"
                    >
                      <el-option
                        :label="$t('members.English')"
                        value="en"
                      ></el-option>
                      <el-option
                        :label="$t('members.Thai')"
                        value="th"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <!-- Country -->
                <el-table-column
                  prop="country"
                  property="country"
                  :label="$t('members.Country')"
                  width="120"
                >
                  <template slot-scope="scope">
                    <el-select
                      v-model="group.items[scope.$index].country"
                      class="langfield"
                      style="width: 100%"
                      filterable
                    >
                      <el-option
                        v-for="item in locationOption"
                        :key="item.value"
                        :label="item.value"
                        :value="item.lable"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="nickname"
                  property="nickname"
                  label="Nickname"
                  width="150"
                >
                  <template slot-scope="scope">
                    <div class="fs-13" style="color: #4A4A4A">
                      {{ getImportReviewFieldDisplay(scope.row, 'nickname', group.code) }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="birthday"
                  property="birthday"
                  label="Birthday"
                  width="170"
                >
                  <template slot-scope="scope">
                    <div class="fs-13" style="color: #4A4A4A">
                      {{ getImportReviewFieldDisplay(scope.row, 'birthday', group.code) }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="workdate"
                  property="workdate"
                  label="Join Date"
                  width="170"
                >
                  <template slot-scope="scope">
                    <div class="fs-13" style="color: #4A4A4A">
                      {{ getImportReviewFieldDisplay(scope.row, 'workdate', group.code) }}
                    </div>
                  </template>
                </el-table-column>

                <!-- Note -->
                <el-table-column
                  prop="note"
                  property="note"
                  :label="`Note`"
                >
                  <template slot-scope="scope">
                    <div class="fs-13" style="color: #4A4A4A">
                      {{ scope.row.note }}
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else style="text-align: center; height: 250px; margin-top: 200px">No results found...</div>
          <div class="mt-28" style="text-align: right">
            <el-button
              class="btn-cancel bigger"
              @click="importMembersStep = `select-${importMembersType}`"
              >Back</el-button
            >
            <el-button
              class="btn-add bigger"
              type="primary"
              @click="importMembersResolve"
              >{{ `Confirm` }}</el-button
            >
          </div>
        </div>
      </el-dialog>

      <!-- Review Updates Dialog -->
      <el-dialog
        :visible.sync="reviewUpdatesModalStatus"
        top="8vh"
        id="reviewUpdatesModal"
        @close="cancelReviewUpdates"
      >
        <div class="p-40">
          <div class="flex-center-1 fs-24 fc-000000 ml-10">
            <span class="fw-900">{{
              reviewUpdatesAll.length > 0
                ? $utils("addCommasInNumber", reviewUpdatesAll.length)
                : 0
            }}</span>
            <span class="fw-700">&nbsp;{{ $t("members.REVIEW_UPDATES") }}</span>
          </div>
          <div
            v-if="
              Object.keys(this.checkedReviewUpdates).filter(
                (k) => this.checkedReviewUpdates[k] === true
              ).length == 0
            "
            style="margin: 15px -15px 0px -40px"
          >
            &nbsp;
          </div>
          <div
            v-else
            class="flex-row-center height-bind ml-10"
            style="background-color: #6c30cc; margin: 15px -15px 0px -40px"
          >
            <span class="fs-18 fc-FFFFFF fw-700 ml-40"
              >{{
                $utils(
                  "addCommasInNumber",
                  Object.keys(this.checkedReviewUpdates).filter(
                    (k) => this.checkedReviewUpdates[k] === true
                  ).length
                )
              }}
              {{ $t("members.members_selected") }}</span
            >
            <div style="margin-left: 24px; display: flex">
              <div
                v-for="(item, index) in this.checkedDataReviewUpdates"
                :key="index"
              >
                <div v-if="index < 3">
                  <img
                    v-if="item.pic"
                    v-lazy="item.pic"
                    :alt="item.firstname + item.lastname"
                    class="viewMember image-skeleton image-profile-30"
                    :class="[ blurMode ?  'blurelement': '' ]"
                    v-bind:style="renderSelectedPic(index)"
                  />
                  <div
                    v-else
                    class="viewMember image image-profile-30"
                    :class="[ blurMode ?  'blurelement': '' ]"
                    v-bind:style="renderSelectedPic(index)"
                  >
                    <div class="text-in-image text-in-image-30 flex-mid">
                      {{
                        $utils("acronymName", {
                          firstName: item.firstname,
                          lastName: item.lastname,
                        })
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <span
              v-if="this.checkedDataReviewUpdates.length > 3"
              class="fs-14 fc-FFFFFF"
              style="margin-left: -10px"
              >+{{
                this.checkedDataReviewUpdates && this.checkedDataReviewUpdates.length > 3
                  ? this.checkedDataReviewUpdates.length - 3
                  : ""
              }}</span
            >

            <!-- Bulk Actions -->
            <div class="divActionHeader">
              <div
                v-if="bulkReAssignManagerStatus"
                class="btn btn-navbar bg-hover-barken-54279B"
                @click="bulkCommandReviewUpdates('reAssignManager')"
              >
                {{ $t("members.RE_ASSIGN_MANAGER") }}
              </div>
              <div
                v-else
                class="btn btn-navbar bg-hover-barken-54279B opa-05"
              >
                {{ $t("members.RE_ASSIGN_MANAGER") }}
              </div>

              <div
                v-if="bulkAddUserStatus"
                class="btn btn-navbar bg-hover-barken-54279B"
                @click="bulkCommandReviewUpdates('addUser')"
              >
                {{ $t("members.ADD") }}
              </div>
              <div
                class="btn btn-navbar bg-hover-barken-54279B opa-05"
                v-else
              >
                {{ $t("members.ADD") }}
              </div>

              <div
                v-if="bulkArchiveStatus"
                class="btn btn-navbar bg-hover-barken-54279B"
                @click="bulkCommandReviewUpdates('archive')"
              >
                {{ $t("members.ARCHIVE") }}
              </div>
              <div class="btn btn-navbar bg-hover-barken-54279B opa-05" v-else>
                {{ $t("members.ARCHIVE") }}
              </div>

              <div
                v-if="bulkIgnoreStatus"
                @click="bulkCommandReviewUpdates('ignore')"
                class="btn btn-navbar bg-hover-barken-54279B"
              >
                {{ $t("members.IGNORE") }}
              </div>
              <div class="btn btn-navbar bg-hover-barken-54279B opa-05" v-else>
                {{ $t("members.IGNORE") }}
              </div>
            </div>
          </div>

          <!-- Search bar -->
          <div v-if="false">
            <div class="flex-row-between mt-14 ml-12">
              <el-input
                class="input-style"
                style="height: 40px"
                autosize
                :placeholder="$t('members.Search')"
                v-model="inputSearchArchive"
                clearable
              ></el-input>
              <button
                @click="deleteArchiveAllClick"
                class="button btn-red cursor-pointer"
              >
                {{ $t("members.delete_all") }}
              </button>
            </div>
          </div>

          <!-- Card-based Review Updates -->
          <div class="mt-10">
            <!-- Select All Header -->
            <div class="review-cards-header" v-if="reviewUpdates && reviewUpdates.length > 0">
              <el-checkbox
                v-model="reviewUpdatesSelectAll"
                @change="handleReviewUpdatesSelectAll"
                :indeterminate="reviewUpdatesSelectIndeterminate"
              >
                <span class="fs-13">Select All</span>
              </el-checkbox>
            </div>

            <!-- Cards Container -->
            <div class="review-cards-container" v-if="!reviewUpdatesLoading">
              <div 
                v-for="(item, index) in reviewUpdates" 
                :key="item.key"
                class="review-card"
                :class="{ 'review-card-selected': checkedReviewUpdates['key_' + item.key] }"
              >
                <!-- Card Header -->
                <div class="review-card-header">
                  <div class="review-card-header-left">
                    <el-checkbox
                      v-model="checkedReviewUpdates['key_' + item.key]"
                      :key="item.key"
                      @change="membersCheckedReviewUpdates(item.key)"
                      class="review-card-checkbox"
                    />
                    <div class="review-card-avatar">
                      <img
                        v-if="item.pic"
                        v-lazy="item.pic"
                        :key="item.pic"
                        class="image-skeleton image-profile-42"
                        :class="[ blurMode ? 'blurelement': '' ]"
                      />
                      <div v-else class="image image-profile-42 flex-mid" :class="[ blurMode ? 'blurelement': '' ]">
                        <div class="text-in-image text-in-image-42 flex-mid">
                          {{ $utils("acronymName", { firstName: item.firstname, lastName: item.lastname }) }}
                        </div>
                      </div>
                    </div>
                    <div class="review-card-member-info">
                      <span class="review-card-name" :class="[ blurMode ? 'blurelement': '' ]">
                        {{ item.firstname }} {{ item.lastname }}
                      </span>
                      <span class="review-card-email" :class="[ blurMode ? 'blurelement': '' ]">
                        {{ item.email }}
                      </span>
                    </div>
                  </div>
                  <div class="review-card-header-center" v-if="item.requested_by || item.email_request">
                    <span class="review-card-requested-label" :class="[ blurMode ? 'blurelement': '' ]">Requested by</span>
                    <span class="review-card-requester-name" :class="[ blurMode ? 'blurelement': '' ]">{{ getRequesterInfo(item) ? getRequesterInfo(item).name : item.requested_by }}</span>
                    <el-popover
                      v-if="getRequesterInfo(item) && getRequesterInfo(item).team_name"
                      placement="top"
                      trigger="hover"
                      popper-class="team-hierarchy-popover"
                    >
                      <div class="team-hierarchy-content" v-if="getTeamHierarchyByName(getRequesterInfo(item).team_name)">
                        <div class="team-hierarchy-current">
                          <span class="team-hierarchy-label">Team</span>
                          <span class="team-hierarchy-name">{{ getRequesterInfo(item).team_name }}</span>
                        </div>
                        <div class="team-hierarchy-parent" v-if="getTeamHierarchyByName(getRequesterInfo(item).team_name).parent">
                          <span class="team-hierarchy-label">↑ Parent</span>
                          <span class="team-hierarchy-name">{{ getTeamHierarchyByName(getRequesterInfo(item).team_name).parent.name }}</span>
                        </div>
                        <div class="team-hierarchy-children" v-if="getTeamHierarchyByName(getRequesterInfo(item).team_name).children.length > 0">
                          <span class="team-hierarchy-label">↓ Sub-teams ({{ getTeamHierarchyByName(getRequesterInfo(item).team_name).children.length }})</span>
                          <span class="team-hierarchy-child" v-for="child in getTeamHierarchyByName(getRequesterInfo(item).team_name).children.slice(0, 5)" :key="child.key">{{ child.name }}</span>
                        </div>
                      </div>
                      <span slot="reference" class="review-card-requester-team review-card-team-hoverable" :class="[ blurMode ? 'blurelement': '' ]">
                        {{ getRequesterInfo(item).team_name }}
                      </span>
                    </el-popover>
                  </div>
                  <div class="review-card-header-right">
                    <!-- HRIS: create -->
                    <el-button
                      v-if="item.source == 'hris' && item.type === 'create'"
                      class="btnAddMember"
                      size="small"
                      icon="el-icon-plus"
                      @click="runCommandReviewUpdates(item.key)"
                    >{{ $t("members.ADD") }}</el-button>
                    <!-- HRIS: update -->
                    <el-button
                      v-if="item.source == 'hris' && item.type === 'update'"
                      class="btnAddMember"
                      size="small"
                      @click="runCommandReviewUpdates(item.key)"
                    >{{ $t("members.EDIT") }}</el-button>
                    <!-- HRIS: delete -->
                    <el-button
                      v-if="item.source == 'hris' && item.type === 'delete'"
                      class="btnDeleteMember"
                      size="small"
                      @click="runCommandReviewUpdates(item.key)"
                    >{{ $t("members.ARCHIVE") }}</el-button>
                    <!-- APP: add_member -->
                    <el-button
                      v-if="item.source == 'app' && item.type == 'add_member'"
                      class="btnAddMember"
                      size="small"
                      icon="el-icon-plus"
                      @click="runCommandReviewUpdates(item.key)"
                    >{{ $t("members.ADD") }}</el-button>
                    <!-- APP: other types -->
                    <el-button
                      v-if="item.source == 'app' && item.type != 'add_member'"
                      class="btnDeleteMember"
                      size="small"
                      @click="runCommandReviewUpdates(item.key)"
                    >{{ $t(getAppButtonLabelKey(item.type)) }}</el-button>
                  </div>
                </div>

                <!-- Card Body - Row 1: Team & Manager -->
                <div class="review-card-body">
                  <div class="review-card-row">
                    <!-- Team Field -->
                    <div class="review-card-field">
                      <label class="review-card-label">{{ $t('members.Team') }}</label>
                      <div class="review-card-comparison" v-if="canEdit(item, 'team')">
                        <el-popover
                          placement="top"
                          trigger="hover"
                          :disabled="!getOriginalValue(item, 'team', '')"
                          popper-class="team-hierarchy-popover"
                        >
                          <div class="team-hierarchy-content" v-if="getTeamHierarchy(getOriginalValue(item, 'team', ''))">
                            <div class="team-hierarchy-current">
                              <span class="team-hierarchy-label">Current Team</span>
                              <span class="team-hierarchy-name">{{ getOriginalValue(item, 'team_name', 'No team') }}</span>
                            </div>
                            <div class="team-hierarchy-parent" v-if="getTeamHierarchy(getOriginalValue(item, 'team', '')).parent">
                              <span class="team-hierarchy-label">↑ Parent</span>
                              <span class="team-hierarchy-name">{{ getTeamHierarchy(getOriginalValue(item, 'team', '')).parent.name }}</span>
                            </div>
                            <div class="team-hierarchy-children" v-if="getTeamHierarchy(getOriginalValue(item, 'team', '')).children.length > 0">
                              <span class="team-hierarchy-label">↓ Sub-teams ({{ getTeamHierarchy(getOriginalValue(item, 'team', '')).children.length }})</span>
                              <span class="team-hierarchy-child" v-for="child in getTeamHierarchy(getOriginalValue(item, 'team', '')).children.slice(0, 5)" :key="child.key">{{ child.name }}</span>
                              <span class="team-hierarchy-more" v-if="getTeamHierarchy(getOriginalValue(item, 'team', '')).children.length > 5">+{{ getTeamHierarchy(getOriginalValue(item, 'team', '')).children.length - 5 }} more</span>
                            </div>
                          </div>
                          <span slot="reference" class="review-card-original review-card-original-hoverable" :class="[ blurMode ? 'blurelement': '' ]">
                            {{ getOriginalValue(item, 'team_name', 'No team') }}
                          </span>
                        </el-popover>
                        <span class="review-card-arrow">→</span>
                        <el-select
                          v-model="reviewUpdates[index].team"
                          class="review-card-select-inline"
                          filterable
                          placeholder="Assign Team"
                          :class="[ blurMode ? 'blurelement': '' ]"
                        >
                          <el-option label="Assign Team" value=""></el-option>
                          <el-option
                            v-for="teamItem in teamOptions"
                            :key="`team_${teamItem.key}`"
                            :label="teamItem.value"
                            :value="teamItem.key"
                            :class="[ blurMode ? 'blurelement': '' ]"
                          >
                            <div class="team-option-item">
                              <div class="team-option-name">{{ teamItem.value }}</div>
                              <div class="team-option-parent" v-if="teamItem.parent_name">↑ {{ teamItem.parent_name }}</div>
                            </div>
                          </el-option>
                        </el-select>
                      </div>
                      <div v-else class="review-card-static-value" :class="[ blurMode ? 'blurelement': '' ]">
                        {{ item.team_name || '-' }}
                      </div>
                    </div>
                    <!-- Manager Field -->
                    <div class="review-card-field">
                      <label class="review-card-label">{{ $t('members.Manager') }}</label>
                      <div class="review-card-comparison" v-if="canEdit(item, 'manager')">
                        <div class="review-card-original-wrapper">
                          <span class="review-card-original" :class="[ blurMode ? 'blurelement': '' ]">
                            {{ getOriginalValue(item, 'manager_name', 'No manager') }}
                          </span>
                          <el-popover
                            v-if="getOriginalValue(item, 'manager_team_name', '')"
                            placement="top"
                            trigger="hover"
                            popper-class="team-hierarchy-popover"
                          >
                            <div class="team-hierarchy-content" v-if="getTeamHierarchyByName(getOriginalValue(item, 'manager_team_name', ''))">
                              <div class="team-hierarchy-current">
                                <span class="team-hierarchy-label">Team</span>
                                <span class="team-hierarchy-name">{{ getOriginalValue(item, 'manager_team_name', '') }}</span>
                              </div>
                              <div class="team-hierarchy-parent" v-if="getTeamHierarchyByName(getOriginalValue(item, 'manager_team_name', '')).parent">
                                <span class="team-hierarchy-label">↑ Parent</span>
                                <span class="team-hierarchy-name">{{ getTeamHierarchyByName(getOriginalValue(item, 'manager_team_name', '')).parent.name }}</span>
                              </div>
                              <div class="team-hierarchy-children" v-if="getTeamHierarchyByName(getOriginalValue(item, 'manager_team_name', '')).children.length > 0">
                                <span class="team-hierarchy-label">↓ Sub-teams ({{ getTeamHierarchyByName(getOriginalValue(item, 'manager_team_name', '')).children.length }})</span>
                                <span class="team-hierarchy-child" v-for="child in getTeamHierarchyByName(getOriginalValue(item, 'manager_team_name', '')).children.slice(0, 5)" :key="child.key">{{ child.name }}</span>
                              </div>
                            </div>
                            <span slot="reference" class="review-card-original-subtext review-card-team-hoverable" :class="[ blurMode ? 'blurelement': '' ]">
                              {{ getOriginalValue(item, 'manager_team_name', '') }}
                            </span>
                          </el-popover>
                          <span v-else class="review-card-original-subtext" :class="[ blurMode ? 'blurelement': '' ]"></span>
                        </div>
                        <span class="review-card-arrow">→</span>
                        <div class="review-card-new-wrapper">
                          <el-select
                            v-model="reviewUpdates[index].manager"
                            class="review-card-select-inline"
                            filterable
                            placeholder="Assign Manager"
                            :class="[ blurMode ? 'blurelement': '' ]"
                            :ref="`managerSelects[${item.key}]`"
                          >
                            <el-option label="Assign Manager" value=""></el-option>
                            <el-option
                              v-for="mgr in managerOptions"
                              :key="`manager_${mgr.key}`"
                              :label="mgr.value"
                              :value="mgr.email"
                              :class="[ blurMode ? 'blurelement': '' ]"
                            >
                              <div style="line-height: 16px; padding: 4px 0;">
                                <div>{{ mgr.value }}</div>
                                <div class="fs-12 opa-06">{{ mgr.team_name || 'No team' }}</div>
                              </div>
                            </el-option>
                          </el-select>
                          <el-popover
                            v-if="reviewUpdates[index].manager && getManagerTeamName(reviewUpdates[index].manager)"
                            placement="top"
                            trigger="hover"
                            popper-class="team-hierarchy-popover"
                          >
                            <div class="team-hierarchy-content" v-if="getTeamHierarchy(getManagerTeamKey(reviewUpdates[index].manager))">
                              <div class="team-hierarchy-current">
                                <span class="team-hierarchy-label">Team</span>
                                <span class="team-hierarchy-name">{{ getManagerTeamName(reviewUpdates[index].manager) }}</span>
                              </div>
                              <div class="team-hierarchy-parent" v-if="getTeamHierarchy(getManagerTeamKey(reviewUpdates[index].manager)).parent">
                                <span class="team-hierarchy-label">↑ Parent</span>
                                <span class="team-hierarchy-name">{{ getTeamHierarchy(getManagerTeamKey(reviewUpdates[index].manager)).parent.name }}</span>
                              </div>
                              <div class="team-hierarchy-children" v-if="getTeamHierarchy(getManagerTeamKey(reviewUpdates[index].manager)).children.length > 0">
                                <span class="team-hierarchy-label">↓ Sub-teams ({{ getTeamHierarchy(getManagerTeamKey(reviewUpdates[index].manager)).children.length }})</span>
                                <span class="team-hierarchy-child" v-for="child in getTeamHierarchy(getManagerTeamKey(reviewUpdates[index].manager)).children.slice(0, 5)" :key="child.key">{{ child.name }}</span>
                              </div>
                            </div>
                            <span slot="reference" class="review-card-new-subtext review-card-team-hoverable" :class="[ blurMode ? 'blurelement': '' ]">
                              {{ getManagerTeamName(reviewUpdates[index].manager) }}
                            </span>
                          </el-popover>
                          <span v-else-if="reviewUpdates[index].manager" class="review-card-new-subtext" :class="[ blurMode ? 'blurelement': '' ]">
                            {{ getManagerTeamName(reviewUpdates[index].manager) }}
                          </span>
                        </div>
                      </div>
                      <div v-else-if="!canEdit(item, 'manager')" class="review-card-static-value" :class="[ blurMode ? 'blurelement': '' ]">
                        {{ item.manager_name || '-' }}
                      </div>
                    </div>
                  </div>

                  <!-- Card Body - Row 2: Language & Country -->
                  <div class="review-card-row">
                    <!-- Language Field -->
                    <div class="review-card-field">
                      <label class="review-card-label">{{ $t('members.Language') }}</label>
                      <div class="review-card-comparison" v-if="canEdit(item, 'language')">
                        <span class="review-card-original" :class="[ blurMode ? 'blurelement': '' ]">
                          {{ getOriginalValue(item, 'language', 'th') === 'en' ? $t('members.English') : $t('members.Thai') }}
                        </span>
                        <span class="review-card-arrow">→</span>
                        <el-select
                          v-model="reviewUpdates[index].language"
                          class="review-card-select-inline review-card-select-sm"
                          :class="[ blurMode ? 'blurelement': '' ]"
                        >
                          <el-option :label="$t('members.English')" value="en"></el-option>
                          <el-option :label="$t('members.Thai')" value="th"></el-option>
                        </el-select>
                      </div>
                      <div v-else class="review-card-static-value" :class="[ blurMode ? 'blurelement': '' ]">
                        {{ item.language === 'en' ? $t('members.English') : $t('members.Thai') }}
                      </div>
                    </div>
                    <!-- Country Field -->
                    <div class="review-card-field">
                      <label class="review-card-label">{{ $t('members.Country') }}</label>
                      <div class="review-card-comparison" v-if="canEdit(item, 'country')">
                        <span class="review-card-original" :class="[ blurMode ? 'blurelement': '' ]">
                          {{ getOriginalValue(item, 'country', 'Not set') }}
                        </span>
                        <span class="review-card-arrow">→</span>
                        <el-select
                          v-model="reviewUpdates[index].country"
                          class="review-card-select-inline"
                          filterable
                          :class="[ blurMode ? 'blurelement': '' ]"
                        >
                          <el-option
                            v-for="loc in locationOption"
                            :key="loc.value"
                            :label="loc.value"
                            :value="loc.lable"
                          ></el-option>
                        </el-select>
                      </div>
                      <div v-else class="review-card-static-value" :class="[ blurMode ? 'blurelement': '' ]">
                        {{ item.country || '-' }}
                      </div>
                    </div>
                  </div>

                  <!-- Archived Type (shown only when applicable) -->
                  <div class="review-card-row" v-if="canEdit(item, 'archived_type')">
                    <div class="review-card-field">
                      <label class="review-card-label">{{ $t('members.Archived_Type') }}</label>
                      <el-dropdown @command="handleArchivedType" trigger="click">
                        <span class="review-card-dropdown-trigger">
                          <span>{{ item.archived_type || 'Select type' }}</span>
                          <i class="el-icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            :command="{ type: 'Resigned', item: item }"
                            :disabled="'Resigned' == item.archived_type"
                          >Resigned</el-dropdown-item>
                          <el-dropdown-item
                            :command="{ type: 'Terminated', item: item }"
                            :disabled="'Terminated' == item.archived_type"
                          >Terminated</el-dropdown-item>
                          <el-dropdown-item
                            :command="{ type: 'Other', item: item }"
                            :disabled="'Other' == item.archived_type"
                          >Other</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <div class="review-card-field"></div>
                  </div>
                </div>
              </div>

              <!-- Empty State -->
              <div v-if="!reviewUpdates || reviewUpdates.length === 0" class="review-cards-empty">
                No pending updates to review
              </div>
            </div>

            <!-- Loading State -->
            <div class="center mt-10 mb-40 pt-10 pb-40" v-if="reviewUpdatesLoading">
              <loading-even></loading-even>
            </div>
          </div>
          <div class="flex-center pagination mt-10">
            <el-pagination
              @current-change="handleReviewUpdatesCurrentChange"
              :current-page="pageReviewUpdates"
              :page-size="10"
              :pager-count="5"
              layout="prev, pager, next"
              :total="reviewUpdatesTotal"
            ></el-pagination>
            <span class="results-status">
              {{ reviewUpdatesTotal > 10 ? 10 : reviewUpdatesTotal }}
              {{ $t("members.results_from") }}
              {{ $utils("addCommasInNumber", reviewUpdatesTotal) }}
              {{ $t("members.results") }}
            </span>
          </div>
        </div>
      </el-dialog>

    </div>
    <div id="managerWarmingModal">
      <el-dialog
        title=""
        :visible.sync="completeManagerWarmingModal"
        width="540px"
      >
        <div class="center mt-10">
          <div class="fs-20 fw-700 fc-2D2E36">
            {{ $t("members.Complete_manager_assignment") }}
          </div>
          <div class="fs-16 fc2D2E36 mt-24 px-40 word-break">
            <span class="fw-700">
              {{
                completeManagerWarmingData.firstname +
                " " +
                completeManagerWarmingData.lastname
              }}
            </span>
            {{ $t("members.is_missing_a_direct") }}
          </div>
        </div>
        <div style="margin-top: 60px" class="flex-mid">
          <el-button
            class="btn btn-add"
            style="width: 360px; height: 50px"
            @click="showReAssignManagerModal('complete')"
            >{{ $t("members.SELECT_DIRECT_MANAGER") }}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        title=""
        :visible.sync="reAssignManagerWarmingModal"
        width="540px"
      >
        <div class="center mt-10">
          <div class="fs-20 fw-700 fc-2D2E36">
            <div>Re-assign a manager to replace</div>
            <div>the archived manager</div>
          </div>
          <div class="fs-16 fc2D2E36 mt-24 px-40 word-break">
            <span class="fw-700">
              {{
                reAssignManagerWarmingData.firstname +
                " " +
                reAssignManagerWarmingData.lastname
              }}
            </span>
            {{ $t("members.has_been_archived_leaving") }}
            {{ reAssignManagerWarmingData.member }}
            {{ $t("members.members_without_a_direct") }}
          </div>
        </div>
        <div style="margin-top: 60px" class="flex-mid">
          <el-button
            class="btn btn-add"
            style="width: 360px; height: 50px"
            @click="showReAssignManagerModal('reassign')"
            >{{ $t("members.RE_ASSIGN_MANAGER") }}</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div id="reAssignManagerModal">
      <el-dialog :visible.sync="reAssignManagerModal" top="8vh">
        <el-col :span="8" class="first-column-modal rm-scrollbar">
          <div class="fs-20 fc-2D2E36 fw-700 mb-6">
            {{
              subCheckedData.length > 0
                ? $utils("addCommasInNumber", subCheckedData.length)
                : 0
            }}
            {{ $t("members.members_selected") }}
          </div>
          <div
            v-for="(user, index) in subCheckedData"
            :key="index + user.email"
            @click="ManagerSelectedClick(user, index)"
            class="flex-center py-8 cursor-pointer"
          >
            <div class="flex-mid">
              <img
                v-if="user.pic"
                v-lazy="user.pic"
                :alt="user.firstname + ' ' + user.lastname"
                :key="user.pic"
                class="image-skeleton image-profile-42 flex-mid mr-12"
              />
              <div v-else class="image image-profile-42 flex-mid mr-12">
                <div class="text-in-image text-in-image-42 flex-mid">
                  {{
                    $utils("acronymName", {
                      firstName: user.firstname,
                      lastName: user.lastname,
                    })
                  }}
                </div>
              </div>
            </div>
            <div class="flex-column">
              <span class="text-name"
                >{{ user.firstname }} {{ user.lastname }}</span
              >
              <span class="text-email">{{ user.email }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="16" class="second-column-modal">
          <div class="fs-24 fc-2D2E36 fw-700 mb-20">
            {{ $t("members.Re_Assign_Manager") }}
          </div>
          <el-input
            class="input-style"
            v-model="manager_assign_disp"
            auto-complete="off"
            :placeholder="$t('members.Search_manager_name')"
            @input="handleInputManagerReAssign"
          ></el-input>
          <div class="fs-14 fc-4A4A4A my-24">
            {{ $t("members.Suggestions_based_on_member") }}
          </div>
          <div class="grid-2">
            <div
              v-for="(item, index) in this.managerSuggest"
              :key="index"
              class="card bd-r-3 cursor-pointer"
              @click="assignManagerActiveClick(item, index)"
              :class="{ 'active-card': selectedManagerForAssign === index }"
            >
              <div class="flex-center">
                <div class="flex-mid">
                  <img
                    v-if="item.pic"
                    v-lazy="item.pic"
                    :alt="item.firstname + item.lastname"
                    :key="item.pic"
                    class="image-skeleton image-profile-40 flex-mid mr-12"
                  />
                  <div v-else class="image image-profile-40 flex-mid mr-12">
                    <div class="text-in-image text-in-image-40 flex-mid">
                      {{
                        $utils("acronymName", {
                          firstName: item.firstname,
                          lastName: item.lastname,
                        })
                      }}
                    </div>
                  </div>
                </div>
                <div class="flex-column" style="width: 150px">
                  <span class="text-name"
                    >{{ item.firstname }} {{ item.lastname }}</span
                  >
                  <span class="text-email">{{ item.email }}</span>
                </div>
                <div class="div-active" style="margin-left: auto">
                  <div class="btn-status" :class="[`status-${item.status}`]">
                    {{ item.status }}
                  </div>
                  <div class="active">{{ item.to_now }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-reverse mt-30">
            <el-button
              class="btn primary"
              style="margin-left: 12px"
              @click="reAssignManagerModalSubmit"
              >{{ $t("members.SUBMIT") }}</el-button
            >
            <el-button
              class="btn secondary"
              @click="reAssignManagerModal = !reAssignManagerModal"
              >{{ $t("members.CANCEL") }}</el-button
            >
          </div>
        </el-col>
      </el-dialog>
    </div>
    <div id="archiveMember">
      <el-dialog
        title=""
        width="560px"
        :visible.sync="archiveMutipleMemberModal"
        top="8vh"
      >
        <div class="center word-break" style="padding: 10px 50px">
          <div class="fs-20 fw-700 fc-2D2E36">
            Are you sure you want to archive the
            {{ this.checkedData.length }}
            selected members?
          </div>
          <div class="fs-16 fc-2D2E36 mt-24">
            Once archived, the members will be logged out of Happily and will
            not be able to log in again.
          </div>
          <div class="fs-16 fc-2D2E36 mt-16">
            Archived members can be restored at a later time.
          </div>
          <div class="pl-20 pr-20">
            <div class="relative mt-24 mb-24">
              <el-date-picker
                v-model="dateAcchivePicker"
                value-format="yyyy-MM-dd HH:mm"
                type="datetime"
                :picker-options="pickerOptions"
                @change="checkNowPicker"
                placeholder=""
                style="width: 100%"
                :format="`MMMM d hh:mm A`"
                default-time="23:59:00"
                :editable="false"
                popper-class="hide-btn-picker-time"
              >
              </el-date-picker>
              <div
                v-if="!dateAcchivePicker"
                class="absolute-mid fs-18 events-none"
                style="left: 56px"
              >
                Now
              </div>
            </div>
            <el-dropdown @command="archiveMemberByGroupType" @click="confirmArchiveMember" class="ml-18">
              <div @click="handleArchiveButtonClick" class="btn btn-archive">
                ARCHIVE
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="Resigned">Resigned</el-dropdown-item>
                <el-dropdown-item command="Terminated"
                  >Terminated</el-dropdown-item
                >
                <el-dropdown-item command="Other">Other</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/database";
import "firebase/firestore";
import { dragscroll } from "vue-dragscroll";
import format from "date-fns/format";
import Chart from "chart.js/auto";
export default {
  directives: {
    dragscroll,
  },
  name: "members",
  components: {
    loadingEven: require("../even/loading").default,
    downloadProgress: require("../even/download-progress").default,
    Member: require("@/components/content/user-profile-details").default,
  },
  data() {
    return {
      id: "",
      mode: "",
      checked: [],
      checkedArchive: [],
      checkedData: [],
      checkedDataArchive: [],
      OptuserType: {
        user: "👩🏻 Member",
        hr: "👩🏻‍💻 HR",
        admin: "✍🏻 Admin",
        developer: "🛠️ Developer",
        leadership: "👩🏻‍💼 Leadership",
        superleader: "🦸🏻‍♀️ Super Leader",
        superadmin: "🙆🏻‍♀️ Super Admin",
        ghost: "👻 Ghost",
      },
      multipleSelection: [],
      type: "all",
      showSnackbar: false,
      exportingContext: false,
      exportingCsv: false,
      isInfinity: false,
      dialogFormVisible: false,
      activeProfileTab: "information",
      directReportsData: {},
      // directReportsData: {
      //   total: 2,
      //   directReport: [
      //     {
      //       id: "idbrabra1",
      //       firstname: "First",
      //       lastname: "lastName",
      //       email: "name@workemail.com",
      //       teamName: "Team Name",
      //       status: "active",
      //       to_now: "2 hours ago"
      //     },
      //     {
      //       id: "idbrabra2",
      //       firstname: "Second",
      //       lastname: "lastName",
      //       email: "name2@workemail.com",
      //       teamName: "Team Name",
      //       status: "active",
      //       to_now: "1 hours ago"
      //     }
      //   ]
      // },
      validateForm: {
        pic: "",
        firstname: "",
        lastname: "",
        nickname: "",
        email: "",
        dispteam: "",
        team_color: "",
        dispboss: "",
        team: "",
        boss: "",
        tmp_boss: "",
        boss_pic: "",
        boss_firstname: "",
        boss_lastname: "",
        language: "th",
        country: "TH",
        time_zone: "+07:00",
        user_type: "user",
        // invite: true,
        status: "new",
        to_now: "",
        streak_count: 0,
        super_feedback_count: 0,
        medal: [],
        coin: 0,
        gem: 0,
        house: "",
        joined: "",
        joined_tooltips: [],
        dispmanager: "",
        introduce: "",
        culture_add_percentile: "",
        birthday_month: "",
        birthday_day: "",
        workdate: "",
      },
      advancedInfoCollapsed: true,
      activeName: "powers",
      assignManagerModalStatus: false,
      selectedManagerForAssign: null,
      managerSuggest: [],
      managerSuggest_temp: [],
      assignManager: "",
      manager_assign_disp: "",
      assignTeamModalStatus: false,
      selectedTeamForAssign: null,
      teamSuggest: [],
      teamSuggest_temp: [],
      assignTeam: "",
      team_assign_disp: "",
      // Inline team editing
      editingTeamMemberKey: null,
      editingTeamRow: null,
      inlineTeamValue: "",
      inlineTeamData: {
        key: "",
        color: "",
        name: "",
      },
      inlineTeamValidationMsg: "",
      // Inline manager editing
      editingManagerMemberKey: null,
      editingManagerRow: null,
      inlineManagerValue: "",
      inlineManagerData: {
        email: "",
        firstname: "",
        lastname: "",
        pic: "",
      },
      inlineManagerValidationMsg: "",
      switchToArchive: false,
      archivedModalStatus: false,
      checkAll: [],
      checkAll_temp: false,
      checkAllArchive: [],
      checkAllArchive_temp: false,
      checkedAutoSendInvit: true,
      houseOptions: [
        { value: '-LWPrZbcyHAVHIFUsWLd', label: 'House of Corvus', image: 'Corvus_32@2x' },
        { value: '-LWOr-XsbZM2digYl1QL', label: 'House of Delphinus', image: 'Delphinus_32@2x' },
        { value: '-LWPrOElCYViBd6j6qP-', label: 'House of Leonos', image: 'Leonos_32@2x' }
      ],
      originalHouseValue: '',
      reAssignManagerWarmingModal: false,
      reAssignManagerWarmingData: {
        firstname: "",
        lastname: "",
        member: 0,
        email: "",
      },
      completeManagerWarmingModal: false,
      completeManagerWarmingData: {
        firstname: "",
        lastname: "",
        email: "",
      },
      reAssignManagerModal: false,
      selectedManagerForReAssign: null,
      manager_assign_disp: "",
      subCheckedData: [],
      managerSuggest: [],
      managerSuggest_temp: [],
      reAssignManager: "",
      archiveMutipleMemberModal: false,
      dateAcchivePicker: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        },
        selectableRange: "",
      },
      dateArchive: "",
      // powerData: [
      //   {
      //     label: "Empathy",
      //     value: 4361,
      //     maxValue: 4590,
      //     icon: "ic_empathy",
      //   },
      // ],
      scheduledArchive: false,
      selcetedArchiveSchedule: false,
      selcetedArchiveScheduleBoth: false,

      // Review Updates
      reviewUpdatesModalStatus: false,
      checkedReviewUpdates: [],
      checkedDataReviewUpdates: [],
      checkAllReviewUpdates: [],
      checkAllReviewUpdates_temp: false,
      bulkReAssignManagerStatus: false,
      bulkAddUserStatus: false,
      bulkArchiveStatus: false,
      bulkIgnoreStatus: true,

      // Import Members
      importMembersModalStatus: false,
      importMembersType: "file",
      importMembersStep: "select", // select, select-file, select-text
      importMembersFileList: [],
      importMembersText: "",
      showMenu: false,
      importMembersSearch: "",
      // importMembersTableDataGroups: [], // @see getters integrations/importMembersTableDataGroups
      
      // Attrition Chart
      attritionChart: null,
      attrition_bar_chart: null,
      
      // Archive Member Happiness Data Hover
      archivedHappinessPatterns: {},  // Store happiness data for archived users
      loadingArchivedPatterns: {},    // Track loading states for each user
      hoveredArchiveUser: null,       // Track current hovered user

      // Archive Expandable Detail Card
      expandedArchiveData: {},      // Cached detail data keyed by email
      loadingArchiveDetail: {},     // Loading states keyed by email
    };
  },
  created() {
    this.$store.dispatch("newmember/getOrganization");
    this.$store.dispatch("newmember/getMember", this.user);
    this.$store.dispatch("newmember/getTeamAll", this.user);
    this.$store.dispatch("newmember/getTimezone", this.user);
    // this.$store.dispatch("newmember/checkEndingloopTeamParent", this.user);
    this.$store.commit("authen/setActiveIndex", "2");
    // this.riskData = mockData;
    this.datePickerUpdateTime();

    // @todo realtime update review updates total (balloon number)
    this.getReviewUpdatesTotal();
    this.$root.$on('archivedModalClick', () => this.archivedModalClick());
    this.$root.$on('clickReviewUpdates', () => this.clickReviewUpdates());
    this.$root.$on('addMember', () => this.addMember());
  },
  mounted() {
    // Render the attrition chart if archived data is available
    this.$nextTick(() => {
      this.renderAttritionChart();
    });
  },
  beforeDestroy() {
    // Clean up the chart instance
    if (this.attrition_bar_chart) {
      this.attrition_bar_chart.destroy();
      this.attrition_bar_chart = null;
    }
  },
  watch: {
    inputSearch() {
      this.$store.dispatch("newmember/searchMembers", this.inputSearch);
    },
    inputSearchArchive() {
      this.$store.dispatch(
        "newmember/searchMembersArchive",
        this.inputSearchArchive
      );
    },
    allUser() {
      // this.$store.dispatch("newmember/getMember", this.user);
      this.$store.dispatch("newmember/getTeamAll", this.user);
    },
    importMembersSearch() {
      this.$store.dispatch("integrations/importMembersSearch", this.importMembersSearch);
    },
    resultsArchive() {
      this.$nextTick(() => { this.renderAttritionChart(); });
    },
    archivedModalStatus() {
      // Render chart and load eNPS when modal opens
      if (this.archivedModalStatus) {
        this.$nextTick(() => {
          this.renderAttritionChart();
          this.loadArchiveEnpsForPage();
        });
      }
    },
    membersArchive() {
      if (this.archivedModalStatus) {
        this.$nextTick(() => { this.loadArchiveEnpsForPage(); });
      }
    },
    teamParentByKey() {
      if (
        Object.keys(this.teamParentByKey).filter((k) => this.teamParentByKey[k])
          .length > 0
      ) {
        let memberData = this.checkedData;
        this.teamSuggest = [];
        this.teamSuggest_temp = [];
        this.assignTeam = "";
        this.selectedTeamForAssign = null;
        for (const i in memberData) {
          if (this.teamSuggest.length < 8) {
            if (memberData[i].boss) {
              /*direc manager*/
              let bossKeyID = memberData[i].boss.replace(/\./g, "||");
              if (
                this.membersByKey[bossKeyID] &&
                this.membersByKey[bossKeyID].team
              ) {
                let teamIdBoss = this.membersByKey[bossKeyID].team;
                let chk_teamExist = _.filter(this.teamSuggest, {
                  key: teamIdBoss,
                });
                if (chk_teamExist.length == 0) {
                  let teamData = this.teamByKey[teamIdBoss];
                  teamData.key = teamIdBoss;
                  teamData.color_code = teamData.color
                    ? teamData.color.replace(/#/g, "")
                    : "747474";
                  teamData.boss_pic = this.teamParentByKey[teamIdBoss]
                    ? this.teamParentByKey[teamIdBoss].pic
                    : "";
                  teamData.boss_name = this.teamParentByKey[teamIdBoss]
                    ? this.teamParentByKey[teamIdBoss].boss_firstname +
                      " " +
                      this.teamParentByKey[teamIdBoss].boss_lastname
                    : "";
                  teamData.count_member_team = this.teamParentByKey[teamIdBoss]
                    ? this.teamParentByKey[teamIdBoss].sup.length
                    : 0;
                  this.teamSuggest.push(teamData);
                  this.teamSuggest_temp.push(teamData);
                }

                /*share direct manager*/
                if (this.teamByKey[teamIdBoss]) {
                  let shareTeam = _.filter(this.team, { parent: teamIdBoss });
                  if (shareTeam.length > 0) {
                    for (const j in shareTeam) {
                      if (this.teamSuggest.length < 8) {
                        if (this.teamByKey[shareTeam[j].key]) {
                          let chk_teamExist = _.filter(this.teamSuggest, {
                            key: shareTeam[j].key,
                          });
                          if (chk_teamExist.length == 0) {
                            let teamData = this.teamByKey[shareTeam[j].key];
                            teamData.key = shareTeam[j].key;
                            teamData.color_code = teamData.color
                              ? teamData.color.replace(/#/g, "")
                              : "747474";
                            teamData.boss_pic = this.teamParentByKey[
                              shareTeam[j].key
                            ]
                              ? this.teamParentByKey[shareTeam[j].key].pic
                              : "";
                            teamData.boss_name = this.teamParentByKey[
                              shareTeam[j].key
                            ]
                              ? this.teamParentByKey[shareTeam[j].key]
                                  .boss_firstname +
                                " " +
                                this.teamParentByKey[shareTeam[j].key]
                                  .boss_lastname
                              : "";
                            teamData.count_member_team = this.teamParentByKey[
                              shareTeam[j].key
                            ]
                              ? this.teamParentByKey[shareTeam[j].key].sup
                                  .length
                              : 0;
                            this.teamSuggest.push(teamData);
                            this.teamSuggest_temp.push(teamData);
                          }
                        }
                      } else {
                        return;
                      }
                    }
                  }
                }
              }
              /*selected member*/
              let selected_team_parent = _.filter(this.team, {
                parent: memberData[i].team,
              });
              if (selected_team_parent.length > 0) {
                for (const k in selected_team_parent) {
                  if (this.teamSuggest.length < 8) {
                    if (this.teamByKey[selected_team_parent[k].key]) {
                      let chk_teamExist = _.filter(this.teamSuggest, {
                        key: selected_team_parent[k].key,
                      });
                      if (chk_teamExist.length == 0) {
                        let teamData =
                          this.teamByKey[selected_team_parent[k].key];
                        teamData.key = selected_team_parent[k].key;
                        teamData.color_code = teamData.color
                          ? teamData.color.replace(/#/g, "")
                          : "747474";
                        teamData.boss_pic = this.teamParentByKey[
                          selected_team_parent[k].key
                        ]
                          ? this.teamParentByKey[selected_team_parent[k].key]
                              .pic
                          : "";
                        teamData.boss_name = this.teamParentByKey[
                          selected_team_parent[k].key
                        ]
                          ? this.teamParentByKey[selected_team_parent[k].key]
                              .boss_firstname +
                            " " +
                            this.teamParentByKey[selected_team_parent[k].key]
                              .boss_lastname
                          : "";
                        teamData.count_member_team = this.teamParentByKey[
                          selected_team_parent[k].key
                        ]
                          ? this.teamParentByKey[selected_team_parent[k].key]
                              .sup.length
                          : 0;
                        this.teamSuggest.push(teamData);
                        this.teamSuggest_temp.push(teamData);
                      }
                    }
                  } else {
                    return;
                  }
                }
              }
            }
          } else {
            return;
          }
        }
      }
    },
    managerMembers() {
      if (
        Object.keys(this.managerMembers).length > 0 &&
        !this.completeManagerWarmingModal
      ) {
        Object.entries(this.managerMembers).forEach(([key, value]) => {
          this.reAssignManagerWarmingData.firstname =
            this.allArchiveData[key].firstname;
          this.reAssignManagerWarmingData.lastname =
            this.allArchiveData[key].lastname;
          this.reAssignManagerWarmingData.email =
            this.allArchiveData[key].email;
          this.reAssignManagerWarmingData.member = value.length;
          this.subCheckedData = value;
          this.managerSuggest = [];
          this.managerSuggest_temp = [];
          this.reAssignManager = "";
          if (this.allArchiveData[key].boss) {
            let bossKeyID = this.allArchiveData[key].boss.replace(/\./g, "||");
            if (this.membersByKey[bossKeyID]) {
              this.managerSuggest.push(this.membersByKey[bossKeyID]);
              this.managerSuggest_temp.push(this.membersByKey[bossKeyID]);
            }
          }

          this.reAssignManagerWarmingModal = true;
          return;
        });
      }
    },
    reviewUpdatesLoading(val) {
      if (val === false) {
        // default el-select (change email of manager to manager name)
        const delay = 500;
        setTimeout(() => {
          const reviewUpdates = this.$store.getters["integrations/reviewUpdates"];
          for (const i in reviewUpdates) {
            const item = reviewUpdates[i];
            const key = item.key;
            const refKey = `managerSelects[${key}]`;
            if (_.has(this.$refs, refKey)) {
              const ref = _.get(this.$refs, refKey);
              const manager = item.manager;
              if (!manager) continue;
              ref.selectedLabel = _.get(item, "manager_name", "");
              ref.selected.currentLabel = ref.selectedLabel;
            }
          }
        }, delay);
      }
    },
  },
  async beforeDestroy() {
    if (this.updateMember == true) {
      await this.$store.dispatch("main/getuser", true);
    }
  },
  computed: {
    monthOptions() {
      return [
        { value: 1, label: 'January' },
        { value: 2, label: 'February' },
        { value: 3, label: 'March' },
        { value: 4, label: 'April' },
        { value: 5, label: 'May' },
        { value: 6, label: 'June' },
        { value: 7, label: 'July' },
        { value: 8, label: 'August' },
        { value: 9, label: 'September' },
        { value: 10, label: 'October' },
        { value: 11, label: 'November' },
        { value: 12, label: 'December' },
      ]
    },
    dayOptions() {
      const days = []
      for (let i = 1; i <= 31; i++) {
        days.push({ value: i, label: String(i) })
      }
      return days
    },
    inputSearch: {
      get() {
        return this.$store.getters["newmember/inputSearch"];
      },
      set(value) {
        this.$store.commit("newmember/setinputSearch", {
          keyword: value,
          userstatus: this.type,
        });
      },
    },
    inputSearchArchive: {
      get() {
        return this.$store.getters["newmember/inputSearchArchive"];
      },
      set(value) {
        this.$store.commit("newmember/setinputSearchArchive", {
          keyword: value,
        });
      },
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    datamembers() {
      return this.$store.getters["newmember/datamembers"];
    },
    members() {
      // this.loadingMemberTable = ++this.loadingMemberTable;
      return this.$store.getters["newmember/members"];
    },
    team() {
      return this.$store.getters["newmember/team"];
    },
    dataexport() {
      return this.$store.getters["newmember/dataexport"];
    },
    exportFileName() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      const memberCount = this.dataexport ? this.dataexport.length : 0;
      return `Members_Export_${year}-${month}-${day}_${memberCount}Members.csv`;
    },
    page() {
      return this.$store.getters["newmember/page"];
    },
    pagearchive() {
      return this.$store.getters["newmember/pagearchive"];
    },
    results() {
      return this.$store.getters["newmember/results"];
    },
    resultsArchive() {
      return this.$store.getters["newmember/resultsArchive"];
    },
    modalMemberData() {
      return this.$store.getters["newmember/modalMemberData"];
    },
    membersByKey() {
      return this.$store.getters["newmember/membersByKey"];
    },
    membersArchiveByKey() {
      return this.$store.getters["newmember/membersArchiveByKey"];
    },
    bossByKey() {
      return this.$store.getters["newmember/bossByKey"];
    },
    teamByKey() {
      return this.$store.getters["newmember/teamByKey"];
    },
    teamParentByKey() {
      return this.$store.getters["newmember/teamParentByKey"];
    },
    membersArchive() {
      return this.$store.getters["newmember/membersArchive"];
    },
    membersArchiveAll() {
      return this.$store.getters["newmember/membersArchiveAll"];
    },
    incomplete() {
      return this.$store.getters["newmember/incomplete"];
    },
    loadingMemberTable() {
      return this.$store.getters["newmember/loadingMemberTable"];
    },
    loadingArchiveTable() {
      return this.$store.getters["newmember/loadingArchiveTable"];
    },
    passProfileToRelationship() {
      let passProfile = {
        firstname: this.validateForm.firstname || "",
        lastname: this.validateForm.lastname || "",
        teamColor: this.validateForm.house_color || "",
        house: this.validateForm.house || "",
        pic: this.validateForm.large_pic || false,
      };
      return passProfile;
    },
    membersByKey() {
      return this.$store.getters["newmember/membersByKey"];
    },
    allArchiveData() {
      return this.$store.getters["newmember/allArchiveData"];
    },
    managerMembers() {
      return this.$store.getters["newmember/managerMembers"];
    },
    riskData() {
      return this.$store.getters["newmember/riskData"];
    },
    loadingLoadMoreData() {
      return this.$store.getters["newmember/loadingLoadMoreData"];
    },
    powerData() {
      return this.$store.getters["newmember/powerData"];
    },
    archivedSchedule() {
      return this.$store.getters["newmember/archivedSchedule"];
    },
    timeZoneOption() {
      return this.$store.getters["newmember/timeZoneOption"];
    },
    locationOption() {
      return this.$store.getters["newmember/locationOption"];
    },
    allUser() {
      return this.$store.getters["main/allUser"];
    },
    updateMember() {
      return this.$store.getters["newmember/updateMember"];
    },
    /* Review Updates */
    reviewUpdates() {
      return this.$store.getters["integrations/reviewUpdates"]; 
    },
    reviewUpdatesAll() {
      return this.$store.getters["integrations/reviewUpdatesAll"];
    },
    reviewUpdatesLoading() {
      return this.$store.getters["integrations/reviewUpdatesLoading"];
    },
    reviewUpdatesTotal() {
      return this.$store.getters["integrations/reviewUpdatesTotal"];
    },
    reviewUpdatesPage() {
      return this.$store.getters["integrations/reviewUpdatesPage"];
    },
    reviewUpdatesByKey() {
      return this.$store.getters["integrations/reviewUpdatesByKey"];
    },
    pageReviewUpdates() {
      return this.$store.getters["integrations/pageReviewUpdates"];
    },
    reviewUpdatesSelectAll: {
      get() {
        if (!this.reviewUpdates || this.reviewUpdates.length === 0) return false;
        return this.reviewUpdates.every(item => this.checkedReviewUpdates['key_' + item.key]);
      },
      set(val) {
        // handled by handleReviewUpdatesSelectAll
      }
    },
    reviewUpdatesSelectIndeterminate() {
      if (!this.reviewUpdates || this.reviewUpdates.length === 0) return false;
      const checkedCount = this.reviewUpdates.filter(item => this.checkedReviewUpdates['key_' + item.key]).length;
      return checkedCount > 0 && checkedCount < this.reviewUpdates.length;
    },
    teamOptions() {
      return this.createOptions("querySearchTeam");
    },
    managerOptions() {
      return this.createOptions("querySearchManager");
    },
    importMembersTableDataGroups() {
      return this.$store.getters["integrations/importMembersTableDataGroups"];
    },
    importMembersTableDataGroupsTotal() {
      return this.$store.getters["integrations/importMembersTableDataGroupsTotal"];
    },
    hasValidArchiveDates() {
      if (!this.resultsArchive || this.resultsArchive.length === 0) {
        return false;
      }
      
      return this.resultsArchive.some(member => {
        const hasDate = member.exitdated || member.archive_date || member.archived_timestamp;
        if (!hasDate) return false;
        
        const archiveDate = new Date(member.exitdated || member.archive_date || member.archived_timestamp);
        return !isNaN(archiveDate.getTime());
      });
    },
  },
  methods: {
        /**
     * Renders an attrition chart showing the number of archived employees by month and type
     * This helps visualize employee attrition trends over time with breakdown by archive type
     */
    renderAttritionChart() {
      if (!this.resultsArchive || this.resultsArchive.length === 0) {
        return;
      }

      // Destroy existing chart if it exists
      if (this.attrition_bar_chart) {
        this.attrition_bar_chart.destroy();
        this.attrition_bar_chart = null;
      }

      const ctx = this.$refs.attritionChart;
      if (!ctx) {
        return;
      }

      // Process the archived data to group by month and type
      const monthlyData = {};
      let earliestDate = null;
      let latestDate = null;
      
      this.resultsArchive.forEach(member => {
        let archiveDate = null;
        
        // Extract archive date from the member data
        if (member.exitdated) {
          archiveDate = new Date(member.exitdated);
        } else if (member.archive_date) {
          archiveDate = new Date(member.archive_date);
        } else if (member.archived_timestamp) {
          archiveDate = new Date(member.archived_timestamp);
        }

        if (archiveDate && !isNaN(archiveDate.getTime())) {
          // Track earliest and latest dates
          if (!earliestDate || archiveDate < earliestDate) {
            earliestDate = archiveDate;
          }
          if (!latestDate || archiveDate > latestDate) {
            latestDate = archiveDate;
          }
          
          const monthKey = format(archiveDate, 'YYYY-MM');
          const archiveType = member.archive_type || 'Other';
          
          if (!monthlyData[monthKey]) {
            monthlyData[monthKey] = {
              'Resigned': 0,
              'Terminated': 0,
              'Other': 0
            };
          }
          
          monthlyData[monthKey][archiveType] = (monthlyData[monthKey][archiveType] || 0) + 1;
        }
      });

      // If no data, show a message
      if (!earliestDate || !latestDate) {
        return;
      }

      // Generate all months between earliest and latest dates
      const allMonths = [];
      const currentDate = new Date(earliestDate.getFullYear(), earliestDate.getMonth(), 1);
      const endDate = new Date(latestDate.getFullYear(), latestDate.getMonth(), 1);
      
      while (currentDate <= endDate) {
        const monthKey = format(currentDate, 'YYYY-MM');
        allMonths.push(monthKey);
        
        // Ensure each month has data structure, even if no employees were archived
        if (!monthlyData[monthKey]) {
          monthlyData[monthKey] = {
            'Resigned': 0,
            'Terminated': 0,
            'Other': 0
          };
        }
        
        currentDate.setMonth(currentDate.getMonth() + 1);
      }
      
      const labels = allMonths.map(month => format(new Date(month + '-01'), 'MMM'));
      const resignedData = allMonths.map(month => monthlyData[month]['Resigned'] || 0);
      const terminatedData = allMonths.map(month => monthlyData[month]['Terminated'] || 0);
      const otherData = allMonths.map(month => monthlyData[month]['Other'] || 0);

      // Create the chart
      this.attrition_bar_chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [
            {
              label: 'Resigned',
              data: resignedData,
              backgroundColor: '#FF6B6B',
              borderColor: '#FF6B6B',
              borderWidth: 1
            },
            {
              label: 'Terminated',
              data: terminatedData,
              backgroundColor: '#FF9F43',
              borderColor: '#FF9F43',
              borderWidth: 1
            },
            {
              label: 'Other',
              data: otherData,
              backgroundColor: '#74B9FF',
              borderColor: '#74B9FF',
              borderWidth: 1
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          datasets: {
            bar: {
              categoryPercentage: 0.5,
              borderRadius: 0
            }
          },
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              mode: 'index',
              position: 'nearest',
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              titleColor: '#ffffff',
              bodyColor: '#ffffff',
              borderColor: '#6C30CC',
              borderWidth: 1,
              callbacks: {
                title: function(tooltipItems) {
                  if (tooltipItems.length !== 0) {
                    const monthIndex = tooltipItems[0].dataIndex;
                    const monthKey = allMonths[monthIndex];
                    return format(new Date(monthKey + '-01'), 'MMM YYYY');
                  }
                  return '';
                },
                label: function(context) {
                  const label = context.dataset.label;
                  const value = context.parsed.y;
                  if (value === 0) return null;
                  return `${label}: ${value} ${value === 1 ? 'employee' : 'employees'}`;
                },
                footer: function(tooltipItems) {
                  let total = 0;
                  tooltipItems.forEach(function(tooltipItem) {
                    total += tooltipItem.parsed.y;
                  });
                  return total > 0 ? `Total: ${total} ${total === 1 ? 'employee' : 'employees'}` : '';
                }
              }
            }
          },
          scales: {
            x: {
              stacked: true,
              grid: {
                display: false,
                drawBorder: false
              },
              ticks: {
                color: '#666666',
                font: {
                  size: 12,
                  weight: '500'
                }
              }
            },
            y: {
              stacked: true,
              beginAtZero: true,
              grid: {
                color: 'rgba(0, 0, 0, 0.1)'
              },
              ticks: {
                color: '#666666',
                font: {
                  size: 12
                },
                stepSize: 1
              }
            }
          },
          layout: {
            padding: {
              top: 24
            }
          },
          interaction: {
            intersect: false,
            mode: 'index'
          }
        }
      });
    },
    /**
     * Check if a date is a company holiday
     * @param {string} dateStr - Date in YYYY-MM-DD format
     * @returns {boolean} - True if the date is a holiday
     */
    isHoliday(dateStr) {
      const settingData = this.$store.getters['settings/settingData'];
      if (!settingData || !settingData.holiday_val || settingData.holiday_val.length === 0) {
        return false;
      }
      
      const checkDate = new Date(dateStr);
      return settingData.holiday_val.some(holidayDate => {
        const holiday = new Date(holidayDate);
        return holiday.getFullYear() === checkDate.getFullYear() &&
               holiday.getMonth() === checkDate.getMonth() &&
               holiday.getDate() === checkDate.getDate();
      });
    },
    /**
     * Loads happiness data for archived users to display in hover tooltip
     * Shows 60 days of happiness responses before the archive date
     * @param {Object} user - The archived user object containing email and archive date
     */
    async loadArchivedUserHappiness(user) {
      // Check if data is already loaded or currently loading
      if (this.archivedHappinessPatterns[user.email] || this.loadingArchivedPatterns[user.email]) {
        return;
      }
      
      // Set loading state and reset risk query flag
      this.$set(this.loadingArchivedPatterns, user.email, true);
      this.riskQueryFailed = false;
      
      try {
        // Get the archive date
        let archiveDate = null;
        if (user.exitdated) {
          archiveDate = new Date(user.exitdated);
        } else if (user.archive_date) {
          archiveDate = new Date(user.archive_date);
        } else if (user.archived_timestamp) {
          archiveDate = new Date(user.archived_timestamp);
        } else if (user.archiveddate) {
          // Parse the formatted date string
          const [day, month, year] = user.archiveddate.split(' ');
          const monthMap = {
            'Jan': 0, 'Feb': 1, 'Mar': 2, 'Apr': 3, 'May': 4, 'Jun': 5,
            'Jul': 6, 'Aug': 7, 'Sep': 8, 'Oct': 9, 'Nov': 10, 'Dec': 11
          };
          archiveDate = new Date(year, monthMap[month], parseInt(day));
        }
        
        if (!archiveDate || isNaN(archiveDate.getTime())) {
          this.$set(this.archivedHappinessPatterns, user.email, { error: 'No archive date available' });
          return;
        }
        
        // Calculate date range: 90 days before archive date
        const endDate = format(archiveDate, 'YYYY-MM-DD');
        const startDate = format(new Date(archiveDate.getTime() - (90 * 24 * 60 * 60 * 1000)), 'YYYY-MM-DD');
        
        // Query happiness data from Firebase
        const happinessRef = firebase.firestore()
          .collection('users_questions')
          .where('users', '==', user.email)
          .where('quest_id', '==', '-Kgs61AHOnpJ3rfyQr6t') // Happiness question ID
          .where('date', '>=', startDate)
          .where('date', '<=', endDate)
          .orderBy('date', 'desc');
          
        // Execute queries with error handling
        let happinessSnapshot;
        let riskSnapshot = { forEach: () => {}, empty: true, size: 0 };
        
        try {
          // Execute happiness query (primary)
          happinessSnapshot = await happinessRef.get().catch(err => {
            return { forEach: () => {}, empty: true };
          });
          
          // Query risk data from Firebase (optional - graceful fallback if fails)
          try {
            const riskRef = firebase.firestore()
              .collection('report_weekly_risk_all')
              .where('email', '==', user.email)
              .where('date', '>=', `${startDate} 00:00:00`)
              .where('date', '<=', `${endDate} 23:59:59`)
              .orderBy('date', 'desc');
              
            riskSnapshot = await riskRef.get();
          } catch (riskError) {
            // Continue without risk data - not critical for functionality
          }
        } catch (queryError) {
          throw queryError;
        }
        
        // Process the happiness data
        const happinessData = {};
        const dailyData = [];
        const monthlyData = {}; // Organize by month
        
        // Process risk data
        const riskData = {};
        const riskFlags = [];
        const recoveryFlags = [];
        
        riskSnapshot.forEach((doc) => {
          const data = doc.data();
          
          // Handle different date formats from Firebase
          let riskDate;
          try {
            if (data.date && data.date.toDate) {
              // Firebase Timestamp
              riskDate = format(data.date.toDate(), 'YYYY-MM-DD');
            } else if (typeof data.date === 'string') {
              // String date - extract just the date part
              riskDate = data.date.split(' ')[0]; // Get YYYY-MM-DD from "YYYY-MM-DD HH:mm:ss"
            } else {
              return;
            }
          } catch (dateError) {
            return;
          }
          
          // Store risk data for the date
          if (riskDate >= startDate && riskDate <= endDate) {
            let risk = data.risk_level ? data.risk_level+'R' : ''
            let highlightContent = data.risk_due?data.risk_due:"Happiness"
            if(risk){
              data.highlight=risk=="1R"?"R":risk
              data.highlight_txt= `${highlightContent}`
            }
            riskData[riskDate] = {
              highlight: data.highlight || null,
              highlightContent: data.highlightContent || null,
              status: data.risk_level || null
            };
            
            // Determine if this is a recovery or risk flag
            if (data.highlight && data.highlight.includes('R')) {
              const isRecovery = this.isRecoveryFlag(data);
              const content = (data.highlightContent && data.highlightContent !== 'undefined' && data.highlightContent.trim() !== '') 
                ? data.highlightContent 
                : (isRecovery ? this.getRecoveryFlagDescription(data.highlight) : this.getRiskFlagDescription(data.highlight));
              
              const flagData = {
                date: riskDate,
                highlight: data.highlight,
                content: content
              };
              
              if (isRecovery) {
                recoveryFlags.push(flagData);
              } else {
                riskFlags.push(flagData);
              }
            }
          }
        });
        
        // Create array of all 90 days organized by month (excluding weekends and holidays)
        for (let i = 89; i >= 0; i--) {
          const date = new Date(archiveDate.getTime() - (i * 24 * 60 * 60 * 1000));
          const dayOfWeekNum = date.getDay(); // 0 = Sunday, 6 = Saturday
          const dateStr = format(date, 'YYYY-MM-DD');
          
          // Skip weekends (Saturday = 6, Sunday = 0)
          if (dayOfWeekNum !== 0 && dayOfWeekNum !== 6) {
            const monthKey = format(date, 'YYYY-MM');
            const monthName = format(date, 'MMM YYYY');
            
            happinessData[dateStr] = null;
            
            const dayData = {
              date: dateStr,
              formattedDate: format(date, 'MMM DD'),
              dayOfWeek: format(date, 'EEE'),
              dayOfMonth: format(date, 'D'),
              response: null,
              riskFlag: riskData[dateStr] || null,
              isArchiveDate: i === 0
            };
            
            dailyData.push(dayData);
            
            // Organize by month
            if (!monthlyData[monthKey]) {
              monthlyData[monthKey] = {
                monthName: monthName,
                days: []
              };
            }
            monthlyData[monthKey].days.push(dayData);
          }
        }
        
        // Fill in actual happiness responses
        happinessSnapshot.forEach((doc) => {
          const data = doc.data();
          if (happinessData.hasOwnProperty(data.date)) {
            let status = 'gray'; // No response
            
            if (data.answer === 0 || data.answer === 1) {
              status = 'green'; // Happy
            } else if (data.answer === 2) {
              status = 'yellow'; // Okay
            } else if (data.answer === 3 || data.answer === 4) {
              status = 'red'; // Not great
            }
            
            happinessData[data.date] = status;
            
            // Update dailyData
            const dayIndex = dailyData.findIndex(d => d.date === data.date);
            if (dayIndex !== -1) {
              dailyData[dayIndex].response = status;
            }
          }
        });
        
        // Calculate happiness statistics
        const happyDays = Object.values(happinessData).filter(v => v === 'green').length;
        const okayDays = Object.values(happinessData).filter(v => v === 'yellow').length;
        const notGreatDays = Object.values(happinessData).filter(v => v === 'red').length;
        
        // Calculate percentages based on total responses (not total days)
        const totalResponseDays = happyDays + okayDays + notGreatDays;
        const happyPercentage = totalResponseDays > 0 ? Math.round((happyDays / totalResponseDays) * 100) : 0;
        const okayPercentage = totalResponseDays > 0 ? Math.round((okayDays / totalResponseDays) * 100) : 0;
        const notGreatPercentage = totalResponseDays > 0 ? Math.round((notGreatDays / totalResponseDays) * 100) : 0;
        
        // Store the processed data
        const storeData = {
          dailyData: dailyData,
          monthlyData: monthlyData,
          stats: {
            happyDays: happyDays,
            okayDays: okayDays,
            notGreatDays: notGreatDays,
            happyPercentage: happyPercentage,
            okayPercentage: okayPercentage,
            notGreatPercentage: notGreatPercentage,
            totalResponseDays: totalResponseDays,
            archiveDate: format(archiveDate, 'MMMM D, YYYY')
          },
          riskFlags: riskFlags, // Risk flag summary
          recoveryFlags: recoveryFlags, // Recovery flag summary
          hasRiskData: riskFlags.length > 0, // Flag to indicate if risk data is available
          hasRecoveryData: recoveryFlags.length > 0 // Flag to indicate if recovery data is available
        };
        
        this.$set(this.archivedHappinessPatterns, user.email, storeData);
        
      } catch (error) {
        console.error('Error loading archived user happiness and risk data:', error);
        console.error('Error details:', {
          userEmail: user.email,
          archiveDate: user.archiveddate,
          errorMessage: error.message,
          errorStack: error.stack
        });
        this.$set(this.archivedHappinessPatterns, user.email, { 
          error: `Failed to load data: ${error.message || 'Unknown error'}` 
        });
      } finally {
        this.$set(this.loadingArchivedPatterns, user.email, false);
      }
    },
    /**
     * Get color for impact rating display
     */
    getImpactRatingColor(value) {
      if (value < 25) return '#B40303';
      if (value < 50) return '#F44336';
      if (value < 75) return '#FBC02D';
      return '#66BB6A';
    },
    /**
     * Get CSS class for network type tag
     */
    getNetworkTagClass(value) {
      if (value === 'Low Network' || value === 'Latent Potential') {
        return 'tag-red';
      } else if (['Medium Inner', 'Medium Outer', 'Medium Network', 'Up-and-coming', 'Contributor', 'Community Pillar', 'Rising Star', 'Crowd Favorite'].includes(value)) {
        return 'tag-half-red';
      } else if (['High Outer', 'High Inner', 'Untapped Potential', 'Engaged Contributor', 'Emerging Talent', 'Valued Contributor', 'Key Player', 'High Potential', 'Unsung Talent'].includes(value)) {
        return 'tag-orange';
      } else if (['Super Outer', 'High Network', 'Super Inner', 'Activated', 'Core Player'].includes(value)) {
        return 'tag-half-green';
      }
      return 'tag-green';
    },
    /**
     * Get tooltip text for network type
     */
    getNetworkTooltip(networkType) {
      const tooltips = {
        'Low Network': 'Limited connections within the organization.',
        'Medium Outer': 'Developing connections across different departments or teams.',
        'Medium Inner': 'Strong connections within immediate team or department.',
        'Medium Network': 'Balanced mix of connections within and outside immediate team.',
        'High Outer': 'Extensive connections beyond immediate team.',
        'High Inner': 'Deeply embedded within immediate team or department.',
        'High Network': 'Wide-ranging connections throughout the organization.',
        'Super Outer': 'Exceptional at forming connections across the entire organization.',
        'Super Inner': 'Central figure within immediate team or department.',
        'Super Network': 'Extraordinary connection hub across all levels.'
      };
      return tooltips[networkType] || 'Network type information';
    },
    /**
     * Pre-load eNPS data for visible archived rows
     */
    categorizeNpsScore(score) {
      if (score >= 9) return { score, category: 'promoter', label: 'Promoter' };
      if (score >= 7) return { score, category: 'passive', label: 'Passive' };
      return { score, category: 'detractor', label: 'Detractor' };
    },
    parseEnpsFromSnapshots(snapshots) {
      let enps = null;
      let latestNpsDate = null;
      snapshots.forEach(snapshot => {
        if (snapshot.docs && snapshot.docs.length > 0) {
          const data = snapshot.docs[0].data();
          if (data.answer != null && (!latestNpsDate || data.date > latestNpsDate)) {
            latestNpsDate = data.date;
            enps = this.categorizeNpsScore(parseInt(data.answer));
          }
        }
      });
      return enps;
    },
    async fetchEnpsForUser(email) {
      const npsQuestionIds = ['-NsgSScCliV4ASMmFDOW', '-L1QT78ajNkp6MpsLkBu', '-NsgSS2L0gXXecipoJxX', '-M4F5P10foOhqehfK3lv'];
      const snapshots = await Promise.all(npsQuestionIds.map(qid =>
        firebase.firestore()
          .collection('users_questions')
          .where('users', '==', email)
          .where('quest_id', '==', qid)
          .orderBy('date', 'desc')
          .limit(1)
          .get()
          .catch(() => ({ docs: [] }))
      ));
      return this.parseEnpsFromSnapshots(snapshots);
    },
    async loadArchiveEnpsForPage() {
      const rows = this.membersArchive;
      if (!rows || !rows.length) return;

      const rowsToLoad = rows.filter(row =>
        !(this.expandedArchiveData[row.email] && this.expandedArchiveData[row.email].enps !== undefined)
      );

      await Promise.all(rowsToLoad.map(async (row) => {
        try {
          const enps = await this.fetchEnpsForUser(row.email);
          const existing = this.expandedArchiveData[row.email] || {};
          this.$set(this.expandedArchiveData, row.email, { ...existing, enps });
        } catch (e) {
          // Silently skip — not critical for pre-load
        }
      }));
    },
    /**
     * Handle archive table row expand/collapse
     */
    handleArchiveExpand(row, expandedRows) {
      if (expandedRows.includes(row)) {
        this.loadArchiveDetailData(row);
      }
    },
    /**
     * Load detail data for expanded archive row (eNPS, risk flags, check-in activity)
     */
    async loadArchiveDetailData(row) {
      // Also load happiness data if not already loaded
      if (!this.archivedHappinessPatterns[row.email] && !this.loadingArchivedPatterns[row.email]) {
        this.loadArchivedUserHappiness(row);
      }

      // Only skip if full detail data (not just eNPS) is already cached
      if (this.expandedArchiveData[row.email] && this.expandedArchiveData[row.email].riskFlagCount !== undefined) return;

      this.$set(this.loadingArchiveDetail, row.email, true);

      try {
        // Get the archive/exit date
        let archiveDate = null;
        if (row.exitdated) {
          archiveDate = new Date(row.exitdated);
        } else if (row.archive_date) {
          archiveDate = new Date(row.archive_date);
        } else if (row.archived_timestamp) {
          archiveDate = new Date(row.archived_timestamp);
        } else if (row.archiveddate) {
          const [day, month, year] = row.archiveddate.split(' ');
          const monthMap = { 'Jan': 0, 'Feb': 1, 'Mar': 2, 'Apr': 3, 'May': 4, 'Jun': 5, 'Jul': 6, 'Aug': 7, 'Sep': 8, 'Oct': 9, 'Nov': 10, 'Dec': 11 };
          archiveDate = new Date(year, monthMap[month], parseInt(day));
        }

        if (!archiveDate || isNaN(archiveDate.getTime())) {
          this.$set(this.expandedArchiveData, row.email, { error: 'No archive date available' });
          return;
        }

        // 4 months before exit
        const exitDate = format(archiveDate, 'YYYY-MM-DD');
        const fourMonthsBefore = format(new Date(archiveDate.getTime() - (120 * 24 * 60 * 60 * 1000)), 'YYYY-MM-DD');

        // Skip eNPS query if already cached from pre-load
        const cachedEnps = this.expandedArchiveData[row.email] && this.expandedArchiveData[row.email].enps;

        const [enps, riskResults, checkinResults] = await Promise.all([
          // Query A — eNPS (skip if already cached)
          cachedEnps !== undefined
            ? Promise.resolve(cachedEnps)
            : this.fetchEnpsForUser(row.email),
          // Query B — Risk flags (4 months before exit)
          firebase.firestore()
            .collection('report_weekly_risk_all')
            .where('email', '==', row.email)
            .where('date', '>=', `${fourMonthsBefore} 00:00:00`)
            .where('date', '<=', `${exitDate} 23:59:59`)
            .orderBy('date', 'desc')
            .get()
            .catch(() => ({ docs: [], forEach: () => {} })),
          // Query C — Check-in activity (4 months before exit, answered only)
          firebase.firestore()
            .collection('users_questions')
            .where('users', '==', row.email)
            .where('quest_id', '==', '-Kgs61AHOnpJ3rfyQr6t')
            .where('status', '==', 'close')
            .where('date', '>=', fourMonthsBefore)
            .where('date', '<=', exitDate)
            .get()
            .catch(() => ({ docs: [], size: 0 }))
        ]);

        // Process risk flags
        let riskFlagCount = 0;
        let riskBreakdown = { R: 0, '2R': 0, '3R': 0 };
        if (riskResults && riskResults.forEach) {
          riskResults.forEach(doc => {
            const data = doc.data();
            if (data.risk_level) {
              riskFlagCount++;
              const level = data.risk_level === 1 ? 'R' : data.risk_level + 'R';
              if (riskBreakdown.hasOwnProperty(level)) {
                riskBreakdown[level]++;
              }
            }
          });
        }

        // Process check-in activity — count unique days only
        const checkinDays = new Set();
        if (checkinResults.docs) {
          checkinResults.docs.forEach(doc => {
            const data = doc.data();
            if (data.date) {
              checkinDays.add(data.date.substring(0, 10));
            }
          });
        }
        const checkinCount = checkinDays.size;
        // Calculate total workdays in 4-month period
        let totalWorkdays = 0;
        const startD = new Date(fourMonthsBefore);
        const endD = new Date(exitDate);
        for (let d = new Date(startD); d <= endD; d.setDate(d.getDate() + 1)) {
          const dow = d.getDay();
          if (dow !== 0 && dow !== 6) {
            const dateStr = format(new Date(d), 'YYYY-MM-DD');
            if (!this.isHoliday(dateStr)) {
              totalWorkdays++;
            }
          }
        }
        const checkinPercentage = totalWorkdays > 0 ? Math.round((checkinCount / totalWorkdays) * 100) : 0;

        this.$set(this.expandedArchiveData, row.email, {
          enps,
          riskFlagCount,
          riskBreakdown,
          checkinCount,
          totalWorkdays,
          checkinPercentage
        });

      } catch (error) {
        console.error('Error loading archive detail data:', error);
        this.$set(this.expandedArchiveData, row.email, { error: error.message });
      } finally {
        this.$set(this.loadingArchiveDetail, row.email, false);
      }
    },
    /**
     * Get CSS class for risk flag display
     * @param {string} highlight - Risk highlight level ('R', '2R', '3R')
     * @returns {string} - CSS class name
     */
    getRiskFlagClass(highlight) {
      switch (highlight) {
        case 'R':
          return 'risk-level-1';
        case '2R':
          return 'risk-level-2';
        case '3R':
          return 'risk-level-3';
        default:
          return 'risk-level-1';
      }
    },
    /**
     * Get description for risk flag display
     * @param {string} highlight - Risk highlight level ('R', '2R', '3R')
     * @returns {string} - Human readable description
     */
    getRiskFlagDescription(highlight) {
      switch (highlight) {
        case 'R':
          return 'Low risk detected - may need attention';
        case '2R':
          return 'Medium risk detected - needs support';
        case '3R':
          return 'High risk detected - immediate attention needed';
        default:
          return 'Risk detected';
      }
    },
    /**
     * Determine if a risk flag represents a recovery state
     * @param {Object} data - Risk data object
     * @returns {boolean} - True if this is a recovery flag
     */
    isRecoveryFlag(data) {
      // Check if risk_level indicates recovery (0)
      if (data.risk_level === 0 || data.risk_level === '0') {
        return true;
      }
      
      // Check for positive language in highlightContent
      if (data.highlightContent && typeof data.highlightContent === 'string') {
        const content = data.highlightContent.toLowerCase();
        const recoveryKeywords = [
          'encouraging', 'improvement', 'positive', 'recovery', 'better',
          'progress', 'development', 'good place', 'engagement',
          'shifted to more positive', 'observed as the employee'
        ];
        
        return recoveryKeywords.some(keyword => content.includes(keyword));
      }
      
      return false;
    },
    /**
     * Get description for recovery flag display
     * @param {string} highlight - Risk highlight level ('R', '2R', '3R')
     * @returns {string} - Recovery description
     */
    getRecoveryFlagDescription(highlight) {
      switch (highlight) {
        case 'R':
          return 'Recovery noted - positive engagement observed';
        case '2R':
          return 'Strong recovery - significant improvement detected';
        case '3R':
          return 'Excellent recovery - major positive shift observed';
        default:
          return 'Recovery detected';
      }
    },
    createOptions(method) {
      const queryString = "";
      let items = [];
      const cb = (results) => {
        items = results;
      };
      this[method](queryString, cb);
      return items;
    },
    canEdit(item, target) {
      // HRIS
      if (item.source == "hris") {
        if (_.indexOf(["create", "update", "edit"], item.type) !== -1) {
          if (["team", "manager", "language", "country"].indexOf(target) !== -1) {
            return true;
          }
        } else if (item.type === "delete") {
          if (target == "archived_type") {
            return true;
          }
        }
      } else if (item.source == "app") {
        if (_.indexOf(["add_member", "direct_manager", "re_assign"], item.type) !== -1) {
          if (["team", "manager", "language", "country"].indexOf(target) !== -1) {
            return true;
          }
        } else if (item.type === "remove") {
          if (target == "archived_type") {
            return true;
          }
        }
      }
      return false;
    },
    getManagerTeamName(managerValue) {
      if (!managerValue) return '';
      // managerValue could be an email (dots) or a key (|| instead of dots)
      // managerOptions uses keys with || replacing .
      const managerKey = managerValue.replace(/\./g, '||');
      const manager = this.managerOptions.find(m => m.key === managerKey || m.email === managerValue);
      return manager ? (manager.team_name || 'No team') : '';
    },
    getOriginalMemberData(item) {
      // Get the original/current data for a member from allUser
      if (!item || !item.email) return null;
      const emailKey = item.email.replace(/\./g, '||');
      const originalUser = this.allUser[emailKey];
      if (!originalUser) return null;
      
      // Build original data object with resolved names
      const teamByKey = this.$store.getters["newmember/teamByKey"] || {};
      const original = {
        team: originalUser.team || '',
        team_name: teamByKey[originalUser.team] ? teamByKey[originalUser.team].name : '',
        manager: originalUser.boss || '',
        manager_name: '',
        manager_team_name: '',
        language: originalUser.language || 'th',
        country: originalUser.country || 'TH'
      };
      
      // Resolve manager name and team
      if (original.manager) {
        const managerKey = original.manager.replace(/\./g, '||');
        const managerUser = this.allUser[managerKey];
        if (managerUser) {
          original.manager_name = `${managerUser.firstname || ''} ${managerUser.lastname || ''}`.trim();
          // Get manager's team name
          if (managerUser.team && teamByKey[managerUser.team]) {
            original.manager_team_name = teamByKey[managerUser.team].name;
          }
        } else {
          original.manager_name = original.manager;
        }
      }
      
      return original;
    },
    getOriginalValue(item, field, defaultValue) {
      const original = this.getOriginalMemberData(item);
      if (!original) return defaultValue;
      return original[field] || defaultValue;
    },
    getRequesterInfo(item) {
      // Get full info about who requested this update
      if (!item) return null;
      
      // Try email_request first (APP source), then fall back to other methods
      const requesterEmail = item.email_request || '';
      if (!requesterEmail) return null;
      
      const emailKey = requesterEmail.replace(/\./g, '||');
      const requester = this.allUser[emailKey];
      if (!requester) return { name: item.requested_by || 'Unknown', team_name: '' };
      
      const teamByKey = this.$store.getters["newmember/teamByKey"] || {};
      return {
        name: `${requester.firstname || ''} ${requester.lastname || ''}`.trim() || requesterEmail,
        team_name: requester.team && teamByKey[requester.team] ? teamByKey[requester.team].name : ''
      };
    },
    getTeamHierarchy(teamKey) {
      // Get team hierarchy info (parent and children)
      if (!teamKey) return null;
      
      const teamByKey = this.$store.getters["newmember/teamByKey"] || {};
      const team = teamByKey[teamKey];
      if (!team) return null;
      
      const hierarchy = {
        name: team.name || '',
        parent: null,
        children: []
      };
      
      // Get parent team
      if (team.parent && teamByKey[team.parent]) {
        hierarchy.parent = {
          key: team.parent,
          name: teamByKey[team.parent].name
        };
      }
      
      // Get child teams (teams where parent equals this team's key)
      Object.keys(teamByKey).forEach(key => {
        if (teamByKey[key].parent === teamKey) {
          hierarchy.children.push({
            key: key,
            name: teamByKey[key].name
          });
        }
      });
      
      // Sort children alphabetically
      hierarchy.children.sort((a, b) => a.name.localeCompare(b.name));
      
      return hierarchy;
    },
    getTeamHierarchyByName(teamName) {
      // Find team by name and get hierarchy
      if (!teamName) return null;
      const teamByKey = this.$store.getters["newmember/teamByKey"] || {};
      const teamEntry = Object.entries(teamByKey).find(([key, team]) => team.name === teamName);
      if (!teamEntry) return null;
      return this.getTeamHierarchy(teamEntry[0]);
    },
    getManagerTeamKey(managerEmail) {
      // Get the team key for a manager by their email
      if (!managerEmail) return null;
      const managerKey = managerEmail.replace(/\./g, '||');
      const manager = this.allUser[managerKey];
      if (!manager) return null;
      return manager.team || null;
    },
    hasValueChanged(item, field, newValue) {
      const original = this.getOriginalMemberData(item);
      if (!original) return true; // New member, consider all changed
      return original[field] !== newValue;
    },
    getAppButtonLabelKey(type) {
      const scope = "members";
      if (type == "add_member") return `${scope}.ADD_MEMBER`;
      if (type == "remove") return `${scope}.ARCHIVE`;
      if (type == "direct_manager") return `${scope}.RE_ASSIGN`;
      if (type == "re_assign") return `${scope}.RE_ASSIGN`;

      return `${scope}.${type}`;
    },
    getImgIconOfPower(name) {
      return require("@/assets/images/components/profile/" + name + ".png");
    },
    ReAssignManagerActiveClick(item, index) {
      this.selectedManagerForReAssign = index;
      this.reAssignManager = item.email;
    },
    ManagerSelectedClick(item, index) {
      this.managerSuggest = [];
      this.managerSuggest.push(item);
      this.selectedManagerForReAssign = 0;
      this.reAssignManager = item.email;
    },
    handleInputManagerReAssign(queryString) {
      this.reAssignManager = "";
      this.selectedManagerForReAssign = null;
      if (queryString) {
        this.managerSuggest = [];
        let arrData = [];
        var links = this.datamembers["membersall"];
        var results = queryString
          ? links.filter(this.createFilterManager(queryString))
          : links;
        if (results.length > 0) {
          for (const i in results) {
            let emailKey = results[i].email.replace(/\./g, "||");
            if (arrData.length < 8 && this.membersByKey[emailKey]) {
              arrData.push(this.membersByKey[emailKey]);
            }
          }
          this.managerSuggest = arrData;
        }
      } else {
        this.managerSuggest = this.managerSuggest_temp;
      }
    },
    createFilterManager(queryString) {
      return (link) => {
        if (
          link.firstname.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0 &&
          link.email.toLowerCase() !==
            this.reAssignManagerWarmingData.email.toLowerCase()
        ) {
          return true;
        } else if (
          link.lastname.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0 &&
          link.email.toLowerCase() !==
            this.reAssignManagerWarmingData.email.toLowerCase()
        ) {
          return true;
        } else if (
          link.email.toLowerCase().indexOf(queryString.toLowerCase()) === 0 &&
          link.email.toLowerCase() !==
            this.reAssignManagerWarmingData.email.toLowerCase()
        ) {
          return true;
        }
      };
    },
    cancelReAssignManagerModal() {
      this.managerSuggest = [];
      this.managerSuggest_temp = [];
      this.reAssignManager = "";
      this.selectedManagerForReAssign = null;
      this.manager_assign_disp = "";
    },
    reAssignManagerModalSubmit() {
      if (!this.reAssignManager) {
        this.$message({
          showClose: true,
          message: "Please assign a manager",
          type: "error",
        });
        return false;
      } else {
        this.$confirm(
          "Are you sure you want to assign this manager?",
          "Confirm",
          {
            confirmButtonText: "Yes, confirm",
            cancelButtonText: "Cancel",
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            let chk_direct = false;
            let completeData = {};
            for (const i in this.subCheckedData) {
              if (this.subCheckedData[i].email == this.reAssignManager) {
                chk_direct = true;
                completeData.firstname = this.subCheckedData[i].firstname;
                completeData.lastname = this.subCheckedData[i].lastname;
                completeData.email = this.subCheckedData[i].email;
              }
            }
            this.$store.dispatch("newmember/ReAssignManagerSubmit", {
              memberData: this.subCheckedData,
              manager: this.reAssignManager,
            });
            this.subCheckedData = [];
            this.cancelReAssignManagerModal();
            this.reAssignManagerModal = false;
            if (chk_direct) {
              this.completeManagerWarmingData.firstname =
                completeData.firstname;
              this.completeManagerWarmingData.lastname = completeData.lastname;
              this.completeManagerWarmingData.email = completeData.email;
              this.completeManagerWarmingModal = true;
            }
          })
          .then(() => {
            this.$message({
              type: "success",
              message: "Manager assignement successful",
            });
          })
          // .then(() => {
          //   this.$store.dispatch("newteam/getTeams", this.user);
          //   this.$store.dispatch("membermanager/getMemberManager", this.user);
          // })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Manager assignment canceled",
            });
          });
      }
    },
    showReAssignManagerModal(type) {
      if (type == "reassign") {
        this.reAssignManagerWarmingModal = false;
        this.reAssignManagerModal = true;
      } else if (type == "complete") {
        this.completeManagerWarmingData.email;
        this.completeManagerWarmingModal = false;
        let keyId = this.completeManagerWarmingData.email.replace(/\./g, "||");
        if (this.membersByKey[keyId]) {
          let _data = this.membersByKey[keyId];
          _data.boss_team_name = "";
          _data.boss = "";
          _data.boss_pic = "";
          _data.boss_name = "";
          _data.boss_firstname = "";
          _data.boss_lastname = "";
          this.validateForm.dispmanager = "";
          this.rowClickEdit(_data, { columnKey: "showReAssignManagerModal" });
        }
      }
    },
    renderOptionSelect(creatElement, { column }) {
      let components = [];
      components.push(
        <el-dropdown-item command="thispage">
          Select {this.results.length < 10 ? this.results.length : 10} contacts
          on this page
        </el-dropdown-item>
      );
      if (this.results.length > 10) {
        components.push(
          <el-dropdown-item command="selectall">
            Select all {this.results.length} contacts
          </el-dropdown-item>
        );
      }
      components.push(
        <el-dropdown-item command="deselectall">Deselect all</el-dropdown-item>
      );
      return (
        <el-dropdown
          trigger="click"
          placement="bottom-start"
          style="display: inline-block; float: right;"
          onCommand={this.handleCommand}
        >
          <div style="display: contents;">
            <el-checkbox
              v-model={this.checkAll[0]}
              onchange={this.checkAllFunc}
              style="display: inline-block; float: right; margin-right: 6px;"
            ></el-checkbox>
          </div>
          <el-dropdown-menu slot="dropdown">{components}</el-dropdown-menu>
        </el-dropdown>
      );
    },
    checkAllFunc(status, $event) {
      if (this.checkAll_temp) {
        this.$set(this.checkAll, 0, true);
      } else {
        this.$set(this.checkAll, 0, false);
      }
    },
    checkAllArchiveFunc(status, $event) {
      let filterArchiveSchedule = [];
      let filterArchive = [];
      if (this.checkAllArchive_temp) {
        this.$set(this.checkAllArchive, 0, true);
      } else {
        this.$set(this.checkAllArchive, 0, false);
        for (let key in this.membersArchiveByKey) {
          if (this.membersArchiveByKey[key].archiveSchedule) {
            filterArchiveSchedule.push(this.membersArchiveByKey[key]);
          } else {
            filterArchive.push(this.membersArchiveByKey[key]);
          }
        }
        if (filterArchiveSchedule.length > 0 && filterArchive.length > 0) {
          this.selcetedArchiveScheduleBoth = true;
        } else {
          this.selcetedArchiveScheduleBoth = false;
        }
        if (filterArchiveSchedule.length > 0) {
          this.selcetedArchiveSchedule = false;
        } else {
          this.selcetedArchiveSchedule = true;
        }
      }
    },
    renderOptionSelectArchive(creatElement, { column }) {
      let components = [];
      components.push(
        <el-dropdown-item command="thispageArchive">
          Select{" "}
          {this.resultsArchive.length < 10 ? this.resultsArchive.length : 10}{" "}
          contacts on this page
        </el-dropdown-item>
      );
      if (this.resultsArchive.length > 10) {
        components.push(
          <el-dropdown-item command="selectallArchive">
            Select all {this.resultsArchive.length} contacts
          </el-dropdown-item>
        );
      }
      components.push(
        <el-dropdown-item command="deselectallArchive">
          Deselect all
        </el-dropdown-item>
      );
      return (
        <el-dropdown
          trigger="click"
          placement="bottom-start"
          style="display: inline-block; float: right;"
          onCommand={this.handleCommandArchive}
        >
          <div style="display: contents;">
            <el-checkbox
              v-model={this.checkAllArchive[0]}
              onchange={this.checkAllArchiveFunc}
              style="display: inline-block; float: right; margin-right: 6px;"
            ></el-checkbox>
          </div>
          <el-dropdown-menu slot="dropdown">{components}</el-dropdown-menu>
        </el-dropdown>
      );
    },
    handleCommand(command) {
      let check = this.checked;
      if (command == "thispage") {
        let thisMemberPage = this.members;
        for (const i in thisMemberPage) {
          this.$set(this.checked, "key_" + thisMemberPage[i].key, true);
          let chk_checked = _.filter(this.checkedData, {
            key: thisMemberPage[i].key,
          });
          if (chk_checked.length == 0) {
            this.checkedData.push(thisMemberPage[i]);
          }
        }
        if (
          Object.keys(this.checked).filter((k) => this.checked[k] === true)
            .length == this.datamembers["membersall"].length
        ) {
          this.checkAll_temp = true;
          this.$set(this.checkAll, 0, true);
        }
      } else if (command == "selectall") {
        let allMember = this.results;
        for (const i in allMember) {
          this.$set(this.checked, "key_" + allMember[i].key, true);
          let chk_checked = _.filter(this.checkedData, {
            key: allMember[i].key,
          });
          if (chk_checked.length == 0) {
            this.checkedData.push(allMember[i]);
          }
        }
        if (
          Object.keys(this.checked).filter((k) => this.checked[k] === true)
            .length == this.datamembers["membersall"].length
        ) {
          this.checkAll_temp = true;
          this.$set(this.checkAll, 0, true);
        }
        // this.checkAll_temp = true;
        // this.$set(this.checkAll, 0, true);
      } else if (command == "deselectall") {
        for (const i in check) {
          this.$set(this.checked, i, false);
        }
        this.checkedData = [];
        this.checkAll_temp = false;
        this.$set(this.checkAll, 0, false);
      }
    },
    handleCommandArchive(command) {
      let check = this.checkedArchive;
      if (command == "thispageArchive") {
        let thisMemberPage = this.membersArchive;
        for (const i in thisMemberPage) {
          this.$set(this.checkedArchive, "key_" + thisMemberPage[i].key, true);
          let chk_checked = _.filter(this.checkedDataArchive, {
            key: thisMemberPage[i].key,
          });
          if (chk_checked.length == 0) {
            this.checkedDataArchive.push(thisMemberPage[i]);
          }
        }
        if (
          Object.keys(this.checkedArchive).filter(
            (k) => this.checkedArchive[k] === true
          ).length == this.membersArchiveAll.length
        ) {
          this.checkAllArchive_temp = true;
          this.$set(this.checkAllArchive, 0, true);
        }
      } else if (command == "selectallArchive") {
        let allMember = this.resultsArchive;
        for (const i in allMember) {
          this.$set(this.checkedArchive, "key_" + allMember[i].key, true);
          let chk_checked = _.filter(this.checkedDataArchive, {
            key: allMember[i].key,
          });
          if (chk_checked.length == 0) {
            this.checkedDataArchive.push(allMember[i]);
          }
        }
        if (
          Object.keys(this.checkedArchive).filter(
            (k) => this.checkedArchive[k] === true
          ).length == this.membersArchiveAll.length
        ) {
          this.checkAllArchive_temp = true;
          this.$set(this.checkAllArchive, 0, true);
        }
      } else if (command == "deselectallArchive") {
        for (const i in check) {
          this.$set(this.checkedArchive, i, false);
        }
        this.checkedDataArchive = [];
        this.checkAllArchive_temp = false;
        this.$set(this.checkAllArchive, 0, false);
      }
    },
    membersChecked(key) {
      let count = Object.keys(this.checked).filter(
        (k) => this.checked[k] === true
      ).length;
      if (this.checked["key_" + key] === true) {
        this.checkedData.push(this.membersByKey[key]);
      } else {
        const index = this.checkedData.findIndex((obj) => obj.key === key);
        this.checkedData.splice(index, 1);
      }
      if (count == 1) {
        this.id = this.checkedData[0].key;
      } else {
        this.id = "";
      }
      if (
        Object.keys(this.checked).filter((k) => this.checked[k] === true)
          .length == this.datamembers["membersall"].length
      ) {
        this.checkAll_temp = true;
        this.$set(this.checkAll, 0, true);
      } else {
        this.checkAll_temp = false;
        this.$set(this.checkAll, 0, false);
      }
    },
    membersCheckedArchive(key) {
      let count = Object.keys(this.checkedArchive).filter(
        (k) => this.checkedArchive[k] === true
      ).length;
      if (this.checkedArchive["key_" + key] === true) {
        this.checkedDataArchive.push(this.membersArchiveByKey[key]);
      } else {
        const index = this.checkedDataArchive.findIndex(
          (obj) => obj.key === key
        );
        this.checkedDataArchive.splice(index, 1);
      }
      if (
        Object.keys(this.checkedArchive).filter(
          (k) => this.checkedArchive[k] === true
        ).length == this.membersArchiveAll.length
      ) {
        this.checkAllArchive_temp = true;
        this.$set(this.checkAllArchive, 0, true);
      } else {
        this.checkAllArchive_temp = false;
        this.$set(this.checkAllArchive, 0, false);
      }
      let filterArchiveSchedule = _.filter(
        this.checkedDataArchive,
        function (currentObject) {
          return currentObject.archiveSchedule;
        }
      );
      let filterArchive = _.filter(
        this.checkedDataArchive,
        function (currentObject) {
          return !currentObject.archiveSchedule;
        }
      );

      if (filterArchiveSchedule.length > 0 && filterArchive.length > 0) {
        this.selcetedArchiveScheduleBoth = true;
      } else {
        this.selcetedArchiveScheduleBoth = false;
      }
      if (filterArchiveSchedule.length > 0) {
        this.selcetedArchiveSchedule = false;
      } else {
        this.selcetedArchiveSchedule = true;
      }
    },
    statusClick(type) {
      if (type == "all") {
        document.getElementById("userStatus").innerHTML =
          "All (" +
          this.$utils(
            "addCommasInNumber",
            this.datamembers["membersall"]
              ? this.datamembers["membersall"].length
              : "0"
          ) +
          ")";
      } else if (type == "active") {
        document.getElementById("userStatus").innerHTML =
          "Active (" +
          this.$utils(
            "addCommasInNumber",
            this.datamembers["membersact"]
              ? this.datamembers["membersact"].length
              : "0"
          ) +
          ")";
      } else if (type == "inactive") {
        document.getElementById("userStatus").innerHTML =
          "Inactive (" +
          this.$utils(
            "addCommasInNumber",
            this.datamembers["membersinact"]
              ? this.datamembers["membersinact"].length
              : "0"
          ) +
          ")";
      } else if (type == "new") {
        document.getElementById("userStatus").innerHTML =
          "New (" +
          this.$utils(
            "addCommasInNumber",
            this.datamembers["membersnew"]
              ? this.datamembers["membersnew"].length
              : "0"
          ) +
          ")";
      } else if (type == "invited") {
        document.getElementById("userStatus").innerHTML =
          "Invited (" +
          this.$utils(
            "addCommasInNumber",
            this.datamembers["membersinvited"]
              ? this.datamembers["membersinvited"].length
              : "0"
          ) +
          ")";
      }
      this.type = type;
      this.$store.dispatch("newmember/statusChange", type);
    },
    handleCurrentChange(val) {
      this.$store.dispatch("newmember/currentChange", val);
    },
    handleArchiveCurrentChange(val) {
      this.$store.dispatch("newmember/archiveCurrentChange", val);
    },
    sort({ column, prop, order }) {
      if (order) {
        this.$store.dispatch("newmember/sortMember", [column.property, order]);
      }
      this.handleCurrentChange(this.page);
    },
    sortArchive({ column, prop, order }) {
      if (order) {
        this.$store.dispatch("newmember/sortMemberArchive", [
          column.property,
          order,
        ]);
      }
    },
    clickExport() {
      this.showSnackbar = true;
      setTimeout(() => {
        this.showSnackbar = false;
      }, 2000);
    },
    async clickExportContext() {
      console.log("Export context button clicked");
      this.exportingContext = true;
      try {
        console.log("Dispatching exportPersonalContext action");
        await this.$store.dispatch("newmember/exportPersonalContext");
        console.log("Export completed successfully");
      } catch (error) {
        console.error("Failed to export personal context:", error);
        this.$message.error("Failed to export personal context. Please try again.");
      } finally {
        this.exportingContext = false;
        console.log("Export process finished");
      }
    },
    handleExportCommand(command) {
      if (command === 'member-data') {
        // Trigger CSV export with loading state
        this.exportingCsv = true;
        this.clickExport();
        this.$nextTick(() => {
          if (this.$refs.hiddenCsvButton) {
            this.$refs.hiddenCsvButton.$el.click();
          }
          // Reset loading state after a short delay
          setTimeout(() => {
            this.exportingCsv = false;
          }, 1500);
        });
      } else if (command === 'context-data') {
        // Trigger AI context export
        this.clickExportContext();
      }
    },
    // Review Updates
    getReviewUpdatesTotal() {
      this.$store.dispatch("integrations/getReviewUpdatesTotal", this.user, { root: true });
    },
    clickReviewUpdates() {
      this.reviewUpdatesModalStatus = !this.reviewUpdatesModalStatus;
      this.handleCommandReviewUpdates('deselectallReviewUpdates');
      this.$store.dispatch("integrations/getReviewUpdates", this.user, { root: true });
    },
    cancelReviewUpdates() {
      // console.log("cancelReviewUpdates()");
    },
    importMembers() {
      this.importMembersStep = "select"; // select-file, select-text
      this.importMembersType = "file";
      this.importMembersFileList = [];
      this.importMembersText = "";
      this.importMembersModalStatus = true;

      // mock data
      /*
      const dataGroups = [];

      dataGroups.push({
        name: "3 New Members to Add",
        items: [{
          email: "test1@test.com",
          firstname: "Test1",
          lastname: "Test",
          team_name: "Avenger",
          boss: "Test",
          user_type: "Test",
          language: "Thai",
          country: "Thailand",
          manager_name: "Avocado",
          note: "Ready to import",
        }, {
          email: "test2@test.com",
          firstname: "Test2",
          lastname: "Test",
          team_name: "Avenger",
          boss: "Test",
          user_type: "Test",
          language: "Thai",
          country: "Thailand",
          manager_name: "Avocado",
          note: "Ready to import",
        }, {
          email: "test3@test.com",
          firstname: "Test3",
          lastname: "Test",
          team_name: "Avenger",
          boss: "Test",
          user_type: "Test",
          language: "Thai",
          country: "Thailand",
          manager_name: "Avocado",
          note: "Ready to import",
        }]
      });

      dataGroups.push({
        name: "2 Issues to Resolve",
        items: [{
          email: "test1@test.com",
          firstname: "First",
          lastname: "Lastname",
          team_name: "Avenger",
          boss: "Test",
          user_type: "Test",
          language: "Thai",
          country: "Thailand",
          manager_name: "Avocado",
          note: "Test",
        }, {
          email: "test2@test.com",
          firstname: "Test2",
          lastname: "Test",
          team_name: "Avenger",
          boss: "Test",
          user_type: "Test",
          language: "Thai",
          country: "Thailand",
          manager_name: "Avocado",
          note: "Test",
        }]
      });

      this.importMembersTableDataGroups = dataGroups;
      console.log(dataGroups, "dataGroups");
      //*/
      
    },
    cancelImportMembers() {
      // console.log("cancelImportMembers()");
    },
    handleImportMembersPreview(file) {
      console.log("handleImportMembersPreview()");
      console.log(file, "file");
    },
    handleImportMembersRemove(file, fileList) {
      // console.log("handleImportMembersRemove()");
      // console.log(file, fileList, "file, fileList");
    },
    handleImportMembersChange(file, fileList) {
      // console.log("handleImportMembersChange()");
      // console.log(file, fileList, "file, fileList");

      // Always delete the first file
      if (fileList.length > 1) {
        fileList.shift();
      }
    },
    handleImportMembersBeforeUpload(file) {
      // Check file size
      // 1 MB = 1024 * 1024 bytes = 1,048,576 bytes
      // 200 MB in bytes
      const maxSize = 209715200; 
      if (file.size > maxSize) {
        return false;
      }
    },
    async handleImportMembersSuccess(res, file, fileList) {
      const data = _.get(res, "data", []);
      const valid = data.length > 0;
      if (valid) {
        await this.$store.dispatch("integrations/validateNewMembersWithUpdate", data, { root: true });
        this.importMembersStep = "review";
      } else {
        this.$message({
          message: "Failed to import members",
        });
      }
    },
    selectImportMembersType(type) {
      this.importMembersType = type;
    },
    importMembersNextStep() {
      this.importMembersStep = `select-${this.importMembersType}`;
    },
    detectImportMembersTextFormat(text) {
      const sanitized = (text || "").replace(/^\uFEFF/, "");
      const firstLine = sanitized
        .split(/\r?\n/)
        .find((line) => line.trim().length > 0) || "";

      const countDelimiter = (line, delimiter) => {
        let count = 0;
        let inQuotes = false;

        for (let index = 0; index < line.length; index++) {
          const char = line[index];
          const nextChar = line[index + 1];

          if (char === '"') {
            if (inQuotes && nextChar === '"') {
              index++;
            } else {
              inQuotes = !inQuotes;
            }
            continue;
          }

          if (!inQuotes && char === delimiter) {
            count++;
          }
        }

        return count;
      };

      const commaCount = countDelimiter(firstLine, ",");
      const tabCount = countDelimiter(firstLine, "\t");

      if (commaCount > tabCount) return "csv";
      if (tabCount > commaCount) return "tsv";
      return "unknown";
    },
    parseImportMembersDelimitedText(text, delimiter) {
      const sanitized = (text || "").replace(/^\uFEFF/, "");
      const rows = [];
      let currentRow = [];
      let currentCell = "";
      let inQuotes = false;

      for (let index = 0; index < sanitized.length; index++) {
        const char = sanitized[index];
        const nextChar = sanitized[index + 1];

        if (char === '"') {
          if (inQuotes && nextChar === '"') {
            currentCell += '"';
            index++;
          } else {
            inQuotes = !inQuotes;
          }
          continue;
        }

        if (!inQuotes && char === delimiter) {
          currentRow.push(currentCell);
          currentCell = "";
          continue;
        }

        if (!inQuotes && (char === "\n" || char === "\r")) {
          if (char === "\r" && nextChar === "\n") {
            index++;
          }
          currentRow.push(currentCell);
          if (currentRow.some((cell) => String(cell).trim().length > 0)) {
            rows.push(currentRow);
          }
          currentRow = [];
          currentCell = "";
          continue;
        }

        currentCell += char;
      }

      currentRow.push(currentCell);
      if (currentRow.some((cell) => String(cell).trim().length > 0)) {
        rows.push(currentRow);
      }

      return rows;
    },
    formatImportReviewValue(field, value) {
      if (!value) {
        return "-";
      }

      const normalizedValue = String(value).trim();
      if (!normalizedValue) {
        return "-";
      }

      if (field === "birthday" && /^\d{4}-\d{2}-\d{2}$/.test(normalizedValue)) {
        return normalizedValue.slice(5);
      }

      return normalizedValue;
    },
    getImportReviewFieldDisplay(row, field, groupCode) {
      const fieldFlagMap = {
        nickname: "nickname",
        birthday: "birthday",
        workdate: "workdate",
      };
      const flagKey = fieldFlagMap[field];
      const hasExplicitValue = flagKey ? _.get(row, `_optional_fields.${flagKey}`, false) : false;
      const currentValue = this.formatImportReviewValue(field, _.get(row, `_existing.${field}`, ""));
      const nextValue = this.formatImportReviewValue(field, _.get(row, field, ""));

      if (hasExplicitValue) {
        if (currentValue === nextValue) {
          return nextValue;
        }
        return `${currentValue} -> ${nextValue}`;
      }

      if (groupCode === "new") {
        return nextValue;
      }

      return "-";
    },
    async importMembersProcess() {
      if (this.importMembersType == "file") {
        // @fixed can be re-submit
        this.$refs.importMembersFileUpload.submit();
      } else if (this.importMembersType == "text") {
        const detectedFormat = this.detectImportMembersTextFormat(this.importMembersText);
        let data = [];

        if (detectedFormat === "csv") {
          data = this.parseImportMembersDelimitedText(this.importMembersText, ",");
        } else if (detectedFormat === "tsv") {
          data = this.parseImportMembersDelimitedText(this.importMembersText, "\t");
        } else {
          this.$message({
            message: "Unable to detect CSV or TSV format",
          });
          return;
        }
      
        await this.handleImportMembersSuccess({data});
      }
    },
    async importMembersResolve() {
      try {
        const result = await this.$store.dispatch("integrations/importMembersResolve", this.user, { root: true });
        this.importMembersModalStatus = false;
        this.$store.dispatch("newmember/getMember", this.user);
        this.$message({
          type: "success",
          message: result && result.backupId
            ? "Import completed. A backup snapshot was saved before changes were applied."
            : "Import completed.",
        });
      } catch (error) {
        this.$message({
          type: "error",
          message: (error && error.message) || "Failed to import members.",
        });
      }
    },
    sortReviewUpdates({ column, prop, order }) {
      if (order) {
        this.$store.dispatch("integrations/sortReviewUpdates", [
          column.property,
          order,
        ]);
      }
    },
    handleReviewUpdatesCurrentChange(val) {
      this.$store.dispatch("integrations/reviewUpdatesCurrentChange", val);
    },
    handleCommandReviewUpdates(command) {
      let check = this.checkedReviewUpdates;
      if (command == "thispageReviewUpdates") {
        let thisMemberPage = this.reviewUpdates;
        for (const i in thisMemberPage) {
          this.$set(this.checkedReviewUpdates, "key_" + thisMemberPage[i].key, true);
          let chk_checked = _.filter(this.checkedDataReviewUpdates, {
            key: thisMemberPage[i].key,
          });
          if (chk_checked.length == 0) {
            this.checkedDataReviewUpdates.push(thisMemberPage[i]);
          }
        }
        if (
          Object.keys(this.checkedReviewUpdates).filter(
            (k) => this.checkedReviewUpdates[k] === true
          ).length == this.reviewUpdatesTotal
        ) {
          this.checkAllReviewUpdates_temp = true;
          this.$set(this.checkAllReviewUpdates, 0, true);
        }
      } else if (command == "selectallReviewUpdates") {
        let allMember = this.reviewUpdatesAll;
        for (const i in allMember) {
          this.$set(this.checkedReviewUpdates, "key_" + allMember[i].key, true);
          let chk_checked = _.filter(this.checkedDataReviewUpdates, {
            key: allMember[i].key,
          });
          if (chk_checked.length == 0) {
            this.checkedDataReviewUpdates.push(allMember[i]);
          }
        }
        if (
          Object.keys(this.checkedReviewUpdates).filter(
            (k) => this.checkedReviewUpdates[k] === true
          ).length == this.reviewUpdatesTotal
        ) {
          this.checkAllReviewUpdates_temp = true;
          this.$set(this.checkAllReviewUpdates, 0, true);
        }
      } else if (command == "deselectallReviewUpdates") {
        for (const i in check) {
          this.$set(this.checkedReviewUpdates, i, false);
        }
        this.checkedDataReviewUpdates = [];
        this.checkAllReviewUpdates_temp = false;
        this.$set(this.checkAllReviewUpdates, 0, false);
      }

      this._updateBulkActions();
    },
    async ignoreReviewUpdates(key) {
      const keys = Array.isArray(key) ? key : [key];

      const reviewUpdatesAll = this.$store.getters["integrations/reviewUpdatesAll"];
      const items = _.filter(reviewUpdatesAll, function(item) { return keys.indexOf(item.key) !== -1 });

      if (!items.length) return;

      const doConfirm = true;
      const confirmTitle = "Are you sure you want to ignore review udpates?";
      const confirmSuccess = "Success";
      const confirmCancel = "Canceled";

      const run = async () => {
        this.$store.dispatch("integrations/beginBulkUpdates", null, {root: true});
        for (const i in items) {
          const item = items[i];
          this.checkedReviewUpdates["key_" + item.key] = false;
          this.membersCheckedReviewUpdates(item.key);
          await this.$store.dispatch("integrations/updateReviewUpdates", {
            key: item.key,
            status: "ignore",
          });
        }
        this.$store.dispatch("integrations/endBulkUpdates", keys, {root: true});
      };

      if (doConfirm) {
        this.$confirm(
        confirmTitle,
        "Warning",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          run();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: confirmSuccess,
          });
        })

        .catch((e) => {
          console.log(e, "e");
          this.$message({
            type: "info",
            message: confirmCancel,
          });
        });
      } else {
        run();
      }
    },
    async runCommandReviewUpdates(key) {
      const keys = Array.isArray(key) ? key : [key];
      
      const reviewUpdatesIgnorePendingStatus = this.$store.getters["integrations/reviewUpdatesIgnorePendingStatus"];
      const reviewUpdatesAll = this.$store.getters["integrations/reviewUpdatesAll"];
      const items = _.filter(reviewUpdatesAll, function(item) { return keys.indexOf(item.key) !== -1 });

      if (!items.length) return;

      let isAddUser = false;
      let isUpdateUser = false;
      let isArchiveUser = false;
      let isChangeManager = false;

      // validate
      const doValidate = true; // for quick testing
      let error = false;
      let errorMsg = "";
      if (doValidate) {
        for (const i in items) {
          const item = items[i];
        // _.each(items,  (item) => {
          if (error) break;

          if (!reviewUpdatesIgnorePendingStatus) {
            if (item.status !== "pending") break;
          }
          
          const source = item.source.toLowerCase()
          if (source == "hris") {
            if (item.type == "create" || item.type == "update" || item.type == "edit") {
              isAddUser = true;
              if (item.type == "update") {
                isAddUser = false;
                isUpdateUser = true;
              }

              // prevent error from internal save function
              const newId = item.email.replace(/\./g, "||");
              const archivedUser = (await firebase.database().ref(`/users_employee_exit/${newId}`).once('value')).val();
              if (archivedUser) {
                error = true;
                errorMsg = `The email (${item.email}) is already in use (as an archived member)`;
                console.log(errorMsg, "errorMsg");
                break;
              }

              if (!item.team.length) {
                error = true;
                errorMsg = "Please assign a team for " + item.email;
                break;
              }
              if (!item.manager.length) {
                error = true;
                errorMsg = "Please select a manager for " + item.email;
                break;
              }
            } else if (item.type == "delete") {
              isArchiveUser = true;
              if (!item.archived_type.length) {
                // console.log(item, "item error of archived type");
                error = true;
                errorMsg = "Please select archived type for " + item.email;
                break;
              }
            }
          }

          // @todo direct_manager, add_member, remove, re_assign
          //       common code in the future
          if (source == "app") {
            if (item.type == "add_member" || item.type == "direct_manager" || item.type == "re_assign") {
              isAddUser = true;
              if (item.type != "add_member") {
                isAddUser = false;
                isUpdateUser = true;
              }

              // prevent error from internal save function
              const newId = item.email.replace(/\./g, "||");
              const archivedUser = (await firebase.database().ref(`/users_employee_exit/${newId}`).once('value')).val();
              if (archivedUser) {
                error = true;
                errorMsg = `The email (${item.email}) is already in use (as an archived member)`;
                console.log(errorMsg, "errorMsg");
                break;
              }

              if (!item.team.length) {
                error = true;
                errorMsg = "Please assign a team for " + item.email;
                break;
              }
              if (!item.manager.length) {
                error = true;
                errorMsg = "Please select a manager for " + item.email;
                break;
              }

            } else if (item.type == "remove") {
              isArchiveUser = true;
              if (!item.archived_type.length) {
                error = true;
                errorMsg = "Please select archived type for " + item.email;
                break;
              }
            }
          }

          this.validateForm.boss_team_name = "";
          this.validateForm.boss = "";
          this.validateForm.boss_pic = "";
          this.validateForm.boss_firstname = "";
          this.validateForm.boss_lastname = "";

          // check manager and team
          const managerKey = item.manager.replace(/\./g, '||');
          const manager = _.find(this.managerOptions, { key: managerKey });
          if (manager) {
            this.validateForm.boss_team_name = manager.team_name;
            this.validateForm.boss = manager.email;
            this.validateForm.boss_pic = manager.pic;
            this.validateForm.boss_firstname = manager.firstname;
            this.validateForm.boss_lastname = manager.lastname;
          }

          this.validateForm.email = item.email;
          this.validateForm.team = item.team;
          this.validateForm.manager = item.manager;

          // @see handleSelectManager
          this.handleSelectManager(manager);

          if (this.validateForm.dispmanager.length) {
            error = true;
            errorMsg = this.validateForm.dispmanager;
            break;
          }

          this.handleSelectTeam(_.cloneDeep(item));
          if (this.validateForm.dispmanager.length) {
            error = true;
            errorMsg = this.validateForm.dispmanager;
            break;
          }

        // });
        }
      }

      const doLogError = false;
      if (doLogError) {
        console.log(error, "error");
        console.log(errorMsg, "errorMsg");
      }

      if (error) {
        this.$message.error(errorMsg);
        return;
      }

      // Confirmation
      const doConfirm = true;

      let confirmTitle = "Are you sure you want to update information?";
      let confirmSuccess = "Success";
      let confirmCancel = "Canceled";
      if (isAddUser) {
        confirmTitle = "Are you sure you want to create member";
        confirmSuccess = "Member created";
        confirmCancel = "Canceled";
      } else if (isUpdateUser) {
        confirmTitle = "Are you sure you want to edit member";
        confirmSuccess = "Member edited";
        confirmCancel = "Canceled";
      } else if (isArchiveUser) {
        confirmTitle = "Are you sure you want to archive this member account?";
        confirmSuccess = "Member account archived";
        confirmCancel = "Canceled";
      } else if (isChangeManager) {
        confirmTitle = "Are you sure you want to assign this manager?";
        confirmSuccess = "Manager assignement successful";
        confirmCancel = "Manager assignment canceled";
      }

      const run = async (cb = () => {}) => {
        const allUser = this.$store.getters["main/allUser"];
        const teamOptions = this.teamOptions;
        const managerOptions = this.managerOptions;

        this.$store.dispatch("integrations/beginBulkUpdates", null, {root: true});

        // process
        for (const i in items) {
          const item = items[i];
          

          if (!reviewUpdatesIgnorePendingStatus) {
            if (item.status !== "pending") return;
          }
          
          const emailKey = item.email.replace(/\./g, "||");
          const source = item.source.toLowerCase();

          let isAddUser = false;
          let isUpdateUser = false;
          let isArchiveUser = false;
          let isChangeManager = false;

          if (source == "hris") {
            if (item.type == "create") {
              isAddUser = true;
            } else if (item.type == "update" || item.type == "edit") {
              isUpdateUser = true;
            } else if (item.type == "delete") {
              isArchiveUser = true;
            }
          } else if (source == "app") {
            if (item.type == "add_member") {
              isAddUser = true;
            } else if (item.type == "direct_manager" || item.type == "re_assign") {
              isChangeManager = true;
              isUpdateUser = true;
            } else if (item.type == "remove") {
              isArchiveUser = true;
            }
          }

          if (isAddUser || isUpdateUser) {

            // @see this.addMember();
            this.mode = allUser.hasOwnProperty(emailKey) ? "edit" : "";
            this.cancelAdd();
            // this.dialogFormVisible = true;
            this.scheduledArchive = false;

            // copy values
            this.validateForm.firstname = item.firstname;
            this.validateForm.lastname = item.lastname;
            this.validateForm.nickname = item.nickname || "";
            this.validateForm.email = item.email;

            // @see handleSelectTeam()
            const team = _.find(teamOptions, { key: item.team });
            if (team) {
              let color = team.color ? team.color.replace(/#/g, "") : "";
              this.validateForm.team = team.key;
              this.validateForm.team_color = color;

              this.validateForm.dispteam = team.name; // fixed, none finding in function to create
            }

            // @see handleSelectManager()
            const managerKey = item.manager.replace(/\./g, "||");
            const manager = _.find(managerOptions, { key: managerKey });
            if (manager) {
              this.validateForm.boss_team_name = manager.team_name;
              this.validateForm.boss = manager.email;
              this.validateForm.boss_pic = manager.pic;
              this.validateForm.boss_firstname = manager.firstname;
              this.validateForm.boss_lastname = manager.lastname;
            }

            if (_.has(item, "country", "TH")) {
              this.validateForm.country = item.country;
            }

            if (_.has(item, "language", "th")) {
              this.validateForm.language = item.language;
            }

            // @see saveMember()
            if (this.mode == "edit") {

              // don't change user type
              this.validateForm.user_type = _.get(allUser, `${emailKey}.user_type`, "user");

              //*
              this.id = this.validateForm.email.replace(/\./g, "||");
              this.$store
                .dispatch("newmember/updateMember", {
                  id: this.id,
                  form: this.validateForm,
                })
                .then(() => {
                  this.dialogFormVisible = false;
                  this.cancelAdd();
                });
              // this.$message({
              //   type: "success",
              //   message: "Member profile has been updated",
              // });f
              //*/
            } else {
              let ctemail = this.validateForm.email.toLowerCase();
              const newId = ctemail.replace(/\./g, "||");
              firebase
                .database()
                .ref(`/users/${newId}`)
                .once("value", (snapshot) => {
                  if (snapshot.val()) {
                    // this.$message.error("This email has already been registered.");
                    error = true;
                    errorMsg = "This email has already been registered.";
                  } else {
                    firebase
                      .database()
                      .ref(`/users_employee_exit/${newId}`)
                      .once("value", (snapshot) => {
                        if (snapshot.val()) {
                          // this.$message.error(
                          //   "The email is already in use (as an archived member)"
                          // );
                          error = true;
                          errorMsg = "The email is already in use (as an archived member)";
                        } else {
                          this.$store
                            .dispatch("newmember/createMember", {
                              form: this.validateForm,
                              invite: this.checkedAutoSendInvit,
                            })
                            .then(() => {
                              this.dialogFormVisible = false;
                              this.cancelAdd();
                            });
                          /*
                          this.$message({
                            type: "success",
                            message: "New member has been created",
                          });
                          //*/
                        }
                      });
                  }
                });
            }

          } else if (isArchiveUser) {
            //*
            this.id = emailKey;
            this.dateAcchivePicker = "";
            // this.archiveMemberClick(item.archived_type);

            const type = item.archived_type;
            if (
              new Date(this.dateAcchivePicker) <= new Date() ||
              !this.dateAcchivePicker
            ) {
              this.$store.dispatch("newmember/archiveMember", {
                id: this.id,
                type: type,
              });
            } else {
              this.$store.dispatch("newmember/setTimeArchiveMember", {
                id: this.id,
                archive_date: this.dateAcchivePicker,
                type: type,
              });
            }
            this.dialogFormVisible = false;
            this.cancelAdd();

            //*/
          }
          
          /*
          else if (source == "app") {

            const user = _.get(allUser, emailKey, {});
            if (user && !user.key) {
              user.key = emailKey;
            }
            const checkedData = [user];
            const assignManager = item.email_request;

            this.$store.dispatch("newmember/assignManagerSubmit", {
              memberData: checkedData,
              manager: assignManager,
            });
          }
          //*/

          if (error) {
            this.$message.error(errorMsg);
          } else {
            this.checkedReviewUpdates["key_" + item.key] = false;
            this.membersCheckedReviewUpdates(item.key);
            await this.$store.dispatch("integrations/updateReviewUpdates", {
              key: item.key,
              status: "success",
            });
          }
        }

        this.$store.dispatch("integrations/endBulkUpdates", keys, {root: true});
        cb();
      }

      if (doConfirm) {
        this.$confirm(
        confirmTitle,
        "Warning",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          run(() => {
            this.$message({
              type: "success",
              message: confirmSuccess,
            });
          });
        })
        .then(() => {
          // this.$message({
          //   type: "success",
          //   message: confirmSuccess,
          // });
        })

        .catch((e) => {
          console.log(e, "e");
          this.$message({
            type: "info",
            message: confirmCancel,
          });
        });
      } else {
        run();
      }
    },
    async bulkCommandReviewUpdates(action) {
      let keys = [];
      let filter;
      switch (action) {
        case "reAssignManager":
          filter = {source: "app", type: "direct_manager"};
          break;
        case "addUser":
          filter = {source: "hris", type: "create"};
          break;
        case "archive":
          filter = {source: "hris", type: "delete"};
          break;
      }
      if (action == "ignore") {
        keys = this.checkedDataReviewUpdates.map((item) => {
          return item.key;
        });
        await this.ignoreReviewUpdates(keys);
      } else {
        keys = _.filter(this.checkedDataReviewUpdates, filter).map((item) => {
          return item.key;
        });
        await this.runCommandReviewUpdates(keys);
      }
    },
    checkAllReviewUpdatesFunc(status, $event) {
      if (this.checkAllReviewUpdates_temp) {
        this.$set(this.checkAllReviewUpdates, 0, true);
      } else {
        this.$set(this.checkAllReviewUpdates, 0, false);
      }
    },
    renderOptionSelectReviewUpdates(creatElement, { column }) {
      let components = [];
      components.push(
        <el-dropdown-item command="thispageReviewUpdates">
          Select{" "}
          {this.reviewUpdatesTotal < 10 ? this.reviewUpdatesTotal : 10}{" "}
          contacts on this page
        </el-dropdown-item>
      );
      if (this.reviewUpdatesTotal > 10) {
        components.push(
          <el-dropdown-item command="selectallReviewUpdates">
            Select all {this.reviewUpdatesTotal} contacts
          </el-dropdown-item>
        );
      }
      components.push(
        <el-dropdown-item command="deselectallReviewUpdates">
          Deselect all
        </el-dropdown-item>
      );
      return (
        <el-dropdown
          trigger="click"
          placement="bottom-start"
          style="display: inline-block; float: right;"
          onCommand={this.handleCommandReviewUpdates}
        >
          <div style="display: contents;">
            <el-checkbox
              v-model={this.checkAllReviewUpdates[0]}
              onchange={this.checkAllReviewUpdatesFunc}
              style="display: inline-block; float: right; margin-right: 6px;"
            ></el-checkbox>
          </div>
          <el-dropdown-menu slot="dropdown">{components}</el-dropdown-menu>
        </el-dropdown>
      );
    },
    _updateBulkActions() {
      this.bulkIgnoreStatus = this.checkedDataReviewUpdates.length > 0;
      this.bulkAddUserStatus = 
        (_.filter(this.checkedDataReviewUpdates, {source: "hris", type: "create"}).length + 
        _.filter(this.checkedDataReviewUpdates, {source: "app", type: "add_member"}).length) > 0;
      this.bulkArchiveStatus = (_.filter(this.checkedDataReviewUpdates, {source: "hris", type: "delete"}).length +
        _.filter(this.checkedDataReviewUpdates, {source: "app", type: "remove"}).length) > 0;
      this.bulkReAssignManagerStatus = (_.filter(this.checkedDataReviewUpdates, {source: "app", type: "direct_manager"}).length +
        _.filter(this.checkedDataReviewUpdates, {source: "app", type: "re_assign"}).length) > 0;
    },
    membersCheckedReviewUpdates(key) {
      let count = Object.keys(this.checkedReviewUpdates).filter(
        (k) => this.checkedReviewUpdates[k] === true
      ).length;
      if (this.checkedReviewUpdates["key_" + key] === true) {
        this.checkedDataReviewUpdates.push(this.reviewUpdatesByKey[key]);
      } else {
        const index = this.checkedDataReviewUpdates.findIndex(
          (obj) => obj.key === key
        );
        this.checkedDataReviewUpdates.splice(index, 1);
      }
      this._updateBulkActions();
    },
    handleReviewUpdatesSelectAll(val) {
      if (!this.reviewUpdates) return;
      this.reviewUpdates.forEach(item => {
        this.$set(this.checkedReviewUpdates, 'key_' + item.key, val);
        if (val) {
          const exists = this.checkedDataReviewUpdates.find(d => d.key === item.key);
          if (!exists && this.reviewUpdatesByKey[item.key]) {
            this.checkedDataReviewUpdates.push(this.reviewUpdatesByKey[item.key]);
          }
        }
      });
      if (!val) {
        this.checkedDataReviewUpdates = [];
      }
      this._updateBulkActions();
    },
    addMember() {
      this.mode = "";
      this.cancelAdd();
      this.dialogFormVisible = true;
      this.scheduledArchive = false;
    },
    cancelAdd() {
      this.validateForm.large_pic = "";
      this.validateForm.firstname = "";
      this.validateForm.lastname = "";
      this.validateForm.nickname = "";
      this.validateForm.email = "";
      this.validateForm.dispteam = "";
      this.validateForm.team_color = "";
      this.validateForm.dispboss = "";
      this.validateForm.team = "";
      this.validateForm.boss_team_name = "";
      this.validateForm.boss = "";
      this.validateForm.tmp_boss = "";
      this.validateForm.boss_pic = "";
      this.validateForm.boss_firstname = "";
      this.validateForm.boss_lastname = "";
      this.validateForm.language = "th";
      this.validateForm.user_type = "user";
      (this.validateForm.country = "TH"),
        (this.validateForm.time_zone = "+07:00"),
        // this.validateForm.invite = true;
        (this.validateForm.status = "new");
      this.validateForm.to_now = "";
      this.validateForm.streak_count = 0;
      this.validateForm.super_feedback_count = 0;
      this.validateForm.medal = [];
      this.validateForm.coin = 0;
      this.validateForm.gem = 0;
      this.validateForm.house = "";
      this.originalHouseValue = "";
      this.validateForm.birthday_month = "";
      this.validateForm.birthday_day = "";
      this.validateForm.workdate = "";
      this.advancedInfoCollapsed = true;
      this.validateForm.joined = "";
      this.validateForm.joined_tooltips = [];
      this.validateForm.dispmanager = "";
      this.validateForm.introduce = "";
      (this.validateForm.culture_add_percentile = ""),
        (this.switchToArchive = false);
      this.checkedAutoSendInvit = true;
      this.activeName = "powers";
      this.directReportsData = {};
      this.activeProfileTab = "information";
      this.scheduledArchive = false;
      this.$store.commit("newmember/setModalMemberData", []);
      this.dateAcchivePicker = "";
      let check = this.checked;
      for (const i in check) {
        this.$set(this.checked, i, false);
      }

      this.checkedData = [];
      this.$set(this.checkAll, 0, false);
      this.checkAll_temp = false;
    },
    cancelAddArchive() {
      let check = this.checkedArchive;
      for (const i in check) {
        this.$set(this.checkedArchive, i, false);
      }
      this.checkedDataArchive = [];
      this.$set(this.checkAllArchive, 0, false);
      this.checkAllArchive_temp = false;
    },
    cancelDialog() {
      this.dateAcchivePicker = "";
      this.dialogFormVisible = false;
      this.directReportsData = {};
      this.$store.commit("newmember/setModalMemberData", []);
      this.$store.dispatch("newmember/clearDate");
      this.cancelAdd();
    },
    getImgUrl(pic) {
      var images = require.context("../../assets/images/", false, /\.png$/);
      return images("./" + pic + ".png");
    },
    getHouseImage(pic) {
      var images = require.context("../../assets/images/happilyvillage/", false, /\.png$/);
      return images("./" + pic + ".png");
    },
    getImgUrlMem(pic) {
      var images = require.context(
        "../../assets/images/members/",
        false,
        /\.png$/
      );
      return images("./" + pic + ".png");
    },
    getImgUrlSet(pic) {
      var images = require.context(
        "../../assets/images/settings/",
        false,
        /\.png$/
      );
      return images("./" + pic + ".png");
    },
    querySearchTeam(queryString, cb) {
      //var links = this.links;
      var links = this.team;
      var results = queryString
        ? links.filter(this.createFilterTeam(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilterTeam(queryString) {
      return (link) => {
        return link.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelectTeam(item) {
      item.email = this.validateForm.boss;
      this.validateForm.dispmanager = "";
      if (this.validateForm.email && item.email) {
        // check loop
        let arrUserRole = [];
        let bossTemp = "";
        let chkLoopErr = false;
        arrUserRole[this.validateForm.email] = this.validateForm.email;
        arrUserRole[item.email] = item.email;
        let emailKey = item.email.replace(/\./g, "||");
        bossTemp =
          this.membersByKey[emailKey] && this.membersByKey[emailKey].boss
            ? this.membersByKey[emailKey].boss
            : "";
        if (bossTemp) {
          do {
            if (arrUserRole[bossTemp]) {
              chkLoopErr = true;
            } else {
              arrUserRole[bossTemp] = bossTemp;
              let bossKey = bossTemp.replace(/\./g, "||");
              bossTemp =
                this.membersByKey[bossKey] && this.membersByKey[bossKey].boss
                  ? this.membersByKey[bossKey].boss
                  : "";
              if (bossTemp && arrUserRole[bossTemp]) {
                chkLoopErr = true;
              }
            }
          } while (
            bossTemp &&
            arrUserRole[bossTemp] == undefined &&
            chkLoopErr == false
          );
        }
        if (chkLoopErr) {
          this.validateForm.dispmanager =
            "⚠️ Managers cannot report to their direct report or below";
        }
        // End Check Loop
      }
      if (
        this.validateForm.boss &&
        item.key &&
        this.validateForm.dispmanager == ""
      ) {
        let teamMember = _.filter(this.datamembers["membersall"], {
          team: item.key,
        });
        if (teamMember.length > 0) {
          let bosscheck = [];
          for (const i in teamMember) {
            if (teamMember[i]["email"] !== this.validateForm.email && teamMember[i]["boss"]) {
              let bossKey = teamMember[i]["boss"].replace(/\./g, "||");
              if(this.membersByKey[bossKey]){
                bosscheck[teamMember[i]["boss"]] = teamMember[i]["boss"];
              }
            }
          }
          if (Object.keys(bosscheck).length >= 1) {
            let emailKey = item.email.replace(/\./g, "||");
            if (
              bosscheck[item.email] == undefined &&
              bosscheck[this.validateForm.email] == undefined
            ) {
              if (
                this.membersByKey[emailKey] &&
                this.membersByKey[emailKey].boss &&
                bosscheck[this.membersByKey[emailKey].boss]
              ) {
              } else {
                this.validateForm.dispmanager =
                  "⚠️ Managers must have their own team";
              }
            }
          }
          // if((Object.keys(bosscheck)).length >= 1){
          //   if(bosscheck[item.email] == undefined && bosscheck[this.validateForm.email] == undefined){
          //     this.validateForm.dispmanager = "⚠️ Managers must have their own team"
          //   }
          // }
        }
      }
      let color = item.color ? item.color.replace(/#/g, "") : "";
      this.validateForm.team = item.key;
      this.validateForm.team_color = color;
    },
    handleInputTeam(value) {
      if (!value) {
        this.validateForm.team_color = "";
        this.validateForm.dispmanager = "";
      }
    },
    // Inline Team Editing Methods
    startInlineTeamEdit(row) {
      // Close any open manager edit first
      if (this.editingManagerMemberKey) {
        this.cancelInlineManagerEdit();
      }
      // Close any other team edit
      if (this.editingTeamMemberKey && this.editingTeamMemberKey !== row.key) {
        this.cancelInlineTeamEdit();
      }
      
      this.editingTeamMemberKey = row.key;
      this.editingTeamRow = row;
      this.inlineTeamValue = row.team_name || "";
      this.inlineTeamData = {
        key: row.team || "",
        color: row.team_color || "",
        name: row.team_name || "",
      };
      this.inlineTeamValidationMsg = "";
    },
    cancelInlineTeamEdit() {
      this.editingTeamMemberKey = null;
      this.editingTeamRow = null;
      this.inlineTeamValue = "";
      this.inlineTeamData = { key: "", color: "", name: "" };
      this.inlineTeamValidationMsg = "";
    },
    handleInlineTeamInput(value) {
      if (!value) {
        this.inlineTeamData = { key: "", color: "", name: "" };
        this.inlineTeamValidationMsg = "";
      }
    },
    isNewTeam(teamName) {
      if (!teamName) return false;
      const existingTeam = Object.keys(this.teamByKey).find(
        (k) => this.teamByKey[k].name.toLowerCase() === teamName.toLowerCase()
      );
      return !existingTeam;
    },
    handleInlineTeamSelect(item, row) {
      // Store the selected team data
      const color = item.color ? item.color.replace(/#/g, "") : "";
      this.inlineTeamData = {
        key: item.key,
        color: color,
        name: item.name,
      };
      this.inlineTeamValue = item.name;
      
      // Validate the team selection
      this.validateInlineTeamSelection(item.key, row);
    },
    validateInlineTeamSelection(teamKey, row) {
      this.inlineTeamValidationMsg = "";
      
      // Check for manager validation (same logic as handleSelectTeam)
      if (row.boss && teamKey) {
        let teamMember = _.filter(this.datamembers["membersall"], {
          team: teamKey,
        });
        if (teamMember.length > 0) {
          let bosscheck = [];
          for (const i in teamMember) {
            if (teamMember[i]["email"] !== row.email && teamMember[i]["boss"]) {
              let bossKey = teamMember[i]["boss"].replace(/\./g, "||");
              if (this.membersByKey[bossKey]) {
                bosscheck[teamMember[i]["boss"]] = teamMember[i]["boss"];
              }
            }
          }
          if (Object.keys(bosscheck).length >= 1) {
            let emailKey = row.boss.replace(/\./g, "||");
            if (
              bosscheck[row.boss] == undefined &&
              bosscheck[row.email] == undefined
            ) {
              if (
                this.membersByKey[emailKey] &&
                this.membersByKey[emailKey].boss &&
                bosscheck[this.membersByKey[emailKey].boss]
              ) {
                // Valid - manager's boss is in the team
              } else {
                this.inlineTeamValidationMsg = "⚠️ Managers must have their own team";
              }
            }
          }
        }
      }
    },
    onTeamPopoverShow() {
      // Focus the autocomplete input after popover is shown
      this.$nextTick(() => {
        if (this.$refs.inlineTeamAutocomplete) {
          this.$refs.inlineTeamAutocomplete.focus();
        }
      });
    },
    confirmInlineTeamEdit(row) {
      // Don't confirm if there's a validation error or no value
      if (this.inlineTeamValidationMsg || !this.inlineTeamValue) {
        return;
      }
      
      // If user typed a new team name (not selected from list)
      if (this.isNewTeam(this.inlineTeamValue) && !this.inlineTeamData.key) {
        this.inlineTeamData = {
          key: "",
          color: "",
          name: this.inlineTeamValue,
        };
      }
      
      // If no change was made
      if (this.inlineTeamData.key === row.team && this.inlineTeamValue === row.team_name) {
        this.cancelInlineTeamEdit();
        return;
      }
      
      this.saveInlineTeam(row);
    },
    saveInlineTeam(row) {
      // Don't save if there's a validation error
      if (this.inlineTeamValidationMsg) {
        this.$message({
          showClose: true,
          message: this.inlineTeamValidationMsg,
          type: "warning",
        });
        return;
      }
      
      // Check if team actually changed
      const newTeamKey = this.inlineTeamData.key;
      const newTeamName = this.inlineTeamData.name || this.inlineTeamValue;
      const isNewTeam = !newTeamKey && newTeamName;
      
      if (!isNewTeam && newTeamKey === row.team) {
        // No change
        this.cancelInlineTeamEdit();
        return;
      }
      
      // Build confirmation message
      let confirmMessage = "";
      if (isNewTeam) {
        confirmMessage = `Are you sure you want to create a new team "${newTeamName}" and assign it to this member?`;
      } else {
        confirmMessage = `Are you sure you want to change the team to "${newTeamName}"?`;
      }
      
      this.$confirm(confirmMessage, "Confirm", {
        confirmButtonText: "Yes, confirm",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true,
      })
        .then(() => {
          // For new team, we need to find or create the team key
          let teamKeyToSave = newTeamKey;
          
          if (isNewTeam) {
            // Find existing team by name (case insensitive) or use the typed name
            const existingTeam = this.team.find(
              (t) => t.name.toLowerCase() === newTeamName.toLowerCase()
            );
            if (existingTeam) {
              teamKeyToSave = existingTeam.key;
            } else {
              // New team will be created - use the name as team key temporarily
              // The store action should handle creating a new team
              teamKeyToSave = newTeamName;
            }
          }
          
          // Use the assignTeamSubmit action with a single member
          this.$store.dispatch("newmember/assignTeamSubmit", {
            memberData: [row],
            team: teamKeyToSave,
          });
          
          this.cancelInlineTeamEdit();
          
          this.$message({
            type: "success",
            message: "Team successfully updated",
          });
        })
        .catch(() => {
          this.cancelInlineTeamEdit();
          this.$message({
            type: "info",
            message: "Team update canceled",
          });
        });
    },
    // Inline Manager Editing Methods
    startInlineManagerEdit(row) {
      // Close any open team edit first
      if (this.editingTeamMemberKey) {
        this.cancelInlineTeamEdit();
      }
      // Close any other manager edit
      if (this.editingManagerMemberKey && this.editingManagerMemberKey !== row.key) {
        this.cancelInlineManagerEdit();
      }
      
      this.editingManagerMemberKey = row.key;
      this.editingManagerRow = row;
      this.inlineManagerValue = row.boss_name || "";
      this.inlineManagerData = {
        email: row.boss || "",
        firstname: row.boss_firstname || "",
        lastname: row.boss_lastname || "",
        pic: row.boss_pic || "",
      };
      this.inlineManagerValidationMsg = "";
    },
    cancelInlineManagerEdit() {
      this.editingManagerMemberKey = null;
      this.editingManagerRow = null;
      this.inlineManagerValue = "";
      this.inlineManagerData = { email: "", firstname: "", lastname: "", pic: "" };
      this.inlineManagerValidationMsg = "";
    },
    handleInlineManagerInput(value) {
      if (!value) {
        this.inlineManagerData = { email: "", firstname: "", lastname: "", pic: "" };
        this.inlineManagerValidationMsg = "";
      }
    },
    onManagerPopoverShow() {
      this.$nextTick(() => {
        if (this.$refs.inlineManagerAutocomplete) {
          this.$refs.inlineManagerAutocomplete.focus();
        }
      });
    },
    querySearchInlineManager(queryString, cb) {
      const currentMemberEmail = this.editingManagerRow ? this.editingManagerRow.email : "";
      var links = this.datamembers["membersall"] || [];
      var results = links.filter((link) => {
        // Exclude the current member from being their own manager
        if (link.email.toLowerCase() === currentMemberEmail.toLowerCase()) {
          return false;
        }
        // Search by firstname, lastname, email, or team name
        const query = queryString.toLowerCase();
        if (link.firstname.toLowerCase().indexOf(query) === 0) {
          return true;
        } else if (link.lastname.toLowerCase().indexOf(query) === 0) {
          return true;
        } else if (link.email.toLowerCase().indexOf(query) === 0) {
          return true;
        } else if (link.team_name && link.team_name.toLowerCase().indexOf(query) === 0) {
          return true;
        }
        return false;
      });
      cb(results);
    },
    handleInlineManagerSelect(item, row) {
      this.inlineManagerData = {
        email: item.email,
        firstname: item.firstname,
        lastname: item.lastname,
        pic: item.pic || "",
      };
      this.inlineManagerValue = `${item.firstname} ${item.lastname}`;
      
      // Validate the manager selection - check for loops
      this.validateInlineManagerSelection(item, row);
    },
    validateInlineManagerSelection(manager, row) {
      this.inlineManagerValidationMsg = "";
      
      if (!row.email || !manager.email) return;
      
      // Check for reporting loop
      let arrUserRole = [];
      let bossTemp = "";
      let chkLoopErr = false;
      
      arrUserRole[row.email] = row.email;
      arrUserRole[manager.email] = manager.email;
      
      let emailKey = manager.email.replace(/\./g, "||");
      bossTemp = this.membersByKey[emailKey] && this.membersByKey[emailKey].boss
        ? this.membersByKey[emailKey].boss
        : "";
      
      if (bossTemp) {
        do {
          if (arrUserRole[bossTemp]) {
            chkLoopErr = true;
          } else {
            arrUserRole[bossTemp] = bossTemp;
            let bossKey = bossTemp.replace(/\./g, "||");
            bossTemp = this.membersByKey[bossKey] && this.membersByKey[bossKey].boss
              ? this.membersByKey[bossKey].boss
              : "";
            if (bossTemp && arrUserRole[bossTemp]) {
              chkLoopErr = true;
            }
          }
        } while (bossTemp && arrUserRole[bossTemp] == undefined && chkLoopErr == false);
      }
      
      if (chkLoopErr) {
        this.inlineManagerValidationMsg = "⚠️ Managers cannot report to their direct report or below";
      }
    },
    confirmInlineManagerEdit(row) {
      // Don't confirm if there's a validation error or no manager selected
      if (this.inlineManagerValidationMsg || !this.inlineManagerData.email) {
        return;
      }
      
      // If no change was made
      if (this.inlineManagerData.email === row.boss) {
        this.cancelInlineManagerEdit();
        return;
      }
      
      this.saveInlineManager(row);
    },
    saveInlineManager(row) {
      // Don't save if there's a validation error
      if (this.inlineManagerValidationMsg) {
        this.$message({
          showClose: true,
          message: this.inlineManagerValidationMsg,
          type: "warning",
        });
        return;
      }
      
      const newManagerEmail = this.inlineManagerData.email;
      const newManagerName = `${this.inlineManagerData.firstname} ${this.inlineManagerData.lastname}`;
      
      // Check if manager actually changed
      if (newManagerEmail === row.boss) {
        this.cancelInlineManagerEdit();
        return;
      }
      
      const confirmMessage = `Are you sure you want to change the manager to "${newManagerName}"?`;
      
      this.$confirm(confirmMessage, "Confirm", {
        confirmButtonText: "Yes, confirm",
        cancelButtonText: "Cancel",
        type: "warning",
        center: true,
      })
        .then(() => {
          // Use the assignManagerSubmit action with a single member
          this.$store.dispatch("membermanager/assignManagerSubmit", {
            memberData: [row],
            manager: newManagerEmail,
          });
          
          this.cancelInlineManagerEdit();
          
          this.$message({
            type: "success",
            message: "Manager successfully updated",
          });
        })
        .catch(() => {
          this.cancelInlineManagerEdit();
          this.$message({
            type: "info",
            message: "Manager update canceled",
          });
        });
    },
    querySearchManager(queryString, cb) {
      var links = this.datamembers["membersall"] || [];
      var results = links.filter(this.createFilterManager(queryString));
      cb(results);
    },
    createFilterManager(queryString) {
      return (link) => {
        if (
          link.firstname.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0 &&
          link.email.toLowerCase() !== this.validateForm.email.toLowerCase()
        ) {
          return true;
        } else if (
          link.lastname.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0 &&
          link.email.toLowerCase() !== this.validateForm.email.toLowerCase()
        ) {
          return true;
        } else if (
          link.email.toLowerCase().indexOf(queryString.toLowerCase()) === 0 &&
          link.email.toLowerCase() !== this.validateForm.email.toLowerCase()
        ) {
          return true;
        } else if (
          link.hasOwnProperty("team_name") &&
          link.team_name.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0 &&
          link.team_name.toLowerCase() !==
            this.validateForm.boss_team_name.toLowerCase()
        ) {
          return true;
        }
      };
    },
    handleSelectManager(item) {
      this.validateForm.dispmanager = "";
      if (this.validateForm.email) {
        // check loop
        let arrUserRole = [];
        let bossTemp = "";
        let chkLoopErr = false;
        arrUserRole[this.validateForm.email] = this.validateForm.email;
        arrUserRole[item.email] = item.email;
        let emailKey = item.email.replace(/\./g, "||");
        bossTemp =
          this.membersByKey[emailKey] && this.membersByKey[emailKey].boss
            ? this.membersByKey[emailKey].boss
            : "";
        if (bossTemp) {
          do {
            if (arrUserRole[bossTemp]) {
              chkLoopErr = true;
            } else {
              arrUserRole[bossTemp] = bossTemp;
              let bossKey = bossTemp.replace(/\./g, "||");
              bossTemp =
                this.membersByKey[bossKey] && this.membersByKey[bossKey].boss
                  ? this.membersByKey[bossKey].boss
                  : "";
              if (bossTemp && arrUserRole[bossTemp]) {
                chkLoopErr = true;
              }
            }
          } while (
            bossTemp &&
            arrUserRole[bossTemp] == undefined &&
            chkLoopErr == false
          );
        }
        if (chkLoopErr) {
          this.validateForm.dispmanager =
            "⚠️ Managers cannot report to their direct report or below";
        }
        // End Check Loop
      }
      if (this.validateForm.team && this.validateForm.dispmanager == "") {
        let teamMember = _.filter(this.datamembers["membersall"], {
          team: this.validateForm.team,
        });
        if (teamMember.length > 0) {
          let bosscheck = [];
          for (const i in teamMember) {
            if (teamMember[i]["email"] !== this.validateForm.email && teamMember[i]["boss"]) {
              let bossKey = teamMember[i]["boss"].replace(/\./g, "||");
              if(this.membersByKey[bossKey]){
                bosscheck[teamMember[i]["boss"]] = teamMember[i]["boss"];
              }
            }
          }
          if (Object.keys(bosscheck).length >= 1) {
            let emailKey = item.email.replace(/\./g, "||");
            if (
              bosscheck[item.email] == undefined &&
              bosscheck[this.validateForm.email] == undefined
            ) {
              if (
                this.membersByKey[emailKey] &&
                this.membersByKey[emailKey].boss &&
                bosscheck[this.membersByKey[emailKey].boss]
              ) {
              } else {
                this.validateForm.dispmanager =
                  "⚠️ Managers must have their own team";
              }
            }
          }
          // if((Object.keys(bosscheck)).length >= 1){
          //   if(bosscheck[item.email] == undefined && bosscheck[this.validateForm.email] == undefined){
          //     this.validateForm.dispmanager = "⚠️ Managers must have their own team"
          //   }
          // }
        }
      }
      this.validateForm.boss_team_name = item.team_name;
      this.validateForm.boss = item.email;
      this.validateForm.boss_pic = item.pic;
      this.validateForm.boss_firstname = item.firstname;
      this.validateForm.boss_lastname = item.lastname;
    },
    handleInputManager(value) {
      if (!value) {
        this.validateForm.boss_team_name = "";
        this.validateForm.boss = "";
        this.validateForm.boss_pic = "";
        this.validateForm.boss_firstname = "";
        this.validateForm.boss_lastname = "";
        this.validateForm.dispmanager = "";
      }
    },
    handleInputManagerAssign(queryString) {
      this.assignManager = "";
      this.selectedManagerForAssign = null;
      if (queryString) {
        this.managerSuggest = [];
        let arrData = [];
        var links = this.datamembers["membersall"];
        var results = queryString
          ? links.filter(this.createFilterManager(queryString))
          : links;
        if (results.length > 0) {
          for (const i in results) {
            let emailKey = results[i].email.replace(/\./g, "||");
            let chk_self = _.filter(this.checkedData, { key: emailKey });
            if (
              arrData.length < 8 &&
              chk_self.length == 0 &&
              this.membersByKey[emailKey]
            ) {
              arrData.push(this.membersByKey[emailKey]);
            }
          }
          this.managerSuggest = arrData;
        }
      } else {
        this.managerSuggest = this.managerSuggest_temp;
      }
    },
    handleInputTeamAssign(queryString) {
      this.assignTeam = "";
      this.selectedTeamForAssign = null;
      if (queryString) {
        this.teamSuggest = [];
        let arrData = [];
        var links = this.team;
        var results = queryString
          ? links.filter(this.createFilterTeam(queryString))
          : links;
        if (results.length > 0) {
          for (const i in results) {
            if (arrData.length < 8 && this.teamByKey[results[i].key]) {
              let teamId = results[i].key;
              let teamData = this.teamByKey[teamId];
              teamData.key = teamId;
              teamData.color_code = teamData.color
                ? teamData.color.replace(/#/g, "")
                : "747474";
              teamData.boss_pic = this.teamParentByKey[teamId]
                ? this.teamParentByKey[teamId].pic
                : "";
              teamData.boss_name = this.teamParentByKey[teamId]
                ? this.teamParentByKey[teamId].boss_firstname +
                  " " +
                  this.teamParentByKey[teamId].boss_lastname
                : "";
              teamData.count_member_team = this.teamParentByKey[teamId]
                ? this.teamParentByKey[teamId].sup.length
                : 0;
              arrData.push(teamData);
            }
          }
          this.teamSuggest = arrData;
        }
      } else {
        this.teamSuggest = this.teamSuggest_temp;
      }
    },
    validateEmoji(value) {
      const withEmojis = /\p{Extended_Pictographic}/gu;
      return withEmojis.test(value);
    },
    validateEmail(email) {
      let re = /\S+@\S+\.\S+/;
      return re.test(email);
    },
    archiveMemberType(type) {
      // console.log("archiveMemberType", type);
      // @TODO: call this function `archiveMemberClick`
      this.archiveMemberClick(type);
    },
    archiveMemberClick(type) {
      this.$confirm(
        "Are you sure you want to archive this member account?",
        "Warning",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          if (
            new Date(this.dateAcchivePicker) <= new Date() ||
            !this.dateAcchivePicker
          ) {
            this.$store.dispatch("newmember/archiveMember", {
              id: this.id,
              type: type,
            });
          } else {
            this.$store.dispatch("newmember/setTimeArchiveMember", {
              id: this.id,
              archive_date: this.dateAcchivePicker,
              type: type,
            });
          }
          this.dialogFormVisible = false;
          this.cancelAdd();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Member account archived",
          });
        })

        .catch((e) => {
          console.log(e, "e");
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    archiveArrMemberClick() {
      if (this.checkedData.length > 1) {
        this.archiveMutipleMemberModal = true;
      } else {
        this.switchToArchive = true;
        this.dialogFormVisible = true;
      }
      // this.$confirm(
      //   "Are you sure you want to archive this member?",
      //   "Warning",
      //   {
      //     confirmButtonText: "Yes, confirm",
      //     cancelButtonText: "Cancel",
      //     type: "warning",
      //     center: true,
      //   }
      // )
      //   .then(() => {
      //     this.$store.dispatch("newmember/archiveArrMember", this.checkedData);
      //     this.dialogFormVisible = false;
      //     this.cancelAdd();
      //   })
      //   .then(() => {
      //     this.$message({
      //       type: "success",
      //       message: "Account Archived",
      //     });
      //   })
      //   // .then(() => {
      //   //   this.$store.dispatch("newteam/getTeams", this.user);
      //   //   this.$store.dispatch("membermanager/getMemberManager", this.user);
      //   // })
      //   .catch(() => {
      //     this.$message({
      //       type: "info",
      //       message: "Canceled",
      //     });
      //   });
    },
    getDayOfWeek() {
      if (this.dateAcchivePicker) {
        const a = new Date(this.dateAcchivePicker);
        const days = [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];
        return days[a.getDay()];
      }
      return "";
    },
    archiveMemberByGroupType(type) {
      //console.log(type)
      this.confirmArchiveMember(type);
      // @TODO: call this function `confirmArchiveMember`
    },
    confirmArchiveMember(type) {
      this.$confirm(
        "Are you sure you want to archive this member?",
        "Warning",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          if (
            new Date(this.dateAcchivePicker) <= new Date() ||
            !this.dateAcchivePicker
          ) {
            this.$store.dispatch("newmember/archiveArrMember", {
              obj: this.checkedData,
              type: type,
            });
          } else {
            this.$store.dispatch("newmember/setTimeArchiveArrMember", {
              arr: this.checkedData,
              archive_date: this.dateAcchivePicker,
              type: type,
            });
          }
          let check = this.checked;
          for (const i in check) {
            this.$set(this.checked, i, false);
          }
          this.archiveMutipleMemberModal = false;
          this.cancelDialog();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Account Archived",
          });
        });
      // .then(() => {
      //   this.$store.dispatch("newteam/getTeams", this.user);
      //   this.$store.dispatch("membermanager/getMemberManager", this.user);
      // })
      // .catch(() => {
      //   this.$message({
      //     type: "info",
      //     message: "Canceled",
      //   });
      // });

      // this.$message({
      //         type: "success",
      //         message: "Account Archived",
      //       });
      //       // this.archiveMutipleMemberModal = false;
      //       this.switchToArchive = false;
      //       this.cancelDialog();
    },
    saveMember() {
      if (
        !this.validateForm.firstname.replace(/ /g, "") ||
        !this.validateForm.lastname.replace(/ /g, "") ||
        !this.validateForm.email.replace(/ /g, "") ||
        !this.validateForm.dispteam.replace(/ /g, "")
      ) {
        this.$message({
          showClose: true,
          message: "Please fill in all the input fields before saving changes",
          type: "error",
        });
        return false;
      } else if (
        this.validateForm.firstname &&
        this.validateEmoji(this.validateForm.firstname)
      ) {
        this.$message({
          showClose: true,
          message: "Emoji are not allowed to Firstname",
          type: "error",
        });
        return false;
      } else if (
        this.validateForm.lastname &&
        this.validateEmoji(this.validateForm.lastname)
      ) {
        this.$message({
          showClose: true,
          message: "Emoji are not allowed to Lastname",
          type: "error",
        });
        return false;
      } else if (
        this.validateForm.nickname &&
        this.validateEmoji(this.validateForm.nickname)
      ) {
        this.$message({
          showClose: true,
          message: "Emoji are not allowed to Nickname",
          type: "error",
        });
        return false;
      } else if (this.validateForm.email == this.validateForm.boss) {
        this.$message({
          showClose: true,
          message: "Not allowed to member and manager to be the same",
          type: "error",
        });
        return false;
      } else if (
        (this.validateForm.birthday_month && !this.validateForm.birthday_day) ||
        (!this.validateForm.birthday_month && this.validateForm.birthday_day)
      ) {
        this.$message({
          showClose: true,
          message: "Please select both month and day for birthday, or clear both",
          type: "error",
        });
        return false;
      } else if (this.validateForm.dispmanager.replace(/ /g, "")) {
        this.$message({
          showClose: true,
          message: this.validateForm.dispmanager,
          type: "error",
        });
        return false;
      }
      // else if (
      //   this.validateForm.email &&
      //   !this.validateEmail(this.validateForm.email)
      // ) {
      //   this.$message({
      //     showClose: true,
      //     message: "A valid email address is required",
      //     type: "error"
      //   });
      //   return false;
      // }
      else {
        if (this.mode == "edit") {
          this.$store
            .dispatch("newmember/updateMember", {
              id: this.id,
              form: this.validateForm,
            })
            .then(() => {
              this.dialogFormVisible = false;
              this.cancelAdd();
            });
          this.$message({
            type: "success",
            message: "Member profile has been updated",
          });
        } else {
          let ctemail = this.validateForm.email.toLowerCase();
          const newId = ctemail.replace(/\./g, "||");
          firebase
            .database()
            .ref(`/users/${newId}`)
            .once("value", (snapshot) => {
              if (snapshot.val()) {
                this.$message.error("This email has already been registered.");
              } else {
                firebase
                  .database()
                  .ref(`/users_employee_exit/${newId}`)
                  .once("value", (snapshot) => {
                    if (snapshot.val()) {
                      this.$message.error(
                        "The email is already in use (as an archived member)"
                      );
                    } else {
                      this.$store
                        .dispatch("newmember/createMember", {
                          form: this.validateForm,
                          invite: this.checkedAutoSendInvit,
                        })
                        .then(() => {
                          this.dialogFormVisible = false;
                          this.cancelAdd();
                        });
                      this.$message({
                        type: "success",
                        message: "New member has been created",
                      });
                    }
                  });
              }
            });
        }
      }
    },
    inviteMember(email) {
      this.$confirm(
        "Are you sure you want to send an invitation email?",
        "Confirm",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$store.dispatch("newmember/inviteMember", email);
          this.dialogFormVisible = false;
          this.cancelAdd();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Invitation sent successfully",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Invitation email canceled",
          });
        });
    },
    inviteArrMember() {
      this.$confirm(
        "Are you sure you want to send the invitation email?",
        "Confirm",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$store.dispatch("newmember/inviteArrMember", this.checkedData);
          this.dialogFormVisible = false;
          this.cancelAdd();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Invitation sent successfully",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Invitation canceled",
          });
        });
    },
    rowClickEdit(row, column, event) {
      if (column.columnKey && column.columnKey == "memberCheckbox") {
      } else {
        const item = row;
        this.id = item.key;
        this.mode = "edit";
        if (item.archiveSchedule) {
          this.scheduledArchive = true;
          this.dateArchive = format(
            new Date(item.archive_date),
            "MMM D, YYYY h:mm A"
          );
        } else {
          this.scheduledArchive = false;
        }
        if (item.introduce) this.validateForm.introduce = item.introduce;
        if (item.culture_add_percentile)
          this.validateForm.culture_add_percentile =
            item.culture_add_percentile;
        this.validateForm.large_pic = item.large_pic;
        this.validateForm.firstname = item.firstname;
        this.validateForm.lastname = item.lastname;
        this.validateForm.nickname = item.nickname || "";
        this.validateForm.email = item.email;
        this.validateForm.dispteam = item.team_name;
        let colorCode = item.team_color
          ? item.team_color.replace(/#/g, "")
          : "";
        this.validateForm.team_color = colorCode;
        this.validateForm.team = item.team;
        this.validateForm.boss_team_name = item.boss_team_name;
        this.validateForm.boss = item.boss;
        this.validateForm.tmp_boss = item.boss;
        this.validateForm.boss_pic = item.boss_pic;
        this.validateForm.dispboss = item.boss_name;
        this.validateForm.boss_firstname = item.boss_firstname;
        this.validateForm.boss_lastname = item.boss_lastname;
        this.validateForm.language = item.language;
        this.validateForm.user_type = item.user_type;
        this.validateForm.country = item.country ? item.country : "TH";

        var timezone = "";
        if (item.timezone || item.timezone == 0) {
          const split_time_zone = item.timezone.toString().split('.')
          let minute = ''
          if(Number(split_time_zone[1]) == 25){
            minute='15'
          }else if(Number(split_time_zone[1]) == 5){
            minute='30'
          }else if(Number(split_time_zone[1]) == 75){
            minute='45'
          }else{
             minute='00'
          }
          if (item.timezone >= 0) {
            if (item.timezone < 10) {
              timezone =
                "+0" + split_time_zone[0]+':'+minute
            } else {
              timezone =
                "+" + split_time_zone[0]+':'+minute
            }
          } else {
            if (item.timezone < 10) {
              timezone =
                "-0" +split_time_zone[0].replace("-", "")+':'+minute
                // item.timezone
                //   .toFixed(2)
                //   .toString()
                //   .replace("-", "")
                //   .replace(".", ":");
            } else {
              timezone = item.timezone.toFixed(2).toString().replace(".", ":");
            }
          }
        } else {
          timezone = "+07.00";
        }
        this.validateForm.time_zone = timezone;
        // this.validateForm.invite = false;
        this.validateForm.status = item.status;
        this.validateForm.to_now = item.to_now;
        this.validateForm.streak_count = item.streak_count
          ? item.streak_count
          : 0;
        this.validateForm.super_feedback_count = item.super_feedback_count
          ? item.super_feedback_count
          : 0;
        this.validateForm.medal = item.medal ? item.medal : [];
        this.validateForm.coin = item.coin;
        this.validateForm.gem = item.gem;
        this.validateForm.house = item.house || "";
        this.originalHouseValue = item.house || "";
        if (item.birthday) {
          const parts = item.birthday.split('-');
          if (parts.length === 3) {
            this.validateForm.birthday_month = parseInt(parts[1], 10);
            this.validateForm.birthday_day = parseInt(parts[2], 10);
          } else if (parts.length === 2) {
            this.validateForm.birthday_month = parseInt(parts[0]);
            this.validateForm.birthday_day = parseInt(parts[1], 10);
          }
        } else {
          this.validateForm.birthday_month = "";
          this.validateForm.birthday_day = "";
        }
        this.validateForm.workdate = item.workdate || "";
        this.validateForm.joined = item.joined ? item.joined : "";
        this.validateForm.joined_tooltips =
          item.joined_tooltips && item.joined_tooltips.length > 0
            ? item.joined_tooltips[0]
            : [];
        if (item.order_join) {
          let joinTotal = Object.keys(this.datamembers["membersall"]).filter(
            (k) => this.datamembers["membersall"][k].order_join
          ).length;
          this.validateForm.joined_tooltips["percent"] = (
            ((joinTotal - item.order_join) / joinTotal) *
            100
          ).toFixed();
        }
        this.validateForm.dispmanager = "";
        let directReportsData = {};
        directReportsData.total = 0;
        directReportsData.directReport = [];
        let directReport = _.filter(this.datamembers["membersall"], {
          boss: item.email,
        });
        if (directReport.length > 0) {
          this.directReportsData.total = directReport.length;
          this.directReportsData.directReport = directReport;
          // this.activeProfileTab = 'directReports'
        } else {
          // this.activeProfileTab = 'information'
          this.directReportsData = directReportsData;
        }
        this.$store.dispatch("newmember/getModalMemberData", item);
        this.activeName = "powers";
        this.activeProfileTab = "information";
        this.switchToArchive = false;
        this.dialogFormVisible = true;
        this.$store.dispatch("newmember/getRisk", item);
        this.$store.dispatch("newmember/getStarPerformer", item);
        this.$store.dispatch("newmember/getHoliday", item);
        this.$store.dispatch("newmember/getPowerData", item);
        this.$store.dispatch("newmember/getDataHerepoint", item.email);
        this.$store.dispatch("newmember/getDailyStatus", item).then(() => {
          setTimeout(() => {
            var container = this.$el.querySelector("#riskBox");
            container.scrollLeft = container.scrollWidth;
          }, 1000);
        });
      }
    },
    tableRowStyle({ row, rowIndex }) {
      return "cursor: pointer;";
    },
    renderSelectedPic(index) {
      if (index == 0) {
        return "";
      } else {
        return `left: ${index * -10}px; position: relative`;
      }
    },
    cancelAssignManagerModal() {
      this.managerSuggest = [];
      this.managerSuggest_temp = [];
      this.assignManager = "";
      this.selectedManagerForAssign = null;
      this.manager_assign_disp = "";
    },
    cancelAssignTeamModal() {
      this.teamSuggest = [];
      this.teamSuggest_temp = [];
      this.assignTeam = "";
      this.selectedTeamForAssign = null;
      this.team_assign_disp = "";
    },
    assignTeamModalClick() {
      this.$store.commit("newmember/setTeamParentKey", []);
      this.$store.dispatch("newmember/getTeamParentKeyData", this.user);
    },
    assignManagerModalClick() {
      let memberData = this.checkedData;
      this.managerSuggest = [];
      this.managerSuggest_temp = [];
      this.assignManager = "";
      this.selectedManagerForAssign = null;
      for (const i in memberData) {
        if (this.managerSuggest.length < 8) {
          if (memberData[i].boss) {
            /*direc manager*/
            let bossKeyID = memberData[i].boss.replace(/\./g, "||");
            if (
              this.membersByKey[bossKeyID] &&
              this.membersByKey[bossKeyID].boss
            ) {
              let bigBossKeyID = this.membersByKey[bossKeyID].boss.replace(
                /\./g,
                "||"
              );
              if (this.membersByKey[bossKeyID].boss) {
                let chk_managerExist = _.filter(this.managerSuggest, {
                  key: bigBossKeyID,
                });
                let chk_duplicate = _.filter(memberData, { key: bigBossKeyID });
                if (chk_managerExist.length == 0 && chk_duplicate.length == 0) {
                  this.managerSuggest.push(this.membersByKey[bigBossKeyID]);
                  this.managerSuggest_temp.push(
                    this.membersByKey[bigBossKeyID]
                  );
                }
              }
            }

            /*share direct manager*/
            if (this.bossByKey[bossKeyID]) {
              let shareManager = _.filter(this.datamembers["membersall"], {
                boss: memberData[i].boss,
              });
              if (shareManager.length > 0) {
                for (const j in shareManager) {
                  if (this.managerSuggest.length < 8) {
                    if (this.bossByKey[shareManager[j].key]) {
                      let chk_managerExist = _.filter(this.managerSuggest, {
                        key: shareManager[j].key,
                      });
                      let chk_duplicate = _.filter(memberData, {
                        key: shareManager[j].key,
                      });
                      if (
                        chk_managerExist.length == 0 &&
                        chk_duplicate.length == 0
                      ) {
                        this.managerSuggest.push(
                          this.membersByKey[shareManager[j].key]
                        );
                        this.managerSuggest_temp.push(
                          this.membersByKey[shareManager[j].key]
                        );
                      }
                    }
                  } else {
                    return;
                  }
                }
              }
            }
          }
        } else {
          return;
        }
      }
    },
    assignManagerActiveClick(item, index) {
      this.selectedManagerForAssign = index;
      this.assignManager = item.email;
    },
    assignManagerModalSubmit() {
      if (!this.assignManager) {
        this.$message({
          showClose: true,
          message: "Please assign a manager",
          type: "error",
        });
        return false;
      } else {
        this.$confirm(
          "Are you sure you want to assign this manager?",
          "Confirm",
          {
            confirmButtonText: "Yes, confirm",
            cancelButtonText: "Cancel",
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            this.$store.dispatch("newmember/assignManagerSubmit", {
              memberData: this.checkedData,
              manager: this.assignManager,
            });
            let check = this.checked;
            for (const i in check) {
              this.$set(this.checked, i, false);
            }
            this.checkedData = [];
            this.cancelAssignManagerModal();
            this.assignManagerModalStatus = false;
          })
          .then(() => {
            this.$message({
              type: "success",
              message: "Manager assignement successful",
            });
          })
          // .then(() => {
          //   this.$store.dispatch("newteam/getTeams", this.user);
          //   this.$store.dispatch("membermanager/getMemberManager", this.user);
          // })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Manager assignment canceled",
            });
          });
      }
    },
    assignTeamActiveClick(item, index) {
      this.selectedTeamForAssign = index;
      this.assignTeam = item.key;
    },
    assignTeamModalSubmit() {
      if (!this.assignTeam) {
        this.$message({
          showClose: true,
          message: "Please select a team",
          type: "error",
        });
        return false;
      } else {
        this.$confirm("Are you sure you want to select this team?", "Confirm", {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.$store.dispatch("newmember/assignTeamSubmit", {
              memberData: this.checkedData,
              team: this.assignTeam,
            });
            let check = this.checked;
            for (const i in check) {
              this.$set(this.checked, i, false);
            }
            this.checkedData = [];
            this.cancelAssignTeamModal();
            this.assignTeamModalStatus = false;
          })
          .then(() => {
            this.$message({
              type: "success",
              message: "Team successfully updated",
            });
          })
          // .then(() => {
          //   this.$store.dispatch("newteam/getTeams", this.user);
          //   this.$store.dispatch("membermanager/getMemberManager", this.user);
          // })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Team update canceled",
            });
          });
      }
    },
    archivedModalClick() {
      this.archivedModalStatus = !this.archivedModalStatus;
      this.$store.dispatch("newmember/getArchiveData", this.user);
    },
    unarchiveMemberClick(row) {
      this.$confirm(
        "Are you sure you want to unarchive this member?",
        "Warning",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          if (row.archiveSchedule) {
            this.$store.dispatch("newmember/unArchiveScheduleMember", row.key);
          } else {
            this.$store.dispatch("newmember/unArchiveMember", row.key);
          }

          this.cancelAdd();
          this.cancelAddArchive();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Account Unarchived",
          });
        })
        // .then(() => {
        //   this.$store.dispatch("newteam/getTeams", this.user);
        //   this.$store.dispatch("membermanager/getMemberManager", this.user);
        // })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Cancelled",
          });
        });
    },
    deleteArchiveMemberClick(id) {
      this.$confirm(
        "Are you sure you want to permanently delete this member?",
        "Warning",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$store.dispatch("newmember/deleteArchiveMember", id);
          this.cancelAdd();
          this.cancelAddArchive();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Account Deleted",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    unarchiveArrMemberClick() {
      let schedule = _.filter(
        this.checkedDataArchive,
        function (currentObject) {
          return currentObject.archiveSchedule;
        }
      );
      let nonSchedule = _.filter(
        this.checkedDataArchive,
        function (currentObject) {
          return !currentObject.archiveSchedule;
        }
      );

      this.$confirm(
        "Are you sure you want to unarchive this member?",
        "Confirm",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          if (nonSchedule) {
            this.$store.dispatch("newmember/unArchiveArrMember", nonSchedule);
          }
          if (schedule) {
            this.$store.dispatch(
              "newmember/unArchiveArrMemberSchedule",
              schedule
            );
          }

          this.cancelAdd();
          this.cancelAddArchive();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Account Unarchived",
          });
        })
        // .then(() => {
        //   this.$store.dispatch("newteam/getTeams", this.user);
        //   this.$store.dispatch("membermanager/getMemberManager", this.user);
        // })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    deleteArchiveArrMemberClick() {
      this.$confirm(
        "Are you sure you want to permanently delete this member?",
        "Warning",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$store.dispatch(
            "newmember/deleteArchiveArrMember",
            this.checkedDataArchive
          );
          this.cancelAdd();
          this.cancelAddArchive();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Member account deleted",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    deleteArchiveAllClick() {
      if (this.membersArchiveAll && this.membersArchiveAll.length > 0) {
        this.$confirm(
          "Are you sure you want to delete all archived members?",
          "Warning",
          {
            confirmButtonText: "Yes, confirm",
            cancelButtonText: "Cancel",
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            this.$store.dispatch("newmember/deleteAllArchiveMember");
            this.cancelAdd();
            this.cancelAddArchive();
          })
          .then(() => {
            this.$message({
              type: "success",
              message: "Member accounts deleted",
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Canceled",
            });
          });
      }
    },
    loadMoreData() {
      this.$store.dispatch("newmember/getDailyStatus", this.validateForm);
    },
    setBarWidth(value, max) {
      let percentage = (value / max) * 100;
      let width = (450 / 100) * percentage;
      return width || "0";
    },
    cancelSchedule() {
      this.$confirm(
        "Would you like to cancel the scheduled archive process for this member?",
        "Are you sure?",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$store.dispatch("newmember/unArchiveScheduleMember", this.id);
          this.dialogFormVisible = false;
          this.cancelAdd();
          this.cancelAddArchive();
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "The scheduled archive process has been canceled.",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Cancelled",
          });
        });
    },
    datePickerUpdateTime() {
      const date = new Date();
      let hour = date.getHours();
      let minute = date.getMinutes() + 3;
      if (minute > 60) {
        minute = "03";
        hour = hour + 1;
      }
      this.pickerOptions.selectableRange = `${hour}:${minute}:00 - 23:59:00`;
    },
    checkNowPicker() {
      this.datePickerUpdateTime();
    },
    selectArchivedType(value, type) {
      // console.log("TODO: set type =>ssss ", value);
      this.$store
        .dispatch("newmember/updateArchiveTypeMember", {
          id: value.user.key,
          type: value.type,
        })
        .then(() => {
          value.user.archive_type = value.type;
        });
    },
    handleArchivedType(value) {
      value.item.archived_type = value.type;
    },
    handleArchiveButtonClick() {
      this.$message({
        message: 'Please select a reason from the dropdown menu',
        type: 'warning',
        duration: 3000,
        showClose: false
      });
    },
    handleMouseLeave() {
      setTimeout(() => {
        this.showMenu = false
      }, 200) // เพิ่ม delay เล็กน้อยเพื่อให้สามารถเลื่อนเมาส์ไปที่เมนูได้
    },
    handleSelect(index) {
      if (index === "import_members") {
        this.importMembers();
      } else if (index === "add_member") {
        this.addMember();
      }
      this.showMenu = false
    }
  },
};
</script>
<style lang="scss" scoped>
/* Inline Team Editing Styles */
.inline-team-clickable {
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  display: inline-block;
  
  &:hover {
    background-color: rgba(50, 194, 213, 0.1);
  }
}

.inline-team-new-hint {
  font-size: 12px;
  color: #32C2D5;
  margin-top: 8px;
  display: flex;
  align-items: center;
}

.house-assignment-hint {
  font-size: 12px;
  color: #8B6914;
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  word-break: normal;
  
  i {
    font-size: 14px;
  }
}

.advanced-info-header {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 0;
  border-top: 1px solid #EBEEF5;
}

.house-option-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #2d2e36;
  font-size: 14px;
}

.house-option-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.inline-team-validation {
  font-size: 12px;
  color: #f56c6c;
  margin-top: 8px;
}

#tabMembers >>> .divContentProfileModal {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.text-archived {
  font-size: 14px;
  color: #747474;
  margin-right: 24px;
  text-decoration: underline;
  cursor: pointer;
}
.txtArchivedModal {
  font-size: 16px;
  color: #494949;
  text-decoration: underline;
  cursor: pointer;
  padding-bottom: 32px;
}
.cancel-achive-box {
  border-radius: 0.3rem;
  background-color: #ea183c;
  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  padding: 16px 30px;
  .link {
    font-weight: 400;
    text-decoration: underline;
    cursor: pointer;
  }
}
.btnAddMember {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
}
.btnAddMember:hover {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
  opacity: 0.8;
}
.btnDeleteMember {
  background-color: #f44336;
  border-color: #f44336;
  color: #ffffff;
  height: 30px;
}
.btnDeleteMember:hover {
  background-color: #f44336;
  border-color: #f44336;
  color: #ffffff;
  opacity: 0.8;
}
.btnExportAll {
  background-color: #e0e0e0;
  border-color: #e0e0e0;
  color: #747474;
}
.btnExportAll:hover {
  background-color: #e0e0e0;
  border-color: #e0e0e0;
  color: #747474;
  opacity: 0.6;
}
.btnExportContext {
  background-color: #6C30CC;
  border-color: #6C30CC;
  color: #ffffff;
}
.btnExportContext:hover {
  background-color: #5B28B8;
  border-color: #5B28B8;
  color: #ffffff;
  opacity: 0.9;
}
.el-submenu {
  width: 220px;
}
.divActionHeader {
  margin-right: 30px;
  display: flex;
  flex: 1;
  justify-content: flex-end;
}
.viewMember {
  border: 1px solid #c4c4c4;
}
.selectionmenu .viewMember {
  border: 1px solid rgb(108, 48, 204);
}
.phase-header {
  width: 200px;
  height: 200px;
  background: #222222;
}
.el-dropdown-menu__item {
  font-size: 14px;
  font-weight: 500;
  color: #585858;
}
li.el-dropdown-menu__item:hover {
  background-color: #6c30cc;
  color: #ffffff;
}
div.el-dropdown {
  padding-left: 0px;
}
.second-column {
  background-color: #f8f8f8;
  height: 84vh;
  min-height: 847px;
  max-height: 1200px;
}
.txtHeaderStyle {
  margin: 0px;
  padding-bottom: 8px;
  font-size: 16px;
  color: #2d2e36;
  font-weight: 700;
}
.btnArchiveModal {
  background-color: #f44336;
  border-color: #f44336;
  color: #ffffff;
  width: 155px;
  height: 50px;
  font-size: 15px;
  font-weight: 700;
}
.btnArchiveModal:hover {
  background-color: #f44336;
  border-color: #f44336;
  color: #ffffff;
  opacity: 0.6;
}
.btnAddMemberModal {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
  width: 176px;
  height: 50px;
  font-size: 15px;
  font-weight: 700;
}
.btnAddMemberModal:hover {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
  opacity: 0.6;
}
.btnInviteMemberModal {
  width: 176px;
  height: 50px;
  font-size: 15px;
  font-weight: 700;
}
.btnCancelArchiveModal {
  width: 122px;
  height: 50px;
  font-size: 15px;
  font-weight: 700;
}
.bg-hover-barken-54279B {
  background-color: #54279b;
  color: #fff;
}
.bg-hover-barken-54279B:hover {
  background-color: #3f1e74;
}
.second-column-modal {
  padding: 40px;
  height: 100%;
  .btn {
    padding: 16px 32px;
    color: #fff;
    font-weight: 700;
    &:hover {
      opacity: 0.7;
    }
  }
  .secondary {
    background-color: #d1d1d1;
  }
  .primary {
    background-color: #32c2d5;
  }
  > .grid-2 {
    display: grid;
    grid-template-columns: 340px 340px;
    grid-gap: 20px;
    width: 100%;
    > .card {
      transition: 0.3s;
      padding: 24px;
      background-color: #f7f7f7;
      border: 1px solid #f7f7f7;
    }
    .active-card {
      background-color: #e8e8e8;
      border: 1px solid #c7c7c7;
    }
  }
}
.height-bind {
  margin-top: -10px;
  height: 52px;
}
.text-link {
  color: skyblue;
  cursor: pointer;
  text-decoration: underline;
}
.modal-edit-team {
  grid-template-columns: 320px auto;
  border-radius: 2px 0 0 2px;
  > .member-selected {
    width: calc(320px - (40px + 30px));
    padding: 40px;
    padding-right: 30px;
    background-color: #f8f8f8;
  }
}
.modal-2-column {
  display: grid;
  height: 100%;
}
#reAssignManagerModal {
  .first-column-modal {
    padding: 40px;
    padding-right: 30px;
    background-color: #f8f8f8;
    height: 100%;
  }
  .second-column-modal {
    padding: 40px;
    height: 100%;
  }
  .second-column-modal .btn {
    padding: 16px 32px;
    color: #fff;
    font-weight: 700;
  }
  .second-column-modal .btn:hover {
    opacity: 0.7;
  }
  .second-column-modal .secondary {
    background-color: #d1d1d1;
  }
  .second-column-modal .primary {
    background-color: #32c2d5;
  }
  .second-column-modal > .grid-2 {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 20px;
    width: 100%;
  }
  .second-column-modal > .grid-2 > .card {
    transition: 0.3s;
    padding: 24px;
    background-color: #f7f7f7;
    border: 1px solid #f7f7f7;
  }
  .second-column-modal > .grid-2 > .active-card {
    background-color: #e8e8e8;
    border: 1px solid #c7c7c7;
  }
}
.btn-archive {
  background-color: #f44336;
  height: 50px;
  border-radius: 3px;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  width: 155px;
}

@keyframes memberskeleton {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.loading-member-table {
  opacity: 1;
  animation-name: memberskeleton;
  transition: 0.3s;
  animation-duration: 3s;
}
.el-table__body-wrapper.is-scrolling-none {
  min-height: 930px;
}

/* Review Updates Card Layout */
.review-cards-header {
  padding: 12px 16px;
  background: #fafafa;
  border-radius: 8px 8px 0 0;
  border: 1px solid #ebeef5;
  border-bottom: none;
}

.review-cards-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.review-card {
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 16px 20px;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: #c0c4cc;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
}

.review-card-selected {
  border-color: #6c30cc;
  background: rgba(108, 48, 204, 0.02);
  box-shadow: 0 0 0 1px rgba(108, 48, 204, 0.2);
}

.review-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.review-card-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.review-card-checkbox {
  margin-right: 4px;
}

.review-card-avatar {
  flex-shrink: 0;
}

.review-card-member-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.review-card-name {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.review-card-email {
  font-size: 13px;
  color: #909399;
}

.review-card-header-center {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  padding: 0 16px;
  border-right: 1px solid #f0f0f0;
  margin-right: 16px;
}

.review-card-header-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  flex-shrink: 0;
}

.review-card-requested-label {
  font-size: 10px;
  color: #b0b0b0;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.review-card-requester-name {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
  white-space: nowrap;
}

.review-card-requester-team {
  font-size: 11px;
  color: #909399;
  white-space: nowrap;
}

/* Team hierarchy hover styles */
.review-card-original-hoverable {
  cursor: help;
  border-bottom: 1px dashed #c0c4cc;
}

.review-card-original-hoverable:hover {
  background: #e8e8e8;
}

.review-card-team-hoverable {
  cursor: help;
  border-bottom: 1px dashed #c0c4cc;
  transition: background-color 0.15s;
}

.review-card-team-hoverable:hover {
  background: rgba(108, 48, 204, 0.08);
}

/* Team option in dropdown */
.team-option-item {
  line-height: 1.3;
  padding: 2px 0;
}

.team-option-name {
  font-size: 13px;
  color: #303133;
}

.team-option-parent {
  font-size: 11px;
  color: #909399;
  margin-top: 2px;
}

.review-card-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.review-card-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.review-card-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.review-card-label {
  font-size: 12px;
  font-weight: 500;
  color: #909399;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.review-card-select {
  width: 100%;
}

.review-card-static-value {
  font-size: 14px;
  color: #606266;
  padding: 8px 0;
}

.review-card-manager-team {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

/* Original and New value wrappers for manager field */
.review-card-original-wrapper {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.review-card-original-subtext {
  font-size: 11px;
  color: #b0b0b0;
  padding-left: 10px;
}

.review-card-new-wrapper {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 140px;
}

.review-card-new-subtext {
  font-size: 11px;
  color: #909399;
  padding-left: 12px;
}

/* Before → After Comparison Styles */
.review-card-comparison {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.review-card-original {
  font-size: 13px;
  color: #909399;
  background: #f5f5f5;
  padding: 6px 10px;
  border-radius: 4px;
  white-space: nowrap;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.review-card-arrow {
  font-size: 16px;
  color: #6c30cc;
  font-weight: 600;
  flex-shrink: 0;
}

.review-card-select-inline {
  flex: 1;
  min-width: 140px;
}

.review-card-select-sm {
  min-width: 100px;
  max-width: 120px;
}

.review-card-dropdown-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  transition: border-color 0.2s;
  
  &:hover {
    border-color: #c0c4cc;
  }
  
  i {
    font-size: 12px;
    color: #909399;
  }
}

.review-cards-empty {
  text-align: center;
  padding: 60px 20px;
  color: #909399;
  font-size: 14px;
  background: #fafafa;
  border-radius: 8px;
  border: 1px dashed #e4e7ed;
}

/* Responsive adjustments for smaller screens */
@media (max-width: 768px) {
  .review-card-row {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .review-card-header {
    flex-direction: column;
    gap: 12px;
  }
  
  .review-card-header-right {
    align-items: flex-start;
    width: 100%;
  }
}
</style>
<style lang="scss">
/* Team Hierarchy Popover Styles */
.team-hierarchy-popover {
  padding: 12px 16px !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12) !important;
  max-width: 280px;
}

.team-hierarchy-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.team-hierarchy-current {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.team-hierarchy-current .team-hierarchy-name {
  font-weight: 600;
  color: #303133;
}

.team-hierarchy-parent,
.team-hierarchy-children {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.team-hierarchy-label {
  font-size: 10px;
  color: #909399;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.team-hierarchy-name {
  font-size: 13px;
  color: #606266;
}

.team-hierarchy-child {
  font-size: 12px;
  color: #606266;
  padding-left: 12px;
  position: relative;
  
  &::before {
    content: '•';
    position: absolute;
    left: 4px;
    color: #c0c4cc;
  }
}

.team-hierarchy-more {
  font-size: 11px;
  color: #909399;
  font-style: italic;
  padding-left: 12px;
}

/* Inline Team Popover Global Styles */
.inline-team-popover {
  padding: 0 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
}

.inline-team-popover-content {
  padding: 16px;
}

.inline-team-popover-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.inline-team-popover-title {
  font-size: 14px;
  font-weight: 600;
  color: #2D2E36;
}

.inline-team-popover-actions {
  display: flex;
  gap: 8px;
}

.inline-team-action-btn {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}

.inline-team-confirm-btn {
  background-color: #E8F8F5;
  color: #27AE60;
  
  &:hover:not(:disabled) {
    background-color: #27AE60;
    color: white;
  }
}

.inline-team-cancel-btn {
  background-color: #FDEDEC;
  color: #E74C3C;
  
  &:hover {
    background-color: #E74C3C;
    color: white;
  }
}

.inline-team-autocomplete-popover {
  width: 100%;
  
  .el-input__inner {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-color: #E0E0E0;
    border-radius: 6px;
    
    &:focus {
      border-color: #32C2D5;
    }
  }
}

.inline-team-suggestion-item {
  display: flex;
  align-items: center;
  padding: 8px 4px;
  margin: 0 -8px;
  border-radius: 6px;
  font-size: 14px;
  color: #2D2E36;
}

.inline-team-color-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 12px;
  flex-shrink: 0;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

/* Inline Manager Suggestion Styles */
.inline-manager-suggestion-item {
  display: flex;
  align-items: center;
  padding: 8px 4px;
  margin: 0 -8px;
  border-radius: 6px;
  transition: background-color 0.15s ease;
}

.inline-manager-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 12px;
  flex-shrink: 0;
  object-fit: cover;
  border: 2px solid #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.inline-manager-avatar-placeholder {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 12px;
  flex-shrink: 0;
  background: linear-gradient(135deg, #E8E8E8 0%, #D0D0D0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  border: 2px solid #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.inline-manager-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}

.inline-manager-name {
  font-size: 14px;
  font-weight: 600;
  color: #2D2E36;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}

.inline-manager-team {
  font-size: 12px;
  color: #9D9D9D;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
  margin-top: 2px;
}

/* Autocomplete Dropdown Popper Styles */
.el-autocomplete-suggestion {
  border-radius: 8px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid #E8E8E8 !important;
  margin-top: 4px !important;
}

.el-autocomplete-suggestion li {
  padding: 8px 12px !important;
  line-height: normal !important;
}

.el-autocomplete-suggestion li:hover,
.el-autocomplete-suggestion li.highlighted {
  background-color: #F5F9FA !important;
}

.el-autocomplete-suggestion__wrap {
  max-height: 280px !important;
  padding: 6px 0 !important;
}

.hide-btn-picker-time {
  .el-picker-panel__footer {
    .el-picker-panel__link-btn {
      &:first-child {
        display: none;
      }
      &:last-child {
        display: inline-block;
      }
    }
  }
}
#tabMembers .el-submenu__title {
  height: 40px;
  line-height: 40px;
  background-color: #f4f4f4;
}
#tabMembers .el-checkbox__inner {
  width: 24px;
  height: 24px;
  border: 1px solid #c6c6c6;
}
#tabMembers .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #5423a2;
  border: 1px solid #5423a2;
}
#tabMembers .el-table th > .cell {
  font-weight: 700;
}
#tabMembers .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #f5f5f5;
}
#tabMembers .el-table__row {
  cursor: pointer;
}
#tabMembers span.el-checkbox__inner::after {
  border: 3px solid #fff;
  border-left: 0;
  border-top: 0;
  top: 2px;
  left: 7px;
  width: 5px;
  height: 13px;
}
#tabMembers label.el-checkbox {
  line-height: 24px;
}
#tabMembers .el-checkbox__input {
  zoom: 1 !important;
}
#tabMembers .el-dialog {
  width: 1100px;
}
#archiveMember .el-dialog__header,
#tabMembers .el-dialog__header {
  padding: 0px;
}
#archiveMember {
  .el-dialog__body {
    background-color: #f8f8f8;
  }
  .btn-archive {
    background-color: #f44336;
    height: 50px;
    border-radius: 3px;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    width: 360px;
    margin: auto;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 360px;
  }
}
#tabMembers .el-dialog__body {
  padding: 0px;
  height: 84vh;
  min-height: 847px;
  max-height: 1200px;
}
#reviewUpdatesModal .el-dialog__body{
  height: auto;
  > div {
    padding: 40px 15px 40px 40px;
  }
}
#tabHeaderStyle .el-tabs__header {
  margin: 0 0 4px;
}
#tabMembers .el-table .cell {
  line-height: 20px;
}
#tabMembers .el-dialog__headerbtn {
  font-size: 26px;
}
#tabMembers .profileform .el-input__inner {
  height: 46px;
  line-height: 46px;
  font-size: 17px;
  border: none;
  padding: 0 32px;
}
#tabMembers .profileform .el-input-group__prepend {
  border: none;
  background: #ffffff;
}
#tabMembers .profileform .managerfield .el-input__inner {
  height: 80px;
  padding: 0 16px 16px 42px;
}
#tabMembers .profileform .teamfield .el-input__inner {
  height: 60px;
  background: #e4e4e4;
  border-left-width: 7px;
  border-left-style: solid;
  /* border-left-color: #6c30cc; */
  padding: 0 32px;
}
#tabMembers .profileform .managerfield .el-input-group__prepend {
  width: 0;
  padding: 0;
}
#tabMembers .profileform .rolefield .el-input__inner,
#tabMembers .profileform .langfield .el-input__inner {
  height: 42px;
}
#tabMembers .profileform .el-input.is-disabled .el-input__inner {
  background-color: #eee;
  border-color: #eee;
  color: #888;
}
#membersContainer #tabMembers .el-tabs__item.is-active,
#membersContainer #tabMembers .el-tabs__item {
  font-size: 16px;
  height: 44px;
}
#membersContainer #tabMembers #modal_profile .el-tabs__item {
  width: 200px;
}
#tabMembers .profileform .border-left-color- .el-input__inner {
  border-left-color: #747474;
}
#tabMembers .el-table td {
  padding: 12px 0;
}
#tabMembers .profileform .border-left-color-6C30CC .el-input__inner {
  border-left-color: #6c30cc;
}
#tabMembers .profileform .border-left-color-4F86C6 .el-input__inner {
  border-left-color: #4f86c6;
}
#tabMembers .profileform .border-left-color-50B0C6 .el-input__inner {
  border-left-color: #50b0c6;
}
#tabMembers .profileform .border-left-color-379392 .el-input__inner {
  border-left-color: #379392;
}
#tabMembers .profileform .border-left-color-68D5B5 .el-input__inner {
  border-left-color: #68d5b5;
}
#tabMembers .profileform .border-left-color-EE7885 .el-input__inner {
  border-left-color: #ee7885;
}
#tabMembers .profileform .border-left-color-C99EC4 .el-input__inner {
  border-left-color: #c99ec4;
}
#tabMembers .profileform .border-left-color-84B1ED .el-input__inner {
  border-left-color: #84b1ed;
}
#tabMembers .profileform .border-left-color-31AADE .el-input__inner {
  border-left-color: #31aade;
}
#tabMembers .profileform .border-left-color-F0DC05 .el-input__inner {
  border-left-color: #f0dc05;
}
#tabMembers .profileform .border-left-color-E63A40 .el-input__inner {
  border-left-color: #e63a40;
}
#archivedModal .attrition-chart-container {
  border-radius: 24px;
  background-color: rgba(108, 48, 204, 0.05);
}
#archivedModal .text-link {
  color: #6C30CC;
}
#archivedModal .text-link.red{
  color: #e63a40;
}
#tabMembers .send-style {
  span.el-checkbox__inner::after {
    left: 5px;
    top: 0px;
    width: 3px;
    height: 9px;
  }
  .el-checkbox__inner {
    width: 18px;
    height: 18px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #32c2d5;
    border: 1px solid #32c2d5;
  }
  .el-checkbox__input + .el-checkbox__label,
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #2d2e36;
    font-size: 13px;
    font-weight: 400;
  }
}

.happily-primary.el-badge-unread > .el-badge__content {
  background-color: #E45006;
  line-height: 14px;
  height: 14px;
  min-width: 14px;
  padding: 4px;
  margin: 0;
  border-radius: 50%;
}

#reviewUpdatesTable.el-table td:last-child .cell {
  position: relative;
  top: 6px;
}
.requested_by {
  display: inline-block;
  width: 120px;
  text-align: left;
  line-height: 12px;
  padding-top: 4px;
}
.dropdown-container {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  margin-top: 5px;
  .el-menu-item {
    font-size: 14px;
    width: 100%;
    background-color: #FFFFFF;
    float: none;
    height: 36px;
    line-height: 36px;
    padding: 0 10px;
    color: #303133;
    &.is-active {
      border-bottom: 0;
    }
  }
}
#importMembersModal {
  .el-dialog {
    max-height: calc(100vh - 8vh - 50px);
  }
  .import-members-radio-group {
    margin-top: 23px;
  }
  /* radio */
  .el-radio-group .el-radio {
    .el-radio__inner {
      width: 24px;
      height: 24px;
    }
    .el-radio__input.is-checked {
      .el-radio__inner {
        border-color: #6c30cc;
        background: #6c30cc;
      }
    }
  }
  .el-radio-group {
    display: flex;
    flex-direction: row;
    gap: 16px;
  }
  .radio-item-wrapper {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 12px;
    > a {
      font-size: 13px;
      color: #6C30CC;
      text-decoration: none;
      margin: 12px 0 0 10px;
    }
  }
  .radio-item {
    width: 251px;
    height: 100px;
    border: 1px solid #E0E0E0;
    border-radius: 15px;
    padding: 24px;
    display: block;
    &.active {
      border: 1px solid #6C30CC;
      background-color: #f9f4fd;
    }
    > div {
      font-size: 13px;
      line-height: 16px;
      margin-top: 6px;
      &.description {
        opacity: 0.6;
      }
    }
    > div:first-child {
      display: flex;
      flex-direction: row;
      margin-top: 0;
      > * {
        display: flex;
      }
    }
  }
  .el-radio__label {
    display: none;
  }
  /* upload file */
  .custom-upload {
    margin-top: 17px;
  }
  .el-upload-dragger {
    border: 1px solid #6C30CC;
    width: 1020px;
    height: 260px;
    .el-upload__text em {
      color: #6C30CC;
    }
  }
  .el-upload__tip {
    font-size: 13px;
  }
  /* text area */
  .custom-textarea {
    margin-top: 17px;
    > textarea {
      width: 100%;
      height: 210px;
      border-radius: 15px;
      padding: 24px 16px;
    }
  }
}

/* Archived Member Happiness Tooltip Styles */
.archived-happiness-tooltip {
  max-width: 480px !important;
  width: 460px !important;
  min-height: 450px !important;
  max-height: 70vh !important;
  padding: 0 !important;
  border-radius: 12px !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
  background: #fff !important;
  border: 1px solid #e8e8e8 !important;
  z-index: 9999 !important;
  overflow-y: auto !important;
  
  /* Consistent positioning */
  transform-origin: left center !important;
}

/* Right placement specific styling */
.archived-happiness-tooltip[x-placement^="right"] {
  margin-left: 15px !important;
}

/* Loading state should maintain tooltip size */
.happiness-loading {
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
  min-height: 410px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

/* Error state should also maintain tooltip size */
.happiness-error {
  padding: 20px;
  text-align: center;
  color: #f56c6c;
  font-size: 14px;
  min-height: 410px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Responsive adjustments for smaller screens */
@media (max-height: 800px) {
  .archived-happiness-tooltip {
    max-width: 350px !important;
  }
  
  .timeline-month {
    padding: 6px !important;
  }
  
  .month-grid {
    gap: 1px !important;
  }
  
  .timeline-day {
    width: 20px !important;
    height: 20px !important;
    font-size: 9px !important;
  }
}

.happiness-loading {
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
}

.happiness-error {
  padding: 20px;
  text-align: center;
  color: #f56c6c;
  font-size: 14px;
}

.happiness-tooltip-content {
  padding: 20px;
  min-height: 410px !important;
  max-height: 70vh;
  overflow-y: auto;
}

/* Custom scrollbar for tooltip content */
.happiness-tooltip-content::-webkit-scrollbar {
  width: 6px;
}

.happiness-tooltip-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.happiness-tooltip-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.happiness-tooltip-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.happiness-tooltip-header {
  margin-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 12px;
}

.tooltip-title {
  font-size: 16px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 4px;
}

.tooltip-subtitle {
  font-size: 12px;
  color: #909399;
}

.happiness-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 20px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

.stat-label {
  color: #606266;
}

.stat-value {
  color: #303133;
  font-weight: 600;
}

.stat-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.stat-dot.green {
  background-color: #4CAF50;
}

.stat-dot.yellow {
  background-color: #FFC107;
}

.stat-dot.red {
  background-color: #F44336;
}

.happiness-timeline {
  margin-top: 16px;
}

.timeline-label {
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
}

.timeline-months {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
}

.timeline-month {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 8px;
  background-color: #fafafa;
}

.month-label {
  font-size: 12px;
  font-weight: 600;
  color: #606266;
  margin-bottom: 6px;
}

.month-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}

.timeline-day {
  width: 24px;
  height: 24px;
  border-radius: 3px;
  cursor: pointer;
  transition: transform 0.2s ease;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #fff;
}

.timeline-day .day-number {
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.timeline-day:hover {
  transform: scale(1.3);
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.timeline-day.no-response {
  background-color: #DCDFE6;
}

.timeline-day.no-response .day-number {
  color: #909399;
  text-shadow: none;
}

.timeline-day.green {
  background-color: #4CAF50;
}

.timeline-day.yellow {
  background-color: #FFC107;
}

.timeline-day.yellow .day-number {
  color: #333;
  text-shadow: none;
}

.timeline-day.red {
  background-color: #F44336;
}

.timeline-day.archive-date {
  border: 2px solid #6C30CC;
  box-shadow: 0 0 0 1px #fff;
}

.archive-marker {
  position: absolute;
  top: -10px;
  right: -8px;
  font-size: 14px;
  z-index: 20;
  background: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.timeline-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 12px;
  color: #606266;
  margin-top: 8px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  display: inline-block;
}

.legend-dot.no-response {
  background-color: #DCDFE6;
}

.legend-dot.green {
  background-color: #4CAF50;
}

.legend-dot.yellow {
  background-color: #FFC107;
}

.legend-dot.red {
  background-color: #F44336;
}

/* Risk Assessment Section Styles */
.risk-assessment-section,
.risk-unavailable-section {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.risk-header {
  margin-bottom: 12px;
}

.risk-title {
  font-size: 14px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 2px;
}

.risk-subtitle {
  font-size: 11px;
  color: #909399;
}

.latest-risk {
  background-color: #f8f9fa;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 12px;
}

.latest-risk-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.risk-indicator {
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  color: #fff;
}

.risk-indicator.recovery {
  background-color: #4CAF50;
}

.risk-indicator.low-risk {
  background-color: #FFC107;
  color: #333;
}

.risk-indicator.medium-risk {
  background-color: #FF9800;
}

.risk-indicator.high-risk {
  background-color: #F44336;
}

.risk-indicator.no-risk {
  background-color: #E9ECEF;
  color: #6C757D;
}

/* Archive Member Hover Indicator Styles */
.archive-member-hover {
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 6px 8px;
  border-radius: 6px;
  position: relative;
  
  &:hover {
    background-color: rgba(108, 48, 204, 0.08);
    box-shadow: 0 2px 8px rgba(108, 48, 204, 0.1);
  }
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 0;
    background-color: #6C30CC;
    border-radius: 2px;
    transition: height 0.2s ease;
  }
  
  &:hover::before {
    height: 60%;
  }
}

.member-name-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.happiness-indicators {
  display: flex;
  align-items: center;
  gap: 4px;
  opacity: 0.8;
  transition: all 0.2s ease;
  margin-left: 8px;
  padding: 4px 6px;
  border-radius: 4px;
  background-color: rgba(108, 48, 204, 0.08);
}

.archive-happiness-indicator {
  color: #7C4DFF;
  font-size: 16px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.archive-member-hover:hover .happiness-indicators {
  opacity: 1;
  background-color: rgba(124, 77, 255, 0.12);
  transform: translateX(-1px);
}

.archive-member-hover:hover .archive-happiness-indicator {
  color: #673AB7;
  transform: scale(1.1);
}

.happiness-indicators:hover {
  background-color: rgba(124, 77, 255, 0.15);
}

.happiness-indicators:hover .archive-happiness-indicator {
  color: #5E35B1;
  transform: scale(1.15);
}

.latest-label {
  font-size: 11px;
  color: #666;
}

.risk-description {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

.risk-stats .stat-dot.recovery {
  background-color: #4CAF50;
}

.risk-stats .stat-dot.low-risk {
  background-color: #FFC107;
}

.risk-stats .stat-dot.medium-risk {
  background-color: #FF9800;
}

.risk-stats .stat-dot.high-risk {
  background-color: #F44336;
}

.risk-timeline {
  margin-top: 12px;
}

.risk-timeline-entries {
  max-height: 120px;
  overflow-y: auto;
}

.risk-timeline-entry {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 11px;
}

.risk-date {
  color: #666;
  font-family: monospace;
}

.risk-level-badge {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 8px;
  color: #fff;
}

.risk-level-badge.recovery {
  background-color: #4CAF50;
}

.risk-level-badge.low-risk {
  background-color: #FFC107;
  color: #333;
}

.risk-level-badge.medium-risk {
  background-color: #FF9800;
}

.risk-level-badge.high-risk {
  background-color: #F44336;
}

.risk-level-badge.no-risk {
  background-color: #E9ECEF;
  color: #6C757D;
}

.more-entries {
  font-size: 10px;
  color: #999;
  font-style: italic;
  text-align: center;
  margin-top: 4px;
}

.no-risk-data {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 6px;
  font-size: 12px;
  color: #666;
}

.no-risk-icon {
  font-size: 16px;
}

/* Archive Modal Layout Fixes */
#archivedModal {
  .el-dialog {
    max-height: 94vh !important;
    overflow: hidden !important;
    margin: 0 auto !important;
  }
  
  .el-dialog__body {
    max-height: calc(94vh - 60px) !important;
    overflow-y: auto !important;
    padding: 0 !important;
  }
  
  /* Chart container responsive sizing */
  .attrition-chart-container {
    max-height: 250px;
    overflow: hidden;
  }

  /* Table should display fully without internal scrolling */
  .el-table {
    height: auto !important;
    max-height: none !important;
  }

  .el-table__body-wrapper {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
  }

  /* Responsive padding for smaller screens */
  @media (max-width: 1200px) {
    .p-40 {
      padding: 20px !important;
    }
  }
  
  @media (max-height: 800px) {
    .el-dialog {
      max-height: 95vh !important;
    }

    .el-dialog__body {
      max-height: calc(95vh - 60px) !important;
    }

    .attrition-chart-container {
      max-height: 180px;
    }
  }
}

/* Risk Flags Styling */
.risk-flags-summary {
  margin-top: 16px;
  padding: 12px;
  background-color: #fff8f6;
  border-left: 3px solid #f44336;
  border-radius: 4px;
}

.risk-header {
  margin-bottom: 8px;
  
  .risk-title {
    font-size: 12px;
    font-weight: 700;
    color: #d32f2f;
    margin-bottom: 2px;
  }
  
  .risk-subtitle {
    font-size: 10px;
    color: #666;
  }
}

.risk-flags-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.risk-flag-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  
  .risk-flag-date {
    font-weight: 600;
    color: #333;
    min-width: 60px;
  }
  
  .risk-flag-level {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    font-size: 8px;
    font-weight: 700;
    color: white;
    
    &.risk-level-1 {
      background-color: #ff9800;
    }
    
    &.risk-level-2 {
      background-color: #ff5722;
    }
    
    &.risk-level-3 {
      background-color: #d32f2f;
    }
  }
  
  .risk-flag-content {
    flex: 1;
    color: #666;
    font-size: 9px;
  }
}

.more-flags {
  font-size: 9px;
  color: #999;
  font-style: italic;
  margin-top: 4px;
}

/* Recovery Flags Styling */
.recovery-flags-summary {
  margin-top: 16px;
  padding: 12px;
  background-color: #f1f8f4;
  border-left: 3px solid #4caf50;
  border-radius: 4px;
}

.recovery-header {
  margin-bottom: 8px;
  
  .recovery-title {
    font-size: 12px;
    font-weight: 700;
    color: #2e7d32;
    margin-bottom: 2px;
  }
  
  .recovery-subtitle {
    font-size: 10px;
    color: #666;
  }
}

.recovery-flags-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.recovery-flag-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  
  .recovery-flag-date {
    font-weight: 600;
    color: #333;
    min-width: 60px;
  }
  
  .recovery-flag-level {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    font-size: 8px;
    font-weight: 700;
    color: white;
    background-color: #4caf50;
    
    &.recovery {
      background-color: #4caf50;
    }
  }
  
  .recovery-flag-content {
    flex: 1;
    color: #666;
    font-size: 9px;
  }
}

/* Risk flag on timeline days */
.timeline-day {
  position: relative;
  
  .risk-flag {
    position: absolute;
    top: -4px;
    right: -4px;
    width: 16px;
    height: 16px;
    background-color: #d32f2f;
    color: white;
    border-radius: 50%;
    font-size: 9px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid white;
    box-shadow: 0 1px 3px rgba(0,0,0,0.3);
    z-index: 3;
  }
}

/* Compact table rows for Archive Modal */
#archivedModal {
  .el-table__row {
    height: 50px !important;
  }
  
  .el-table td {
    padding: 6px 0 !important;
  }
  
  .el-table__cell {
    padding: 6px 0 !important;
  }
  
  /* Simple fix for bottom cutoff */
  .pagination {
    margin-bottom: 20px !important;
  }
  
  /* Compact member info */
  .archive-member-hover {
    padding: 4px 6px;
    cursor: pointer;
    
    .member-name-row {
      margin-bottom: 2px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    
    .text-name {
      font-size: 14px;
      line-height: 1.2;
      color: #303133;
    }
    
    .text-email {
      font-size: 12px;
      line-height: 1.1;
      color: #909399;
    }
    
    .happiness-indicators {
      margin-left: 6px;
      padding: 3px 5px;
      
      .archive-happiness-indicator {
        font-size: 15px;
        color: #7C4DFF;
      }
    }
  }
  
  /* Compact profile images */
  .image-profile-42 {
    width: 36px !important;
    height: 36px !important;
  }
  
  .text-in-image-42 {
    font-size: 12px !important;
    width: 36px !important;
    height: 36px !important;
  }
  
  /* Compact checkbox column */
  .el-checkbox {
    margin: 0 !important;
  }
  
  /* Compact other text elements */
  .el-table .cell {
    line-height: 1.3 !important;
  }
  
  /* Make team names and other text more compact */
  .el-table__body .el-table__row .el-table__cell .cell {
    font-size: 13px;
  }
}

/* Archive Table Action Buttons */
.archive-action-link {
  color: #6C30CC;
  font-size: 12px;
  cursor: pointer;
  transition: color 0.15s ease;

  &:hover {
    color: #4a1a99;
    text-decoration: underline;
  }
}

.archive-delete-btn {
  color: #c0c4cc;
  font-size: 16px;
  cursor: pointer;
  transition: color 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #CC3030;
  }
}

/* Archive Detail Expandable Card */
.archive-detail-card {
  display: flex;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin: 8px 0;
  padding: 0;
  overflow: hidden;
}

.archive-detail-panel {
  flex: 1;
  padding: 16px 20px;
  min-width: 0;

  &:not(:last-child) {
    border-right: 1px solid #f0f0f0;
  }
}

.archive-detail-panel-center {
  flex: 1.5;
}

.panel-title {
  font-size: 13px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 14px;
  padding-bottom: 6px;
  border-bottom: 2px solid #6C30CC;
  display: inline-block;
}

.detail-section {
  margin-bottom: 14px;
}

.detail-label {
  font-size: 11px;
  font-weight: 600;
  color: #909399;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 6px;
}

.detail-empty {
  font-size: 12px;
  color: #c0c4cc;
  font-style: italic;
}

/* Unified pill/tag for table columns (Network + eNPS) */
.archive-pill {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
}

/* eNPS pill colors — light bg, dark text (consistent with network tags) */
.enps-promoter {
  background-color: rgba(58, 196, 125, 0.15);
  color: #1a7a42;
}

.enps-passive {
  background-color: rgba(247, 185, 36, 0.15);
  color: #7E6016;
}

.enps-detractor {
  background-color: rgba(204, 48, 48, 0.15);
  color: #9a1a1a;
}

/* eNPS badge in expandable detail card (larger) */
.enps-badge-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.enps-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 700;
}

.enps-score {
  font-size: 12px;
  color: #666;
}

/* Risk Count Bar */
.risk-count-total {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 6px;
}

.risk-count-bar {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.risk-segment {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  color: #fff;
}

.risk-segment.risk-high {
  background-color: #CC3030;
}

.risk-segment.risk-medium {
  background-color: #ff5722;
}

.risk-segment.risk-low {
  background-color: #ff9800;
  color: #333;
}

/* Activity Progress */
.activity-label {
  font-size: 12px;
  color: #303133;
  margin-bottom: 6px;
}

.activity-progress {
  height: 8px;
  background-color: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
}

.activity-bar {
  height: 100%;
  background-color: #6C30CC;
  border-radius: 4px;
  transition: width 0.3s ease;
}

/* Coins & Gems */
.coins-gems-row {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: #303133;
}

.coin-value, .gem-value {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
}

.coin-gem-icon {
  width: 18px;
  height: 18px;
}

/* Flag List in Right Panel */
.flag-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.flag-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
}

.flag-date {
  font-weight: 600;
  color: #333;
  min-width: 70px;
  font-family: monospace;
  font-size: 10px;
}

.flag-level {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 8px;
  font-weight: 700;
  color: #fff;

  &.recovery {
    background-color: #4caf50;
  }

  &.risk-level-1 {
    background-color: #ff9800;
  }

  &.risk-level-2 {
    background-color: #ff5722;
  }

  &.risk-level-3 {
    background-color: #d32f2f;
  }
}

.flag-content {
  flex: 1;
  color: #666;
  font-size: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Tag styles for Network Type */
.tag-red {
  background-color: rgba(244, 67, 54, 0.12);
  color: #7E120A;
}

.tag-half-red, .tag-orange {
  background-color: rgba(251, 192, 45, 0.12);
  color: #7E6016;
}

.tag-green, .tag-half-green {
  background-color: rgba(102, 187, 106, 0.12);
  color: #008406;
}

/* Happiness card content inside expand */
.happiness-card-content {
  .happiness-tooltip-header {
    margin-bottom: 10px;
  }

  .tooltip-subtitle {
    font-size: 11px;
    color: #909399;
  }

  .happiness-stats {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
    flex-wrap: wrap;
  }

  .stat-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
  }

  .stat-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;

    &.green { background-color: #3AC47D; }
    &.yellow { background-color: #F7B924; }
    &.red { background-color: #CC3030; }
  }

  .stat-label {
    color: #909399;
    font-size: 11px;
  }

  .stat-value {
    font-weight: 600;
    color: #303133;
    font-size: 11px;
  }

  .happiness-timeline {
    margin-top: 8px;
  }

  .timeline-label {
    font-size: 11px;
    color: #909399;
    margin-bottom: 6px;
  }

  .timeline-months {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .timeline-month {
    margin-bottom: 4px;
  }

  .month-label {
    font-size: 10px;
    font-weight: 600;
    color: #606266;
    margin-bottom: 3px;
  }

  .month-grid {
    display: flex;
    gap: 2px;
    flex-wrap: wrap;
  }

  .timeline-day {
    width: 18px;
    height: 18px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: default;

    &.green { background-color: #C8E6C9; }
    &.yellow { background-color: #FFF9C4; }
    &.red { background-color: #FFCDD2; }
    &.no-response { background-color: #f5f5f5; }
    &.archive-date { border: 2px solid #6C30CC; }
  }

  .day-number {
    font-size: 8px;
    color: #666;
  }

  .archive-marker {
    position: absolute;
    top: -6px;
    right: -6px;
    font-size: 8px;
    z-index: 2;
  }

  .timeline-legend {
    display: flex;
    gap: 10px;
    margin-top: 6px;
    font-size: 10px;
    color: #909399;
    flex-wrap: wrap;
  }

  .legend-item {
    display: flex;
    align-items: center;
    gap: 3px;
  }

  .legend-dot {
    width: 8px;
    height: 8px;
    border-radius: 2px;
    display: inline-block;

    &.green { background-color: #C8E6C9; }
    &.yellow { background-color: #FFF9C4; }
    &.red { background-color: #FFCDD2; }
    &.no-response { background-color: #f5f5f5; border: 1px solid #e0e0e0; }
  }
}

/* Loading & Error states for detail card */
.archive-detail-loading {
  padding: 24px;
  text-align: center;
  color: #909399;
  font-size: 13px;
}

.archive-detail-error {
  padding: 12px 20px;
  color: #CC3030;
  font-size: 12px;
}

</style>
